/*
Copyright 2012 Igor Vaynberg

Version: 3.5.2 Timestamp: Sat Nov  1 14:43:36 EDT 2014

This software is licensed under the Apache License, Version 2.0 (the "Apache License") or the GNU
General Public License version 2 (the "GPL License"). You may choose either license to govern your
use of this software only upon the condition that you accept all of the terms of either the Apache
License or the GPL License.

You may obtain a copy of the Apache License and the GPL License at:

    http://www.apache.org/licenses/LICENSE-2.0
    http://www.gnu.org/licenses/gpl-2.0.html

Unless required by applicable law or agreed to in writing, software distributed under the
Apache License or the GPL License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
CONDITIONS OF ANY KIND, either express or implied. See the Apache License and the GPL License for
the specific language governing permissions and limitations under the Apache License and the GPL License.
*/
(function ($) {
    if(typeof $.fn.each2 == "undefined") {
        $.extend($.fn, {
            /*
            * 4-10 times faster .each replacement
            * use it carefully, as it overrides jQuery context of element on each iteration
            */
            each2 : function (c) {
                var j = $([0]), i = -1, l = this.length;
                while (
                    ++i < l
                    && (j.context = j[0] = this[i])
                    && c.call(j[0], i, j) !== false //"this"=DOM, i=index, j=jQuery object
                );
                return this;
            }
        });
    }
})(jQuery);

(function ($, undefined) {
    "use strict";
    /*global document, window, jQuery, console */

    if (window.Select2 !== undefined) {
        return;
    }

    var AbstractSelect2, SingleSelect2, MultiSelect2, nextUid, sizer,
        lastMousePosition={x:0,y:0}, $document, scrollBarDimensions,

    KEY = {
        TAB: 9,
        ENTER: 13,
        ESC: 27,
        SPACE: 32,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40,
        SHIFT: 16,
        CTRL: 17,
        ALT: 18,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        HOME: 36,
        END: 35,
        BACKSPACE: 8,
        DELETE: 46,
        isArrow: function (k) {
            k = k.which ? k.which : k;
            switch (k) {
            case KEY.LEFT:
            case KEY.RIGHT:
            case KEY.UP:
            case KEY.DOWN:
                return true;
            }
            return false;
        },
        isControl: function (e) {
            var k = e.which;
            switch (k) {
            case KEY.SHIFT:
            case KEY.CTRL:
            case KEY.ALT:
                return true;
            }

            if (e.metaKey) return true;

            return false;
        },
        isFunctionKey: function (k) {
            k = k.which ? k.which : k;
            return k >= 112 && k <= 123;
        }
    },
    MEASURE_SCROLLBAR_TEMPLATE = "<div class='select2-measure-scrollbar'></div>",

    DIACRITICS = {"\u24B6":"A","\uFF21":"A","\u00C0":"A","\u00C1":"A","\u00C2":"A","\u1EA6":"A","\u1EA4":"A","\u1EAA":"A","\u1EA8":"A","\u00C3":"A","\u0100":"A","\u0102":"A","\u1EB0":"A","\u1EAE":"A","\u1EB4":"A","\u1EB2":"A","\u0226":"A","\u01E0":"A","\u00C4":"A","\u01DE":"A","\u1EA2":"A","\u00C5":"A","\u01FA":"A","\u01CD":"A","\u0200":"A","\u0202":"A","\u1EA0":"A","\u1EAC":"A","\u1EB6":"A","\u1E00":"A","\u0104":"A","\u023A":"A","\u2C6F":"A","\uA732":"AA","\u00C6":"AE","\u01FC":"AE","\u01E2":"AE","\uA734":"AO","\uA736":"AU","\uA738":"AV","\uA73A":"AV","\uA73C":"AY","\u24B7":"B","\uFF22":"B","\u1E02":"B","\u1E04":"B","\u1E06":"B","\u0243":"B","\u0182":"B","\u0181":"B","\u24B8":"C","\uFF23":"C","\u0106":"C","\u0108":"C","\u010A":"C","\u010C":"C","\u00C7":"C","\u1E08":"C","\u0187":"C","\u023B":"C","\uA73E":"C","\u24B9":"D","\uFF24":"D","\u1E0A":"D","\u010E":"D","\u1E0C":"D","\u1E10":"D","\u1E12":"D","\u1E0E":"D","\u0110":"D","\u018B":"D","\u018A":"D","\u0189":"D","\uA779":"D","\u01F1":"DZ","\u01C4":"DZ","\u01F2":"Dz","\u01C5":"Dz","\u24BA":"E","\uFF25":"E","\u00C8":"E","\u00C9":"E","\u00CA":"E","\u1EC0":"E","\u1EBE":"E","\u1EC4":"E","\u1EC2":"E","\u1EBC":"E","\u0112":"E","\u1E14":"E","\u1E16":"E","\u0114":"E","\u0116":"E","\u00CB":"E","\u1EBA":"E","\u011A":"E","\u0204":"E","\u0206":"E","\u1EB8":"E","\u1EC6":"E","\u0228":"E","\u1E1C":"E","\u0118":"E","\u1E18":"E","\u1E1A":"E","\u0190":"E","\u018E":"E","\u24BB":"F","\uFF26":"F","\u1E1E":"F","\u0191":"F","\uA77B":"F","\u24BC":"G","\uFF27":"G","\u01F4":"G","\u011C":"G","\u1E20":"G","\u011E":"G","\u0120":"G","\u01E6":"G","\u0122":"G","\u01E4":"G","\u0193":"G","\uA7A0":"G","\uA77D":"G","\uA77E":"G","\u24BD":"H","\uFF28":"H","\u0124":"H","\u1E22":"H","\u1E26":"H","\u021E":"H","\u1E24":"H","\u1E28":"H","\u1E2A":"H","\u0126":"H","\u2C67":"H","\u2C75":"H","\uA78D":"H","\u24BE":"I","\uFF29":"I","\u00CC":"I","\u00CD":"I","\u00CE":"I","\u0128":"I","\u012A":"I","\u012C":"I","\u0130":"I","\u00CF":"I","\u1E2E":"I","\u1EC8":"I","\u01CF":"I","\u0208":"I","\u020A":"I","\u1ECA":"I","\u012E":"I","\u1E2C":"I","\u0197":"I","\u24BF":"J","\uFF2A":"J","\u0134":"J","\u0248":"J","\u24C0":"K","\uFF2B":"K","\u1E30":"K","\u01E8":"K","\u1E32":"K","\u0136":"K","\u1E34":"K","\u0198":"K","\u2C69":"K","\uA740":"K","\uA742":"K","\uA744":"K","\uA7A2":"K","\u24C1":"L","\uFF2C":"L","\u013F":"L","\u0139":"L","\u013D":"L","\u1E36":"L","\u1E38":"L","\u013B":"L","\u1E3C":"L","\u1E3A":"L","\u0141":"L","\u023D":"L","\u2C62":"L","\u2C60":"L","\uA748":"L","\uA746":"L","\uA780":"L","\u01C7":"LJ","\u01C8":"Lj","\u24C2":"M","\uFF2D":"M","\u1E3E":"M","\u1E40":"M","\u1E42":"M","\u2C6E":"M","\u019C":"M","\u24C3":"N","\uFF2E":"N","\u01F8":"N","\u0143":"N","\u00D1":"N","\u1E44":"N","\u0147":"N","\u1E46":"N","\u0145":"N","\u1E4A":"N","\u1E48":"N","\u0220":"N","\u019D":"N","\uA790":"N","\uA7A4":"N","\u01CA":"NJ","\u01CB":"Nj","\u24C4":"O","\uFF2F":"O","\u00D2":"O","\u00D3":"O","\u00D4":"O","\u1ED2":"O","\u1ED0":"O","\u1ED6":"O","\u1ED4":"O","\u00D5":"O","\u1E4C":"O","\u022C":"O","\u1E4E":"O","\u014C":"O","\u1E50":"O","\u1E52":"O","\u014E":"O","\u022E":"O","\u0230":"O","\u00D6":"O","\u022A":"O","\u1ECE":"O","\u0150":"O","\u01D1":"O","\u020C":"O","\u020E":"O","\u01A0":"O","\u1EDC":"O","\u1EDA":"O","\u1EE0":"O","\u1EDE":"O","\u1EE2":"O","\u1ECC":"O","\u1ED8":"O","\u01EA":"O","\u01EC":"O","\u00D8":"O","\u01FE":"O","\u0186":"O","\u019F":"O","\uA74A":"O","\uA74C":"O","\u01A2":"OI","\uA74E":"OO","\u0222":"OU","\u24C5":"P","\uFF30":"P","\u1E54":"P","\u1E56":"P","\u01A4":"P","\u2C63":"P","\uA750":"P","\uA752":"P","\uA754":"P","\u24C6":"Q","\uFF31":"Q","\uA756":"Q","\uA758":"Q","\u024A":"Q","\u24C7":"R","\uFF32":"R","\u0154":"R","\u1E58":"R","\u0158":"R","\u0210":"R","\u0212":"R","\u1E5A":"R","\u1E5C":"R","\u0156":"R","\u1E5E":"R","\u024C":"R","\u2C64":"R","\uA75A":"R","\uA7A6":"R","\uA782":"R","\u24C8":"S","\uFF33":"S","\u1E9E":"S","\u015A":"S","\u1E64":"S","\u015C":"S","\u1E60":"S","\u0160":"S","\u1E66":"S","\u1E62":"S","\u1E68":"S","\u0218":"S","\u015E":"S","\u2C7E":"S","\uA7A8":"S","\uA784":"S","\u24C9":"T","\uFF34":"T","\u1E6A":"T","\u0164":"T","\u1E6C":"T","\u021A":"T","\u0162":"T","\u1E70":"T","\u1E6E":"T","\u0166":"T","\u01AC":"T","\u01AE":"T","\u023E":"T","\uA786":"T","\uA728":"TZ","\u24CA":"U","\uFF35":"U","\u00D9":"U","\u00DA":"U","\u00DB":"U","\u0168":"U","\u1E78":"U","\u016A":"U","\u1E7A":"U","\u016C":"U","\u00DC":"U","\u01DB":"U","\u01D7":"U","\u01D5":"U","\u01D9":"U","\u1EE6":"U","\u016E":"U","\u0170":"U","\u01D3":"U","\u0214":"U","\u0216":"U","\u01AF":"U","\u1EEA":"U","\u1EE8":"U","\u1EEE":"U","\u1EEC":"U","\u1EF0":"U","\u1EE4":"U","\u1E72":"U","\u0172":"U","\u1E76":"U","\u1E74":"U","\u0244":"U","\u24CB":"V","\uFF36":"V","\u1E7C":"V","\u1E7E":"V","\u01B2":"V","\uA75E":"V","\u0245":"V","\uA760":"VY","\u24CC":"W","\uFF37":"W","\u1E80":"W","\u1E82":"W","\u0174":"W","\u1E86":"W","\u1E84":"W","\u1E88":"W","\u2C72":"W","\u24CD":"X","\uFF38":"X","\u1E8A":"X","\u1E8C":"X","\u24CE":"Y","\uFF39":"Y","\u1EF2":"Y","\u00DD":"Y","\u0176":"Y","\u1EF8":"Y","\u0232":"Y","\u1E8E":"Y","\u0178":"Y","\u1EF6":"Y","\u1EF4":"Y","\u01B3":"Y","\u024E":"Y","\u1EFE":"Y","\u24CF":"Z","\uFF3A":"Z","\u0179":"Z","\u1E90":"Z","\u017B":"Z","\u017D":"Z","\u1E92":"Z","\u1E94":"Z","\u01B5":"Z","\u0224":"Z","\u2C7F":"Z","\u2C6B":"Z","\uA762":"Z","\u24D0":"a","\uFF41":"a","\u1E9A":"a","\u00E0":"a","\u00E1":"a","\u00E2":"a","\u1EA7":"a","\u1EA5":"a","\u1EAB":"a","\u1EA9":"a","\u00E3":"a","\u0101":"a","\u0103":"a","\u1EB1":"a","\u1EAF":"a","\u1EB5":"a","\u1EB3":"a","\u0227":"a","\u01E1":"a","\u00E4":"a","\u01DF":"a","\u1EA3":"a","\u00E5":"a","\u01FB":"a","\u01CE":"a","\u0201":"a","\u0203":"a","\u1EA1":"a","\u1EAD":"a","\u1EB7":"a","\u1E01":"a","\u0105":"a","\u2C65":"a","\u0250":"a","\uA733":"aa","\u00E6":"ae","\u01FD":"ae","\u01E3":"ae","\uA735":"ao","\uA737":"au","\uA739":"av","\uA73B":"av","\uA73D":"ay","\u24D1":"b","\uFF42":"b","\u1E03":"b","\u1E05":"b","\u1E07":"b","\u0180":"b","\u0183":"b","\u0253":"b","\u24D2":"c","\uFF43":"c","\u0107":"c","\u0109":"c","\u010B":"c","\u010D":"c","\u00E7":"c","\u1E09":"c","\u0188":"c","\u023C":"c","\uA73F":"c","\u2184":"c","\u24D3":"d","\uFF44":"d","\u1E0B":"d","\u010F":"d","\u1E0D":"d","\u1E11":"d","\u1E13":"d","\u1E0F":"d","\u0111":"d","\u018C":"d","\u0256":"d","\u0257":"d","\uA77A":"d","\u01F3":"dz","\u01C6":"dz","\u24D4":"e","\uFF45":"e","\u00E8":"e","\u00E9":"e","\u00EA":"e","\u1EC1":"e","\u1EBF":"e","\u1EC5":"e","\u1EC3":"e","\u1EBD":"e","\u0113":"e","\u1E15":"e","\u1E17":"e","\u0115":"e","\u0117":"e","\u00EB":"e","\u1EBB":"e","\u011B":"e","\u0205":"e","\u0207":"e","\u1EB9":"e","\u1EC7":"e","\u0229":"e","\u1E1D":"e","\u0119":"e","\u1E19":"e","\u1E1B":"e","\u0247":"e","\u025B":"e","\u01DD":"e","\u24D5":"f","\uFF46":"f","\u1E1F":"f","\u0192":"f","\uA77C":"f","\u24D6":"g","\uFF47":"g","\u01F5":"g","\u011D":"g","\u1E21":"g","\u011F":"g","\u0121":"g","\u01E7":"g","\u0123":"g","\u01E5":"g","\u0260":"g","\uA7A1":"g","\u1D79":"g","\uA77F":"g","\u24D7":"h","\uFF48":"h","\u0125":"h","\u1E23":"h","\u1E27":"h","\u021F":"h","\u1E25":"h","\u1E29":"h","\u1E2B":"h","\u1E96":"h","\u0127":"h","\u2C68":"h","\u2C76":"h","\u0265":"h","\u0195":"hv","\u24D8":"i","\uFF49":"i","\u00EC":"i","\u00ED":"i","\u00EE":"i","\u0129":"i","\u012B":"i","\u012D":"i","\u00EF":"i","\u1E2F":"i","\u1EC9":"i","\u01D0":"i","\u0209":"i","\u020B":"i","\u1ECB":"i","\u012F":"i","\u1E2D":"i","\u0268":"i","\u0131":"i","\u24D9":"j","\uFF4A":"j","\u0135":"j","\u01F0":"j","\u0249":"j","\u24DA":"k","\uFF4B":"k","\u1E31":"k","\u01E9":"k","\u1E33":"k","\u0137":"k","\u1E35":"k","\u0199":"k","\u2C6A":"k","\uA741":"k","\uA743":"k","\uA745":"k","\uA7A3":"k","\u24DB":"l","\uFF4C":"l","\u0140":"l","\u013A":"l","\u013E":"l","\u1E37":"l","\u1E39":"l","\u013C":"l","\u1E3D":"l","\u1E3B":"l","\u017F":"l","\u0142":"l","\u019A":"l","\u026B":"l","\u2C61":"l","\uA749":"l","\uA781":"l","\uA747":"l","\u01C9":"lj","\u24DC":"m","\uFF4D":"m","\u1E3F":"m","\u1E41":"m","\u1E43":"m","\u0271":"m","\u026F":"m","\u24DD":"n","\uFF4E":"n","\u01F9":"n","\u0144":"n","\u00F1":"n","\u1E45":"n","\u0148":"n","\u1E47":"n","\u0146":"n","\u1E4B":"n","\u1E49":"n","\u019E":"n","\u0272":"n","\u0149":"n","\uA791":"n","\uA7A5":"n","\u01CC":"nj","\u24DE":"o","\uFF4F":"o","\u00F2":"o","\u00F3":"o","\u00F4":"o","\u1ED3":"o","\u1ED1":"o","\u1ED7":"o","\u1ED5":"o","\u00F5":"o","\u1E4D":"o","\u022D":"o","\u1E4F":"o","\u014D":"o","\u1E51":"o","\u1E53":"o","\u014F":"o","\u022F":"o","\u0231":"o","\u00F6":"o","\u022B":"o","\u1ECF":"o","\u0151":"o","\u01D2":"o","\u020D":"o","\u020F":"o","\u01A1":"o","\u1EDD":"o","\u1EDB":"o","\u1EE1":"o","\u1EDF":"o","\u1EE3":"o","\u1ECD":"o","\u1ED9":"o","\u01EB":"o","\u01ED":"o","\u00F8":"o","\u01FF":"o","\u0254":"o","\uA74B":"o","\uA74D":"o","\u0275":"o","\u01A3":"oi","\u0223":"ou","\uA74F":"oo","\u24DF":"p","\uFF50":"p","\u1E55":"p","\u1E57":"p","\u01A5":"p","\u1D7D":"p","\uA751":"p","\uA753":"p","\uA755":"p","\u24E0":"q","\uFF51":"q","\u024B":"q","\uA757":"q","\uA759":"q","\u24E1":"r","\uFF52":"r","\u0155":"r","\u1E59":"r","\u0159":"r","\u0211":"r","\u0213":"r","\u1E5B":"r","\u1E5D":"r","\u0157":"r","\u1E5F":"r","\u024D":"r","\u027D":"r","\uA75B":"r","\uA7A7":"r","\uA783":"r","\u24E2":"s","\uFF53":"s","\u00DF":"s","\u015B":"s","\u1E65":"s","\u015D":"s","\u1E61":"s","\u0161":"s","\u1E67":"s","\u1E63":"s","\u1E69":"s","\u0219":"s","\u015F":"s","\u023F":"s","\uA7A9":"s","\uA785":"s","\u1E9B":"s","\u24E3":"t","\uFF54":"t","\u1E6B":"t","\u1E97":"t","\u0165":"t","\u1E6D":"t","\u021B":"t","\u0163":"t","\u1E71":"t","\u1E6F":"t","\u0167":"t","\u01AD":"t","\u0288":"t","\u2C66":"t","\uA787":"t","\uA729":"tz","\u24E4":"u","\uFF55":"u","\u00F9":"u","\u00FA":"u","\u00FB":"u","\u0169":"u","\u1E79":"u","\u016B":"u","\u1E7B":"u","\u016D":"u","\u00FC":"u","\u01DC":"u","\u01D8":"u","\u01D6":"u","\u01DA":"u","\u1EE7":"u","\u016F":"u","\u0171":"u","\u01D4":"u","\u0215":"u","\u0217":"u","\u01B0":"u","\u1EEB":"u","\u1EE9":"u","\u1EEF":"u","\u1EED":"u","\u1EF1":"u","\u1EE5":"u","\u1E73":"u","\u0173":"u","\u1E77":"u","\u1E75":"u","\u0289":"u","\u24E5":"v","\uFF56":"v","\u1E7D":"v","\u1E7F":"v","\u028B":"v","\uA75F":"v","\u028C":"v","\uA761":"vy","\u24E6":"w","\uFF57":"w","\u1E81":"w","\u1E83":"w","\u0175":"w","\u1E87":"w","\u1E85":"w","\u1E98":"w","\u1E89":"w","\u2C73":"w","\u24E7":"x","\uFF58":"x","\u1E8B":"x","\u1E8D":"x","\u24E8":"y","\uFF59":"y","\u1EF3":"y","\u00FD":"y","\u0177":"y","\u1EF9":"y","\u0233":"y","\u1E8F":"y","\u00FF":"y","\u1EF7":"y","\u1E99":"y","\u1EF5":"y","\u01B4":"y","\u024F":"y","\u1EFF":"y","\u24E9":"z","\uFF5A":"z","\u017A":"z","\u1E91":"z","\u017C":"z","\u017E":"z","\u1E93":"z","\u1E95":"z","\u01B6":"z","\u0225":"z","\u0240":"z","\u2C6C":"z","\uA763":"z","\u0386":"\u0391","\u0388":"\u0395","\u0389":"\u0397","\u038A":"\u0399","\u03AA":"\u0399","\u038C":"\u039F","\u038E":"\u03A5","\u03AB":"\u03A5","\u038F":"\u03A9","\u03AC":"\u03B1","\u03AD":"\u03B5","\u03AE":"\u03B7","\u03AF":"\u03B9","\u03CA":"\u03B9","\u0390":"\u03B9","\u03CC":"\u03BF","\u03CD":"\u03C5","\u03CB":"\u03C5","\u03B0":"\u03C5","\u03C9":"\u03C9","\u03C2":"\u03C3"};

    $document = $(document);

    nextUid=(function() { var counter=1; return function() { return counter++; }; }());


    function reinsertElement(element) {
        var placeholder = $(document.createTextNode(''));

        element.before(placeholder);
        placeholder.before(element);
        placeholder.remove();
    }

    function stripDiacritics(str) {
        // Used 'uni range + named function' from http://jsperf.com/diacritics/18
        function match(a) {
            return DIACRITICS[a] || a;
        }

        return str.replace(/[^\u0000-\u007E]/g, match);
    }

    function indexOf(value, array) {
        var i = 0, l = array.length;
        for (; i < l; i = i + 1) {
            if (equal(value, array[i])) return i;
        }
        return -1;
    }

    function measureScrollbar () {
        var $template = $( MEASURE_SCROLLBAR_TEMPLATE );
        $template.appendTo(document.body);

        var dim = {
            width: $template.width() - $template[0].clientWidth,
            height: $template.height() - $template[0].clientHeight
        };
        $template.remove();

        return dim;
    }

    /**
     * Compares equality of a and b
     * @param a
     * @param b
     */
    function equal(a, b) {
        if (a === b) return true;
        if (a === undefined || b === undefined) return false;
        if (a === null || b === null) return false;
        // Check whether 'a' or 'b' is a string (primitive or object).
        // The concatenation of an empty string (+'') converts its argument to a string's primitive.
        if (a.constructor === String) return a+'' === b+''; // a+'' - in case 'a' is a String object
        if (b.constructor === String) return b+'' === a+''; // b+'' - in case 'b' is a String object
        return false;
    }

    /**
     * Splits the string into an array of values, transforming each value. An empty array is returned for nulls or empty
     * strings
     * @param string
     * @param separator
     */
    function splitVal(string, separator, transform) {
        var val, i, l;
        if (string === null || string.length < 1) return [];
        val = string.split(separator);
        for (i = 0, l = val.length; i < l; i = i + 1) val[i] = transform(val[i]);
        return val;
    }

    function getSideBorderPadding(element) {
        return element.outerWidth(false) - element.width();
    }

    function installKeyUpChangeEvent(element) {
        var key="keyup-change-value";
        element.on("keydown", function () {
            if ($.data(element, key) === undefined) {
                $.data(element, key, element.val());
            }
        });
        element.on("keyup", function () {
            var val= $.data(element, key);
            if (val !== undefined && element.val() !== val) {
                $.removeData(element, key);
                element.trigger("keyup-change");
            }
        });
    }


    /**
     * filters mouse events so an event is fired only if the mouse moved.
     *
     * filters out mouse events that occur when mouse is stationary but
     * the elements under the pointer are scrolled.
     */
    function installFilteredMouseMove(element) {
        element.on("mousemove", function (e) {
            var lastpos = lastMousePosition;
            if (lastpos === undefined || lastpos.x !== e.pageX || lastpos.y !== e.pageY) {
                $(e.target).trigger("mousemove-filtered", e);
            }
        });
    }

    /**
     * Debounces a function. Returns a function that calls the original fn function only if no invocations have been made
     * within the last quietMillis milliseconds.
     *
     * @param quietMillis number of milliseconds to wait before invoking fn
     * @param fn function to be debounced
     * @param ctx object to be used as this reference within fn
     * @return debounced version of fn
     */
    function debounce(quietMillis, fn, ctx) {
        ctx = ctx || undefined;
        var timeout;
        return function () {
            var args = arguments;
            window.clearTimeout(timeout);
            timeout = window.setTimeout(function() {
                fn.apply(ctx, args);
            }, quietMillis);
        };
    }

    function installDebouncedScroll(threshold, element) {
        var notify = debounce(threshold, function (e) { element.trigger("scroll-debounced", e);});
        element.on("scroll", function (e) {
            if (indexOf(e.target, element.get()) >= 0) notify(e);
        });
    }

    function focus($el) {
        if ($el[0] === document.activeElement) return;

        /* set the focus in a 0 timeout - that way the focus is set after the processing
            of the current event has finished - which seems like the only reliable way
            to set focus */
        window.setTimeout(function() {
            var el=$el[0], pos=$el.val().length, range;

            $el.focus();

            /* make sure el received focus so we do not error out when trying to manipulate the caret.
                sometimes modals or others listeners may steal it after its set */
            var isVisible = (el.offsetWidth > 0 || el.offsetHeight > 0);
            if (isVisible && el === document.activeElement) {

                /* after the focus is set move the caret to the end, necessary when we val()
                    just before setting focus */
                if(el.setSelectionRange)
                {
                    el.setSelectionRange(pos, pos);
                }
                else if (el.createTextRange) {
                    range = el.createTextRange();
                    range.collapse(false);
                    range.select();
                }
            }
        }, 0);
    }

    function getCursorInfo(el) {
        el = $(el)[0];
        var offset = 0;
        var length = 0;
        if ('selectionStart' in el) {
            offset = el.selectionStart;
            length = el.selectionEnd - offset;
        } else if ('selection' in document) {
            el.focus();
            var sel = document.selection.createRange();
            length = document.selection.createRange().text.length;
            sel.moveStart('character', -el.value.length);
            offset = sel.text.length - length;
        }
        return { offset: offset, length: length };
    }

    function killEvent(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    function killEventImmediately(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }

    function measureTextWidth(e) {
        if (!sizer){
            var style = e[0].currentStyle || window.getComputedStyle(e[0], null);
            sizer = $(document.createElement("div")).css({
                position: "absolute",
                left: "-10000px",
                top: "-10000px",
                display: "none",
                fontSize: style.fontSize,
                fontFamily: style.fontFamily,
                fontStyle: style.fontStyle,
                fontWeight: style.fontWeight,
                letterSpacing: style.letterSpacing,
                textTransform: style.textTransform,
                whiteSpace: "nowrap"
            });
            sizer.attr("class","select2-sizer");
            $(document.body).append(sizer);
        }
        sizer.text(e.val());
        return sizer.width();
    }

    function syncCssClasses(dest, src, adapter) {
        var classes, replacements = [], adapted;

        classes = $.trim(dest.attr("class"));

        if (classes) {
            classes = '' + classes; // for IE which returns object

            $(classes.split(/\s+/)).each2(function() {
                if (this.indexOf("select2-") === 0) {
                    replacements.push(this);
                }
            });
        }

        classes = $.trim(src.attr("class"));

        if (classes) {
            classes = '' + classes; // for IE which returns object

            $(classes.split(/\s+/)).each2(function() {
                if (this.indexOf("select2-") !== 0) {
                    adapted = adapter(this);

                    if (adapted) {
                        replacements.push(adapted);
                    }
                }
            });
        }

        dest.attr("class", replacements.join(" "));
    }


    function markMatch(text, term, markup, escapeMarkup) {
        var match=stripDiacritics(text.toUpperCase()).indexOf(stripDiacritics(term.toUpperCase())),
            tl=term.length;

        if (match<0) {
            markup.push(escapeMarkup(text));
            return;
        }

        markup.push(escapeMarkup(text.substring(0, match)));
        markup.push("<span class='select2-match'>");
        markup.push(escapeMarkup(text.substring(match, match + tl)));
        markup.push("</span>");
        markup.push(escapeMarkup(text.substring(match + tl, text.length)));
    }

    function defaultEscapeMarkup(markup) {
        var replace_map = {
            '\\': '&#92;',
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
            "/": '&#47;'
        };

        return String(markup).replace(/[&<>"'\/\\]/g, function (match) {
            return replace_map[match];
        });
    }

    /**
     * Produces an ajax-based query function
     *
     * @param options object containing configuration parameters
     * @param options.params parameter map for the transport ajax call, can contain such options as cache, jsonpCallback, etc. see $.ajax
     * @param options.transport function that will be used to execute the ajax request. must be compatible with parameters supported by $.ajax
     * @param options.url url for the data
     * @param options.data a function(searchTerm, pageNumber, context) that should return an object containing query string parameters for the above url.
     * @param options.dataType request data type: ajax, jsonp, other datatypes supported by jQuery's $.ajax function or the transport function if specified
     * @param options.quietMillis (optional) milliseconds to wait before making the ajaxRequest, helps debounce the ajax function if invoked too often
     * @param options.results a function(remoteData, pageNumber, query) that converts data returned form the remote request to the format expected by Select2.
     *      The expected format is an object containing the following keys:
     *      results array of objects that will be used as choices
     *      more (optional) boolean indicating whether there are more results available
     *      Example: {results:[{id:1, text:'Red'},{id:2, text:'Blue'}], more:true}
     */
    function ajax(options) {
        var timeout, // current scheduled but not yet executed request
            handler = null,
            quietMillis = options.quietMillis || 100,
            ajaxUrl = options.url,
            self = this;

        return function (query) {
            window.clearTimeout(timeout);
            timeout = window.setTimeout(function () {
                var data = options.data, // ajax data function
                    url = ajaxUrl, // ajax url string or function
                    transport = options.transport || $.fn.select2.ajaxDefaults.transport,
                    // deprecated - to be removed in 4.0  - use params instead
                    deprecated = {
                        type: options.type || 'GET', // set type of request (GET or POST)
                        cache: options.cache || false,
                        jsonpCallback: options.jsonpCallback||undefined,
                        dataType: options.dataType||"json"
                    },
                    params = $.extend({}, $.fn.select2.ajaxDefaults.params, deprecated);

                data = data ? data.call(self, query.term, query.page, query.context) : null;
                url = (typeof url === 'function') ? url.call(self, query.term, query.page, query.context) : url;

                if (handler && typeof handler.abort === "function") { handler.abort(); }

                if (options.params) {
                    if ($.isFunction(options.params)) {
                        $.extend(params, options.params.call(self));
                    } else {
                        $.extend(params, options.params);
                    }
                }

                $.extend(params, {
                    url: url,
                    dataType: options.dataType,
                    data: data,
                    success: function (data) {
                        // TODO - replace query.page with query so users have access to term, page, etc.
                        // added query as third paramter to keep backwards compatibility
                        var results = options.results(data, query.page, query);
                        query.callback(results);
                    },
                    error: function(jqXHR, textStatus, errorThrown){
                        var results = {
                            hasError: true,
                            jqXHR: jqXHR,
                            textStatus: textStatus,
                            errorThrown: errorThrown
                        };

                        query.callback(results);
                    }
                });
                handler = transport.call(self, params);
            }, quietMillis);
        };
    }

    /**
     * Produces a query function that works with a local array
     *
     * @param options object containing configuration parameters. The options parameter can either be an array or an
     * object.
     *
     * If the array form is used it is assumed that it contains objects with 'id' and 'text' keys.
     *
     * If the object form is used it is assumed that it contains 'data' and 'text' keys. The 'data' key should contain
     * an array of objects that will be used as choices. These objects must contain at least an 'id' key. The 'text'
     * key can either be a String in which case it is expected that each element in the 'data' array has a key with the
     * value of 'text' which will be used to match choices. Alternatively, text can be a function(item) that can extract
     * the text.
     */
    function local(options) {
        var data = options, // data elements
            dataText,
            tmp,
            text = function (item) { return ""+item.text; }; // function used to retrieve the text portion of a data item that is matched against the search

         if ($.isArray(data)) {
            tmp = data;
            data = { results: tmp };
        }

         if ($.isFunction(data) === false) {
            tmp = data;
            data = function() { return tmp; };
        }

        var dataItem = data();
        if (dataItem.text) {
            text = dataItem.text;
            // if text is not a function we assume it to be a key name
            if (!$.isFunction(text)) {
                dataText = dataItem.text; // we need to store this in a separate variable because in the next step data gets reset and data.text is no longer available
                text = function (item) { return item[dataText]; };
            }
        }

        return function (query) {
            var t = query.term, filtered = { results: [] }, process;
            if (t === "") {
                query.callback(data());
                return;
            }

            process = function(datum, collection) {
                var group, attr;
                datum = datum[0];
                if (datum.children) {
                    group = {};
                    for (attr in datum) {
                        if (datum.hasOwnProperty(attr)) group[attr]=datum[attr];
                    }
                    group.children=[];
                    $(datum.children).each2(function(i, childDatum) { process(childDatum, group.children); });
                    if (group.children.length || query.matcher(t, text(group), datum)) {
                        collection.push(group);
                    }
                } else {
                    if (query.matcher(t, text(datum), datum)) {
                        collection.push(datum);
                    }
                }
            };

            $(data().results).each2(function(i, datum) { process(datum, filtered.results); });
            query.callback(filtered);
        };
    }

    // TODO javadoc
    function tags(data) {
        var isFunc = $.isFunction(data);
        return function (query) {
            var t = query.term, filtered = {results: []};
            var result = isFunc ? data(query) : data;
            if ($.isArray(result)) {
                $(result).each(function () {
                    var isObject = this.text !== undefined,
                        text = isObject ? this.text : this;
                    if (t === "" || query.matcher(t, text)) {
                        filtered.results.push(isObject ? this : {id: this, text: this});
                    }
                });
                query.callback(filtered);
            }
        };
    }

    /**
     * Checks if the formatter function should be used.
     *
     * Throws an error if it is not a function. Returns true if it should be used,
     * false if no formatting should be performed.
     *
     * @param formatter
     */
    function checkFormatter(formatter, formatterName) {
        if ($.isFunction(formatter)) return true;
        if (!formatter) return false;
        if (typeof(formatter) === 'string') return true;
        throw new Error(formatterName +" must be a string, function, or falsy value");
    }

  /**
   * Returns a given value
   * If given a function, returns its output
   *
   * @param val string|function
   * @param context value of "this" to be passed to function
   * @returns {*}
   */
    function evaluate(val, context) {
        if ($.isFunction(val)) {
            var args = Array.prototype.slice.call(arguments, 2);
            return val.apply(context, args);
        }
        return val;
    }

    function countResults(results) {
        var count = 0;
        $.each(results, function(i, item) {
            if (item.children) {
                count += countResults(item.children);
            } else {
                count++;
            }
        });
        return count;
    }

    /**
     * Default tokenizer. This function uses breaks the input on substring match of any string from the
     * opts.tokenSeparators array and uses opts.createSearchChoice to create the choice object. Both of those
     * two options have to be defined in order for the tokenizer to work.
     *
     * @param input text user has typed so far or pasted into the search field
     * @param selection currently selected choices
     * @param selectCallback function(choice) callback tho add the choice to selection
     * @param opts select2's opts
     * @return undefined/null to leave the current input unchanged, or a string to change the input to the returned value
     */
    function defaultTokenizer(input, selection, selectCallback, opts) {
        var original = input, // store the original so we can compare and know if we need to tell the search to update its text
            dupe = false, // check for whether a token we extracted represents a duplicate selected choice
            token, // token
            index, // position at which the separator was found
            i, l, // looping variables
            separator; // the matched separator

        if (!opts.createSearchChoice || !opts.tokenSeparators || opts.tokenSeparators.length < 1) return undefined;

        while (true) {
            index = -1;

            for (i = 0, l = opts.tokenSeparators.length; i < l; i++) {
                separator = opts.tokenSeparators[i];
                index = input.indexOf(separator);
                if (index >= 0) break;
            }

            if (index < 0) break; // did not find any token separator in the input string, bail

            token = input.substring(0, index);
            input = input.substring(index + separator.length);

            if (token.length > 0) {
                token = opts.createSearchChoice.call(this, token, selection);
                if (token !== undefined && token !== null && opts.id(token) !== undefined && opts.id(token) !== null) {
                    dupe = false;
                    for (i = 0, l = selection.length; i < l; i++) {
                        if (equal(opts.id(token), opts.id(selection[i]))) {
                            dupe = true; break;
                        }
                    }

                    if (!dupe) selectCallback(token);
                }
            }
        }

        if (original!==input) return input;
    }

    function cleanupJQueryElements() {
        var self = this;

        $.each(arguments, function (i, element) {
            self[element].remove();
            self[element] = null;
        });
    }

    /**
     * Creates a new class
     *
     * @param superClass
     * @param methods
     */
    function clazz(SuperClass, methods) {
        var constructor = function () {};
        constructor.prototype = new SuperClass;
        constructor.prototype.constructor = constructor;
        constructor.prototype.parent = SuperClass.prototype;
        constructor.prototype = $.extend(constructor.prototype, methods);
        return constructor;
    }

    AbstractSelect2 = clazz(Object, {

        // abstract
        bind: function (func) {
            var self = this;
            return function () {
                func.apply(self, arguments);
            };
        },

        // abstract
        init: function (opts) {
            var results, search, resultsSelector = ".select2-results";

            // prepare options
            this.opts = opts = this.prepareOpts(opts);

            this.id=opts.id;

            // destroy if called on an existing component
            if (opts.element.data("select2") !== undefined &&
                opts.element.data("select2") !== null) {
                opts.element.data("select2").destroy();
            }

            this.container = this.createContainer();

            this.liveRegion = $('.select2-hidden-accessible');
            if (this.liveRegion.length == 0) {
                this.liveRegion = $("<span>", {
                        role: "status",
                        "aria-live": "polite"
                    })
                    .addClass("select2-hidden-accessible")
                    .appendTo(document.body);
            }

            this.containerId="s2id_"+(opts.element.attr("id") || "autogen"+nextUid());
            this.containerEventName= this.containerId
                .replace(/([.])/g, '_')
                .replace(/([;&,\-\.\+\*\~':"\!\^#$%@\[\]\(\)=>\|])/g, '\\$1');
            this.container.attr("id", this.containerId);

            this.container.attr("title", opts.element.attr("title"));

            this.body = $(document.body);

            syncCssClasses(this.container, this.opts.element, this.opts.adaptContainerCssClass);

            this.container.attr("style", opts.element.attr("style"));
            this.container.css(evaluate(opts.containerCss, this.opts.element));
            this.container.addClass(evaluate(opts.containerCssClass, this.opts.element));

            this.elementTabIndex = this.opts.element.attr("tabindex");

            // swap container for the element
            this.opts.element
                .data("select2", this)
                .attr("tabindex", "-1")
                .before(this.container)
                .on("click.select2", killEvent); // do not leak click events

            this.container.data("select2", this);

            this.dropdown = this.container.find(".select2-drop");

            syncCssClasses(this.dropdown, this.opts.element, this.opts.adaptDropdownCssClass);

            this.dropdown.addClass(evaluate(opts.dropdownCssClass, this.opts.element));
            this.dropdown.data("select2", this);
            this.dropdown.on("click", killEvent);

            this.results = results = this.container.find(resultsSelector);
            this.search = search = this.container.find("input.select2-input");

            this.queryCount = 0;
            this.resultsPage = 0;
            this.context = null;

            // initialize the container
            this.initContainer();

            this.container.on("click", killEvent);

            installFilteredMouseMove(this.results);

            this.dropdown.on("mousemove-filtered", resultsSelector, this.bind(this.highlightUnderEvent));
            this.dropdown.on("touchstart touchmove touchend", resultsSelector, this.bind(function (event) {
                this._touchEvent = true;
                this.highlightUnderEvent(event);
            }));
            this.dropdown.on("touchmove", resultsSelector, this.bind(this.touchMoved));
            this.dropdown.on("touchstart touchend", resultsSelector, this.bind(this.clearTouchMoved));

            // Waiting for a click event on touch devices to select option and hide dropdown
            // otherwise click will be triggered on an underlying element
            this.dropdown.on('click', this.bind(function (event) {
                if (this._touchEvent) {
                    this._touchEvent = false;
                    this.selectHighlighted();
                }
            }));

            installDebouncedScroll(80, this.results);
            this.dropdown.on("scroll-debounced", resultsSelector, this.bind(this.loadMoreIfNeeded));

            // do not propagate change event from the search field out of the component
            $(this.container).on("change", ".select2-input", function(e) {e.stopPropagation();});
            $(this.dropdown).on("change", ".select2-input", function(e) {e.stopPropagation();});

            // if jquery.mousewheel plugin is installed we can prevent out-of-bounds scrolling of results via mousewheel
            if ($.fn.mousewheel) {
                results.mousewheel(function (e, delta, deltaX, deltaY) {
                    var top = results.scrollTop();
                    if (deltaY > 0 && top - deltaY <= 0) {
                        results.scrollTop(0);
                        killEvent(e);
                    } else if (deltaY < 0 && results.get(0).scrollHeight - results.scrollTop() + deltaY <= results.height()) {
                        results.scrollTop(results.get(0).scrollHeight - results.height());
                        killEvent(e);
                    }
                });
            }

            installKeyUpChangeEvent(search);
            search.on("keyup-change input paste", this.bind(this.updateResults));
            search.on("focus", function () { search.addClass("select2-focused"); });
            search.on("blur", function () { search.removeClass("select2-focused");});

            this.dropdown.on("mouseup", resultsSelector, this.bind(function (e) {
                if ($(e.target).closest(".select2-result-selectable").length > 0) {
                    this.highlightUnderEvent(e);
                    this.selectHighlighted(e);
                }
            }));

            // trap all mouse events from leaving the dropdown. sometimes there may be a modal that is listening
            // for mouse events outside of itself so it can close itself. since the dropdown is now outside the select2's
            // dom it will trigger the popup close, which is not what we want
            // focusin can cause focus wars between modals and select2 since the dropdown is outside the modal.
            this.dropdown.on("click mouseup mousedown touchstart touchend focusin", function (e) { e.stopPropagation(); });

            this.nextSearchTerm = undefined;

            if ($.isFunction(this.opts.initSelection)) {
                // initialize selection based on the current value of the source element
                this.initSelection();

                // if the user has provided a function that can set selection based on the value of the source element
                // we monitor the change event on the element and trigger it, allowing for two way synchronization
                this.monitorSource();
            }

            if (opts.maximumInputLength !== null) {
                this.search.attr("maxlength", opts.maximumInputLength);
            }

            var disabled = opts.element.prop("disabled");
            if (disabled === undefined) disabled = false;
            this.enable(!disabled);

            var readonly = opts.element.prop("readonly");
            if (readonly === undefined) readonly = false;
            this.readonly(readonly);

            // Calculate size of scrollbar
            scrollBarDimensions = scrollBarDimensions || measureScrollbar();

            this.autofocus = opts.element.prop("autofocus");
            opts.element.prop("autofocus", false);
            if (this.autofocus) this.focus();

            this.search.attr("placeholder", opts.searchInputPlaceholder);
        },

        // abstract
        destroy: function () {
            var element=this.opts.element, select2 = element.data("select2"), self = this;

            this.close();

            if (element.length && element[0].detachEvent && self._sync) {
                element.each(function () {
                    if (self._sync) {
                        this.detachEvent("onpropertychange", self._sync);
                    }
                });
            }
            if (this.propertyObserver) {
                this.propertyObserver.disconnect();
                this.propertyObserver = null;
            }
            this._sync = null;

            if (select2 !== undefined) {
                select2.container.remove();
                select2.liveRegion.remove();
                select2.dropdown.remove();
                element
                    .show()
                    .removeData("select2")
                    .off(".select2")
                    .prop("autofocus", this.autofocus || false);
                if (this.elementTabIndex) {
                    element.attr({tabindex: this.elementTabIndex});
                } else {
                    element.removeAttr("tabindex");
                }
                element.show();
            }

            cleanupJQueryElements.call(this,
                "container",
                "liveRegion",
                "dropdown",
                "results",
                "search"
            );
        },

        // abstract
        optionToData: function(element) {
            if (element.is("option")) {
                return {
                    id:element.prop("value"),
                    text:element.text(),
                    element: element.get(),
                    css: element.attr("class"),
                    disabled: element.prop("disabled"),
                    locked: equal(element.attr("locked"), "locked") || equal(element.data("locked"), true)
                };
            } else if (element.is("optgroup")) {
                return {
                    text:element.attr("label"),
                    children:[],
                    element: element.get(),
                    css: element.attr("class")
                };
            }
        },

        // abstract
        prepareOpts: function (opts) {
            var element, select, idKey, ajaxUrl, self = this;

            element = opts.element;

            if (element.get(0).tagName.toLowerCase() === "select") {
                this.select = select = opts.element;
            }

            if (select) {
                // these options are not allowed when attached to a select because they are picked up off the element itself
                $.each(["id", "multiple", "ajax", "query", "createSearchChoice", "initSelection", "data", "tags"], function () {
                    if (this in opts) {
                        throw new Error("Option '" + this + "' is not allowed for Select2 when attached to a <select> element.");
                    }
                });
            }

            opts = $.extend({}, {
                populateResults: function(container, results, query) {
                    var populate, id=this.opts.id, liveRegion=this.liveRegion;

                    populate=function(results, container, depth) {

                        var i, l, result, selectable, disabled, compound, node, label, innerContainer, formatted;

                        results = opts.sortResults(results, container, query);

                        // collect the created nodes for bulk append
                        var nodes = [];
                        for (i = 0, l = results.length; i < l; i = i + 1) {

                            result=results[i];

                            disabled = (result.disabled === true);
                            selectable = (!disabled) && (id(result) !== undefined);

                            compound=result.children && result.children.length > 0;

                            node=$("<li></li>");
                            node.addClass("select2-results-dept-"+depth);
                            node.addClass("select2-result");
                            node.addClass(selectable ? "select2-result-selectable" : "select2-result-unselectable");
                            if (disabled) { node.addClass("select2-disabled"); }
                            if (compound) { node.addClass("select2-result-with-children"); }
                            node.addClass(self.opts.formatResultCssClass(result));
                            node.attr("role", "presentation");

                            label=$(document.createElement("div"));
                            label.addClass("select2-result-label");
                            label.attr("id", "select2-result-label-" + nextUid());
                            label.attr("role", "option");

                            formatted=opts.formatResult(result, label, query, self.opts.escapeMarkup);
                            if (formatted!==undefined) {
                                label.html(formatted);
                                node.append(label);
                            }


                            if (compound) {

                                innerContainer=$("<ul></ul>");
                                innerContainer.addClass("select2-result-sub");
                                populate(result.children, innerContainer, depth+1);
                                node.append(innerContainer);
                            }

                            node.data("select2-data", result);
                            nodes.push(node[0]);
                        }

                        // bulk append the created nodes
                        container.append(nodes);
                        liveRegion.text(opts.formatMatches(results.length));
                    };

                    populate(results, container, 0);
                }
            }, $.fn.select2.defaults, opts);

            if (typeof(opts.id) !== "function") {
                idKey = opts.id;
                opts.id = function (e) { return e[idKey]; };
            }

            if ($.isArray(opts.element.data("select2Tags"))) {
                if ("tags" in opts) {
                    throw "tags specified as both an attribute 'data-select2-tags' and in options of Select2 " + opts.element.attr("id");
                }
                opts.tags=opts.element.data("select2Tags");
            }

            if (select) {
                opts.query = this.bind(function (query) {
                    var data = { results: [], more: false },
                        term = query.term,
                        children, placeholderOption, process;

                    process=function(element, collection) {
                        var group;
                        if (element.is("option")) {
                            if (query.matcher(term, element.text(), element)) {
                                collection.push(self.optionToData(element));
                            }
                        } else if (element.is("optgroup")) {
                            group=self.optionToData(element);
                            element.children().each2(function(i, elm) { process(elm, group.children); });
                            if (group.children.length>0) {
                                collection.push(group);
                            }
                        }
                    };

                    children=element.children();

                    // ignore the placeholder option if there is one
                    if (this.getPlaceholder() !== undefined && children.length > 0) {
                        placeholderOption = this.getPlaceholderOption();
                        if (placeholderOption) {
                            children=children.not(placeholderOption);
                        }
                    }

                    children.each2(function(i, elm) { process(elm, data.results); });

                    query.callback(data);
                });
                // this is needed because inside val() we construct choices from options and their id is hardcoded
                opts.id=function(e) { return e.id; };
            } else {
                if (!("query" in opts)) {

                    if ("ajax" in opts) {
                        ajaxUrl = opts.element.data("ajax-url");
                        if (ajaxUrl && ajaxUrl.length > 0) {
                            opts.ajax.url = ajaxUrl;
                        }
                        opts.query = ajax.call(opts.element, opts.ajax);
                    } else if ("data" in opts) {
                        opts.query = local(opts.data);
                    } else if ("tags" in opts) {
                        opts.query = tags(opts.tags);
                        if (opts.createSearchChoice === undefined) {
                            opts.createSearchChoice = function (term) { return {id: $.trim(term), text: $.trim(term)}; };
                        }
                        if (opts.initSelection === undefined) {
                            opts.initSelection = function (element, callback) {
                                var data = [];
                                $(splitVal(element.val(), opts.separator, opts.transformVal)).each(function () {
                                    var obj = { id: this, text: this },
                                        tags = opts.tags;
                                    if ($.isFunction(tags)) tags=tags();
                                    $(tags).each(function() { if (equal(this.id, obj.id)) { obj = this; return false; } });
                                    data.push(obj);
                                });

                                callback(data);
                            };
                        }
                    }
                }
            }
            if (typeof(opts.query) !== "function") {
                throw "query function not defined for Select2 " + opts.element.attr("id");
            }

            if (opts.createSearchChoicePosition === 'top') {
                opts.createSearchChoicePosition = function(list, item) { list.unshift(item); };
            }
            else if (opts.createSearchChoicePosition === 'bottom') {
                opts.createSearchChoicePosition = function(list, item) { list.push(item); };
            }
            else if (typeof(opts.createSearchChoicePosition) !== "function")  {
                throw "invalid createSearchChoicePosition option must be 'top', 'bottom' or a custom function";
            }

            return opts;
        },

        /**
         * Monitor the original element for changes and update select2 accordingly
         */
        // abstract
        monitorSource: function () {
            var el = this.opts.element, observer, self = this;

            el.on("change.select2", this.bind(function (e) {
                if (this.opts.element.data("select2-change-triggered") !== true) {
                    this.initSelection();
                }
            }));

            this._sync = this.bind(function () {

                // sync enabled state
                var disabled = el.prop("disabled");
                if (disabled === undefined) disabled = false;
                this.enable(!disabled);

                var readonly = el.prop("readonly");
                if (readonly === undefined) readonly = false;
                this.readonly(readonly);

                if (this.container) {
                    syncCssClasses(this.container, this.opts.element, this.opts.adaptContainerCssClass);
                    this.container.addClass(evaluate(this.opts.containerCssClass, this.opts.element));
                }

                if (this.dropdown) {
                    syncCssClasses(this.dropdown, this.opts.element, this.opts.adaptDropdownCssClass);
                    this.dropdown.addClass(evaluate(this.opts.dropdownCssClass, this.opts.element));
                }

            });

            // IE8-10 (IE9/10 won't fire propertyChange via attachEventListener)
            if (el.length && el[0].attachEvent) {
                el.each(function() {
                    this.attachEvent("onpropertychange", self._sync);
                });
            }

            // safari, chrome, firefox, IE11
            observer = window.MutationObserver || window.WebKitMutationObserver|| window.MozMutationObserver;
            if (observer !== undefined) {
                if (this.propertyObserver) { delete this.propertyObserver; this.propertyObserver = null; }
                this.propertyObserver = new observer(function (mutations) {
                    $.each(mutations, self._sync);
                });
                this.propertyObserver.observe(el.get(0), { attributes:true, subtree:false });
            }
        },

        // abstract
        triggerSelect: function(data) {
            var evt = $.Event("select2-selecting", { val: this.id(data), object: data, choice: data });
            this.opts.element.trigger(evt);
            return !evt.isDefaultPrevented();
        },

        /**
         * Triggers the change event on the source element
         */
        // abstract
        triggerChange: function (details) {

            details = details || {};
            details= $.extend({}, details, { type: "change", val: this.val() });
            // prevents recursive triggering
            this.opts.element.data("select2-change-triggered", true);
            this.opts.element.trigger(details);
            this.opts.element.data("select2-change-triggered", false);

            // some validation frameworks ignore the change event and listen instead to keyup, click for selects
            // so here we trigger the click event manually
            this.opts.element.click();

            // ValidationEngine ignores the change event and listens instead to blur
            // so here we trigger the blur event manually if so desired
            if (this.opts.blurOnChange)
                this.opts.element.blur();
        },

        //abstract
        isInterfaceEnabled: function()
        {
            return this.enabledInterface === true;
        },

        // abstract
        enableInterface: function() {
            var enabled = this._enabled && !this._readonly,
                disabled = !enabled;

            if (enabled === this.enabledInterface) return false;

            this.container.toggleClass("select2-container-disabled", disabled);
            this.close();
            this.enabledInterface = enabled;

            return true;
        },

        // abstract
        enable: function(enabled) {
            if (enabled === undefined) enabled = true;
            if (this._enabled === enabled) return;
            this._enabled = enabled;

            this.opts.element.prop("disabled", !enabled);
            this.enableInterface();
        },

        // abstract
        disable: function() {
            this.enable(false);
        },

        // abstract
        readonly: function(enabled) {
            if (enabled === undefined) enabled = false;
            if (this._readonly === enabled) return;
            this._readonly = enabled;

            this.opts.element.prop("readonly", enabled);
            this.enableInterface();
        },

        // abstract
        opened: function () {
            return (this.container) ? this.container.hasClass("select2-dropdown-open") : false;
        },

        // abstract
        positionDropdown: function() {
            var $dropdown = this.dropdown,
                container = this.container,
                offset = container.offset(),
                height = container.outerHeight(false),
                width = container.outerWidth(false),
                dropHeight = $dropdown.outerHeight(false),
                $window = $(window),
                windowWidth = $window.width(),
                windowHeight = $window.height(),
                viewPortRight = $window.scrollLeft() + windowWidth,
                viewportBottom = $window.scrollTop() + windowHeight,
                dropTop = offset.top + height,
                dropLeft = offset.left,
                enoughRoomBelow = dropTop + dropHeight <= viewportBottom,
                enoughRoomAbove = (offset.top - dropHeight) >= $window.scrollTop(),
                dropWidth = $dropdown.outerWidth(false),
                enoughRoomOnRight = function() {
                    return dropLeft + dropWidth <= viewPortRight;
                },
                enoughRoomOnLeft = function() {
                    return offset.left + viewPortRight + container.outerWidth(false)  > dropWidth;
                },
                aboveNow = $dropdown.hasClass("select2-drop-above"),
                bodyOffset,
                above,
                changeDirection,
                css,
                resultsListNode;

            // always prefer the current above/below alignment, unless there is not enough room
            if (aboveNow) {
                above = true;
                if (!enoughRoomAbove && enoughRoomBelow) {
                    changeDirection = true;
                    above = false;
                }
            } else {
                above = false;
                if (!enoughRoomBelow && enoughRoomAbove) {
                    changeDirection = true;
                    above = true;
                }
            }

            //if we are changing direction we need to get positions when dropdown is hidden;
            if (changeDirection) {
                $dropdown.hide();
                offset = this.container.offset();
                height = this.container.outerHeight(false);
                width = this.container.outerWidth(false);
                dropHeight = $dropdown.outerHeight(false);
                viewPortRight = $window.scrollLeft() + windowWidth;
                viewportBottom = $window.scrollTop() + windowHeight;
                dropTop = offset.top + height;
                dropLeft = offset.left;
                dropWidth = $dropdown.outerWidth(false);
                $dropdown.show();

                // fix so the cursor does not move to the left within the search-textbox in IE
                this.focusSearch();
            }

            if (this.opts.dropdownAutoWidth) {
                resultsListNode = $('.select2-results', $dropdown)[0];
                $dropdown.addClass('select2-drop-auto-width');
                $dropdown.css('width', '');
                // Add scrollbar width to dropdown if vertical scrollbar is present
                dropWidth = $dropdown.outerWidth(false) + (resultsListNode.scrollHeight === resultsListNode.clientHeight ? 0 : scrollBarDimensions.width);
                dropWidth > width ? width = dropWidth : dropWidth = width;
                dropHeight = $dropdown.outerHeight(false);
            }
            else {
                this.container.removeClass('select2-drop-auto-width');
            }

            //console.log("below/ droptop:", dropTop, "dropHeight", dropHeight, "sum", (dropTop+dropHeight)+" viewport bottom", viewportBottom, "enough?", enoughRoomBelow);
            //console.log("above/ offset.top", offset.top, "dropHeight", dropHeight, "top", (offset.top-dropHeight), "scrollTop", this.body.scrollTop(), "enough?", enoughRoomAbove);

            // fix positioning when body has an offset and is not position: static
            if (this.body.css('position') !== 'static') {
                bodyOffset = this.body.offset();
                dropTop -= bodyOffset.top;
                dropLeft -= bodyOffset.left;
            }

            if (!enoughRoomOnRight() && enoughRoomOnLeft()) {
                dropLeft = offset.left + this.container.outerWidth(false) - dropWidth;
            }

            css =  {
                left: dropLeft,
                width: width
            };

            if (above) {
                css.top = offset.top - dropHeight;
                css.bottom = 'auto';
                this.container.addClass("select2-drop-above");
                $dropdown.addClass("select2-drop-above");
            }
            else {
                css.top = dropTop;
                css.bottom = 'auto';
                this.container.removeClass("select2-drop-above");
                $dropdown.removeClass("select2-drop-above");
            }
            css = $.extend(css, evaluate(this.opts.dropdownCss, this.opts.element));

            $dropdown.css(css);
        },

        // abstract
        shouldOpen: function() {
            var event;

            if (this.opened()) return false;

            if (this._enabled === false || this._readonly === true) return false;

            event = $.Event("select2-opening");
            this.opts.element.trigger(event);
            return !event.isDefaultPrevented();
        },

        // abstract
        clearDropdownAlignmentPreference: function() {
            // clear the classes used to figure out the preference of where the dropdown should be opened
            this.container.removeClass("select2-drop-above");
            this.dropdown.removeClass("select2-drop-above");
        },

        /**
         * Opens the dropdown
         *
         * @return {Boolean} whether or not dropdown was opened. This method will return false if, for example,
         * the dropdown is already open, or if the 'open' event listener on the element called preventDefault().
         */
        // abstract
        open: function () {

            if (!this.shouldOpen()) return false;

            this.opening();

            // Only bind the document mousemove when the dropdown is visible
            $document.on("mousemove.select2Event", function (e) {
                lastMousePosition.x = e.pageX;
                lastMousePosition.y = e.pageY;
            });

            return true;
        },

        /**
         * Performs the opening of the dropdown
         */
        // abstract
        opening: function() {
            var cid = this.containerEventName,
                scroll = "scroll." + cid,
                resize = "resize."+cid,
                orient = "orientationchange."+cid,
                mask;

            this.container.addClass("select2-dropdown-open").addClass("select2-container-active");

            this.clearDropdownAlignmentPreference();

            if(this.dropdown[0] !== this.body.children().last()[0]) {
                this.dropdown.detach().appendTo(this.body);
            }

            // create the dropdown mask if doesn't already exist
            mask = $("#select2-drop-mask");
            if (mask.length === 0) {
                mask = $(document.createElement("div"));
                mask.attr("id","select2-drop-mask").attr("class","select2-drop-mask");
                mask.hide();
                mask.appendTo(this.body);
                mask.on("mousedown touchstart click", function (e) {
                    // Prevent IE from generating a click event on the body
                    reinsertElement(mask);

                    var dropdown = $("#select2-drop"), self;
                    if (dropdown.length > 0) {
                        self=dropdown.data("select2");
                        if (self.opts.selectOnBlur) {
                            self.selectHighlighted({noFocus: true});
                        }
                        self.close();
                        e.preventDefault();
                        e.stopPropagation();
                    }
                });
            }

            // ensure the mask is always right before the dropdown
            if (this.dropdown.prev()[0] !== mask[0]) {
                this.dropdown.before(mask);
            }

            // move the global id to the correct dropdown
            $("#select2-drop").removeAttr("id");
            this.dropdown.attr("id", "select2-drop");

            // show the elements
            mask.show();

            this.positionDropdown();
            this.dropdown.show();
            this.positionDropdown();

            this.dropdown.addClass("select2-drop-active");

            // attach listeners to events that can change the position of the container and thus require
            // the position of the dropdown to be updated as well so it does not come unglued from the container
            var that = this;
            this.container.parents().add(window).each(function () {
                $(this).on(resize+" "+scroll+" "+orient, function (e) {
                    if (that.opened()) that.positionDropdown();
                });
            });


        },

        // abstract
        close: function () {
            if (!this.opened()) return;

            var cid = this.containerEventName,
                scroll = "scroll." + cid,
                resize = "resize."+cid,
                orient = "orientationchange."+cid;

            // unbind event listeners
            this.container.parents().add(window).each(function () { $(this).off(scroll).off(resize).off(orient); });

            this.clearDropdownAlignmentPreference();

            $("#select2-drop-mask").hide();
            this.dropdown.removeAttr("id"); // only the active dropdown has the select2-drop id
            this.dropdown.hide();
            this.container.removeClass("select2-dropdown-open").removeClass("select2-container-active");
            this.results.empty();

            // Now that the dropdown is closed, unbind the global document mousemove event
            $document.off("mousemove.select2Event");

            this.clearSearch();
            this.search.removeClass("select2-active");
            this.opts.element.trigger($.Event("select2-close"));
        },

        /**
         * Opens control, sets input value, and updates results.
         */
        // abstract
        externalSearch: function (term) {
            this.open();
            this.search.val(term);
            this.updateResults(false);
        },

        // abstract
        clearSearch: function () {

        },

        //abstract
        getMaximumSelectionSize: function() {
            return evaluate(this.opts.maximumSelectionSize, this.opts.element);
        },

        // abstract
        ensureHighlightVisible: function () {
            var results = this.results, children, index, child, hb, rb, y, more, topOffset;

            index = this.highlight();

            if (index < 0) return;

            if (index == 0) {

                // if the first element is highlighted scroll all the way to the top,
                // that way any unselectable headers above it will also be scrolled
                // into view

                results.scrollTop(0);
                return;
            }

            children = this.findHighlightableChoices().find('.select2-result-label');

            child = $(children[index]);

            topOffset = (child.offset() || {}).top || 0;

            hb = topOffset + child.outerHeight(true);

            // if this is the last child lets also make sure select2-more-results is visible
            if (index === children.length - 1) {
                more = results.find("li.select2-more-results");
                if (more.length > 0) {
                    hb = more.offset().top + more.outerHeight(true);
                }
            }

            rb = results.offset().top + results.outerHeight(false);
            if (hb > rb) {
                results.scrollTop(results.scrollTop() + (hb - rb));
            }
            y = topOffset - results.offset().top;

            // make sure the top of the element is visible
            if (y < 0 && child.css('display') != 'none' ) {
                results.scrollTop(results.scrollTop() + y); // y is negative
            }
        },

        // abstract
        findHighlightableChoices: function() {
            return this.results.find(".select2-result-selectable:not(.select2-disabled):not(.select2-selected)");
        },

        // abstract
        moveHighlight: function (delta) {
            var choices = this.findHighlightableChoices(),
                index = this.highlight();

            while (index > -1 && index < choices.length) {
                index += delta;
                var choice = $(choices[index]);
                if (choice.hasClass("select2-result-selectable") && !choice.hasClass("select2-disabled") && !choice.hasClass("select2-selected")) {
                    this.highlight(index);
                    break;
                }
            }
        },

        // abstract
        highlight: function (index) {
            var choices = this.findHighlightableChoices(),
                choice,
                data;

            if (arguments.length === 0) {
                return indexOf(choices.filter(".select2-highlighted")[0], choices.get());
            }

            if (index >= choices.length) index = choices.length - 1;
            if (index < 0) index = 0;

            this.removeHighlight();

            choice = $(choices[index]);
            choice.addClass("select2-highlighted");

            // ensure assistive technology can determine the active choice
            this.search.attr("aria-activedescendant", choice.find(".select2-result-label").attr("id"));

            this.ensureHighlightVisible();

            this.liveRegion.text(choice.text());

            data = choice.data("select2-data");
            if (data) {
                this.opts.element.trigger({ type: "select2-highlight", val: this.id(data), choice: data });
            }
        },

        removeHighlight: function() {
            this.results.find(".select2-highlighted").removeClass("select2-highlighted");
        },

        touchMoved: function() {
            this._touchMoved = true;
        },

        clearTouchMoved: function() {
          this._touchMoved = false;
        },

        // abstract
        countSelectableResults: function() {
            return this.findHighlightableChoices().length;
        },

        // abstract
        highlightUnderEvent: function (event) {
            var el = $(event.target).closest(".select2-result-selectable");
            if (el.length > 0 && !el.is(".select2-highlighted")) {
                var choices = this.findHighlightableChoices();
                this.highlight(choices.index(el));
            } else if (el.length == 0) {
                // if we are over an unselectable item remove all highlights
                this.removeHighlight();
            }
        },

        // abstract
        loadMoreIfNeeded: function () {
            var results = this.results,
                more = results.find("li.select2-more-results"),
                below, // pixels the element is below the scroll fold, below==0 is when the element is starting to be visible
                page = this.resultsPage + 1,
                self=this,
                term=this.search.val(),
                context=this.context;

            if (more.length === 0) return;
            below = more.offset().top - results.offset().top - results.height();

            if (below <= this.opts.loadMorePadding) {
                more.addClass("select2-active");
                this.opts.query({
                        element: this.opts.element,
                        term: term,
                        page: page,
                        context: context,
                        matcher: this.opts.matcher,
                        callback: this.bind(function (data) {

                    // ignore a response if the select2 has been closed before it was received
                    if (!self.opened()) return;


                    self.opts.populateResults.call(this, results, data.results, {term: term, page: page, context:context});
                    self.postprocessResults(data, false, false);

                    if (data.more===true) {
                        more.detach().appendTo(results).html(self.opts.escapeMarkup(evaluate(self.opts.formatLoadMore, self.opts.element, page+1)));
                        window.setTimeout(function() { self.loadMoreIfNeeded(); }, 10);
                    } else {
                        more.remove();
                    }
                    self.positionDropdown();
                    self.resultsPage = page;
                    self.context = data.context;
                    this.opts.element.trigger({ type: "select2-loaded", items: data });
                })});
            }
        },

        /**
         * Default tokenizer function which does nothing
         */
        tokenize: function() {

        },

        /**
         * @param initial whether or not this is the call to this method right after the dropdown has been opened
         */
        // abstract
        updateResults: function (initial) {
            var search = this.search,
                results = this.results,
                opts = this.opts,
                data,
                self = this,
                input,
                term = search.val(),
                lastTerm = $.data(this.container, "select2-last-term"),
                // sequence number used to drop out-of-order responses
                queryNumber;

            // prevent duplicate queries against the same term
            if (initial !== true && lastTerm && equal(term, lastTerm)) return;

            $.data(this.container, "select2-last-term", term);

            // if the search is currently hidden we do not alter the results
            if (initial !== true && (this.showSearchInput === false || !this.opened())) {
                return;
            }

            function postRender() {
                search.removeClass("select2-active");
                self.positionDropdown();
                if (results.find('.select2-no-results,.select2-selection-limit,.select2-searching').length) {
                    self.liveRegion.text(results.text());
                }
                else {
                    self.liveRegion.text(self.opts.formatMatches(results.find('.select2-result-selectable:not(".select2-selected")').length));
                }
            }

            function render(html) {
                results.html(html);
                postRender();
            }

            queryNumber = ++this.queryCount;

            var maxSelSize = this.getMaximumSelectionSize();
            if (maxSelSize >=1) {
                data = this.data();
                if ($.isArray(data) && data.length >= maxSelSize && checkFormatter(opts.formatSelectionTooBig, "formatSelectionTooBig")) {
                    render("<li class='select2-selection-limit'>" + evaluate(opts.formatSelectionTooBig, opts.element, maxSelSize) + "</li>");
                    return;
                }
            }

            if (search.val().length < opts.minimumInputLength) {
                if (checkFormatter(opts.formatInputTooShort, "formatInputTooShort")) {
                    render("<li class='select2-no-results'>" + evaluate(opts.formatInputTooShort, opts.element, search.val(), opts.minimumInputLength) + "</li>");
                } else {
                    render("");
                }
                if (initial && this.showSearch) this.showSearch(true);
                return;
            }

            if (opts.maximumInputLength && search.val().length > opts.maximumInputLength) {
                if (checkFormatter(opts.formatInputTooLong, "formatInputTooLong")) {
                    render("<li class='select2-no-results'>" + evaluate(opts.formatInputTooLong, opts.element, search.val(), opts.maximumInputLength) + "</li>");
                } else {
                    render("");
                }
                return;
            }

            if (opts.formatSearching && this.findHighlightableChoices().length === 0) {
                render("<li class='select2-searching'>" + evaluate(opts.formatSearching, opts.element) + "</li>");
            }

            search.addClass("select2-active");

            this.removeHighlight();

            // give the tokenizer a chance to pre-process the input
            input = this.tokenize();
            if (input != undefined && input != null) {
                search.val(input);
            }

            this.resultsPage = 1;

            opts.query({
                element: opts.element,
                    term: search.val(),
                    page: this.resultsPage,
                    context: null,
                    matcher: opts.matcher,
                    callback: this.bind(function (data) {
                var def; // default choice

                // ignore old responses
                if (queryNumber != this.queryCount) {
                  return;
                }

                // ignore a response if the select2 has been closed before it was received
                if (!this.opened()) {
                    this.search.removeClass("select2-active");
                    return;
                }

                // handle ajax error
                if(data.hasError !== undefined && checkFormatter(opts.formatAjaxError, "formatAjaxError")) {
                    render("<li class='select2-ajax-error'>" + evaluate(opts.formatAjaxError, opts.element, data.jqXHR, data.textStatus, data.errorThrown) + "</li>");
                    return;
                }

                // save context, if any
                this.context = (data.context===undefined) ? null : data.context;
                // create a default choice and prepend it to the list
                if (this.opts.createSearchChoice && search.val() !== "") {
                    def = this.opts.createSearchChoice.call(self, search.val(), data.results);
                    if (def !== undefined && def !== null && self.id(def) !== undefined && self.id(def) !== null) {
                        if ($(data.results).filter(
                            function () {
                                return equal(self.id(this), self.id(def));
                            }).length === 0) {
                            this.opts.createSearchChoicePosition(data.results, def);
                        }
                    }
                }

                if (data.results.length === 0 && checkFormatter(opts.formatNoMatches, "formatNoMatches")) {
                    render("<li class='select2-no-results'>" + evaluate(opts.formatNoMatches, opts.element, search.val()) + "</li>");
                    return;
                }

                results.empty();
                self.opts.populateResults.call(this, results, data.results, {term: search.val(), page: this.resultsPage, context:null});

                if (data.more === true && checkFormatter(opts.formatLoadMore, "formatLoadMore")) {
                    results.append("<li class='select2-more-results'>" + opts.escapeMarkup(evaluate(opts.formatLoadMore, opts.element, this.resultsPage)) + "</li>");
                    window.setTimeout(function() { self.loadMoreIfNeeded(); }, 10);
                }

                this.postprocessResults(data, initial);

                postRender();

                this.opts.element.trigger({ type: "select2-loaded", items: data });
            })});
        },

        // abstract
        cancel: function () {
            this.close();
        },

        // abstract
        blur: function () {
            // if selectOnBlur == true, select the currently highlighted option
            if (this.opts.selectOnBlur)
                this.selectHighlighted({noFocus: true});

            this.close();
            this.container.removeClass("select2-container-active");
            // synonymous to .is(':focus'), which is available in jquery >= 1.6
            if (this.search[0] === document.activeElement) { this.search.blur(); }
            this.clearSearch();
            this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus");
        },

        // abstract
        focusSearch: function () {
            focus(this.search);
        },

        // abstract
        selectHighlighted: function (options) {
            if (this._touchMoved) {
              this.clearTouchMoved();
              return;
            }
            var index=this.highlight(),
                highlighted=this.results.find(".select2-highlighted"),
                data = highlighted.closest('.select2-result').data("select2-data");

            if (data) {
                this.highlight(index);
                this.onSelect(data, options);
            } else if (options && options.noFocus) {
                this.close();
            }
        },

        // abstract
        getPlaceholder: function () {
            var placeholderOption;
            return this.opts.element.attr("placeholder") ||
                this.opts.element.attr("data-placeholder") || // jquery 1.4 compat
                this.opts.element.data("placeholder") ||
                this.opts.placeholder ||
                ((placeholderOption = this.getPlaceholderOption()) !== undefined ? placeholderOption.text() : undefined);
        },

        // abstract
        getPlaceholderOption: function() {
            if (this.select) {
                var firstOption = this.select.children('option').first();
                if (this.opts.placeholderOption !== undefined ) {
                    //Determine the placeholder option based on the specified placeholderOption setting
                    return (this.opts.placeholderOption === "first" && firstOption) ||
                           (typeof this.opts.placeholderOption === "function" && this.opts.placeholderOption(this.select));
                } else if ($.trim(firstOption.text()) === "" && firstOption.val() === "") {
                    //No explicit placeholder option specified, use the first if it's blank
                    return firstOption;
                }
            }
        },

        /**
         * Get the desired width for the container element.  This is
         * derived first from option `width` passed to select2, then
         * the inline 'style' on the original element, and finally
         * falls back to the jQuery calculated element width.
         */
        // abstract
        initContainerWidth: function () {
            function resolveContainerWidth() {
                var style, attrs, matches, i, l, attr;

                if (this.opts.width === "off") {
                    return null;
                } else if (this.opts.width === "element"){
                    return this.opts.element.outerWidth(false) === 0 ? 'auto' : this.opts.element.outerWidth(false) + 'px';
                } else if (this.opts.width === "copy" || this.opts.width === "resolve") {
                    // check if there is inline style on the element that contains width
                    style = this.opts.element.attr('style');
                    if (style !== undefined) {
                        attrs = style.split(';');
                        for (i = 0, l = attrs.length; i < l; i = i + 1) {
                            attr = attrs[i].replace(/\s/g, '');
                            matches = attr.match(/^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i);
                            if (matches !== null && matches.length >= 1)
                                return matches[1];
                        }
                    }

                    if (this.opts.width === "resolve") {
                        // next check if css('width') can resolve a width that is percent based, this is sometimes possible
                        // when attached to input type=hidden or elements hidden via css
                        style = this.opts.element.css('width');
                        if (style.indexOf("%") > 0) return style;

                        // finally, fallback on the calculated width of the element
                        return (this.opts.element.outerWidth(false) === 0 ? 'auto' : this.opts.element.outerWidth(false) + 'px');
                    }

                    return null;
                } else if ($.isFunction(this.opts.width)) {
                    return this.opts.width();
                } else {
                    return this.opts.width;
               }
            };

            var width = resolveContainerWidth.call(this);
            if (width !== null) {
                this.container.css("width", width);
            }
        }
    });

    SingleSelect2 = clazz(AbstractSelect2, {

        // single

        createContainer: function () {
            var container = $(document.createElement("div")).attr({
                "class": "select2-container"
            }).html([
                "<a href='javascript:void(0)' class='select2-choice' tabindex='-1'>",
                "   <span class='select2-chosen'>&#160;</span><abbr class='select2-search-choice-close'></abbr>",
                "   <span class='select2-arrow' role='presentation'><b role='presentation'></b></span>",
                "</a>",
                "<label for='' class='select2-offscreen'></label>",
                "<input class='select2-focusser select2-offscreen' type='text' aria-haspopup='true' role='button' />",
                "<div class='select2-drop select2-display-none'>",
                "   <div class='select2-search'>",
                "       <label for='' class='select2-offscreen'></label>",
                "       <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input' role='combobox' aria-expanded='true'",
                "       aria-autocomplete='list' />",
                "   </div>",
                "   <ul class='select2-results' role='listbox'>",
                "   </ul>",
                "</div>"].join(""));
            return container;
        },

        // single
        enableInterface: function() {
            if (this.parent.enableInterface.apply(this, arguments)) {
                this.focusser.prop("disabled", !this.isInterfaceEnabled());
            }
        },

        // single
        opening: function () {
            var el, range, len;

            if (this.opts.minimumResultsForSearch >= 0) {
                this.showSearch(true);
            }

            this.parent.opening.apply(this, arguments);

            if (this.showSearchInput !== false) {
                // IE appends focusser.val() at the end of field :/ so we manually insert it at the beginning using a range
                // all other browsers handle this just fine

                this.search.val(this.focusser.val());
            }
            if (this.opts.shouldFocusInput(this)) {
                this.search.focus();
                // move the cursor to the end after focussing, otherwise it will be at the beginning and
                // new text will appear *before* focusser.val()
                el = this.search.get(0);
                if (el.createTextRange) {
                    range = el.createTextRange();
                    range.collapse(false);
                    range.select();
                } else if (el.setSelectionRange) {
                    len = this.search.val().length;
                    el.setSelectionRange(len, len);
                }
            }

            // initializes search's value with nextSearchTerm (if defined by user)
            // ignore nextSearchTerm if the dropdown is opened by the user pressing a letter
            if(this.search.val() === "") {
                if(this.nextSearchTerm != undefined){
                    this.search.val(this.nextSearchTerm);
                    this.search.select();
                }
            }

            this.focusser.prop("disabled", true).val("");
            this.updateResults(true);
            this.opts.element.trigger($.Event("select2-open"));
        },

        // single
        close: function () {
            if (!this.opened()) return;
            this.parent.close.apply(this, arguments);

            this.focusser.prop("disabled", false);

            if (this.opts.shouldFocusInput(this)) {
                this.focusser.focus();
            }
        },

        // single
        focus: function () {
            if (this.opened()) {
                this.close();
            } else {
                this.focusser.prop("disabled", false);
                if (this.opts.shouldFocusInput(this)) {
                    this.focusser.focus();
                }
            }
        },

        // single
        isFocused: function () {
            return this.container.hasClass("select2-container-active");
        },

        // single
        cancel: function () {
            this.parent.cancel.apply(this, arguments);
            this.focusser.prop("disabled", false);

            if (this.opts.shouldFocusInput(this)) {
                this.focusser.focus();
            }
        },

        // single
        destroy: function() {
            $("label[for='" + this.focusser.attr('id') + "']")
                .attr('for', this.opts.element.attr("id"));
            this.parent.destroy.apply(this, arguments);

            cleanupJQueryElements.call(this,
                "selection",
                "focusser"
            );
        },

        // single
        initContainer: function () {

            var selection,
                container = this.container,
                dropdown = this.dropdown,
                idSuffix = nextUid(),
                elementLabel;

            if (this.opts.minimumResultsForSearch < 0) {
                this.showSearch(false);
            } else {
                this.showSearch(true);
            }

            this.selection = selection = container.find(".select2-choice");

            this.focusser = container.find(".select2-focusser");

            // add aria associations
            selection.find(".select2-chosen").attr("id", "select2-chosen-"+idSuffix);
            this.focusser.attr("aria-labelledby", "select2-chosen-"+idSuffix);
            this.results.attr("id", "select2-results-"+idSuffix);
            this.search.attr("aria-owns", "select2-results-"+idSuffix);

            // rewrite labels from original element to focusser
            this.focusser.attr("id", "s2id_autogen"+idSuffix);

            elementLabel = $("label[for='" + this.opts.element.attr("id") + "']");
            this.opts.element.focus(this.bind(function () { this.focus(); }));

            this.focusser.prev()
                .text(elementLabel.text())
                .attr('for', this.focusser.attr('id'));

            // Ensure the original element retains an accessible name
            var originalTitle = this.opts.element.attr("title");
            this.opts.element.attr("title", (originalTitle || elementLabel.text()));

            this.focusser.attr("tabindex", this.elementTabIndex);

            // write label for search field using the label from the focusser element
            this.search.attr("id", this.focusser.attr('id') + '_search');

            this.search.prev()
                .text($("label[for='" + this.focusser.attr('id') + "']").text())
                .attr('for', this.search.attr('id'));

            this.search.on("keydown", this.bind(function (e) {
                if (!this.isInterfaceEnabled()) return;

                // filter 229 keyCodes (input method editor is processing key input)
                if (229 == e.keyCode) return;

                if (e.which === KEY.PAGE_UP || e.which === KEY.PAGE_DOWN) {
                    // prevent the page from scrolling
                    killEvent(e);
                    return;
                }

                switch (e.which) {
                    case KEY.UP:
                    case KEY.DOWN:
                        this.moveHighlight((e.which === KEY.UP) ? -1 : 1);
                        killEvent(e);
                        return;
                    case KEY.ENTER:
                        this.selectHighlighted();
                        killEvent(e);
                        return;
                    case KEY.TAB:
                        this.selectHighlighted({noFocus: true});
                        return;
                    case KEY.ESC:
                        this.cancel(e);
                        killEvent(e);
                        return;
                }
            }));

            this.search.on("blur", this.bind(function(e) {
                // a workaround for chrome to keep the search field focussed when the scroll bar is used to scroll the dropdown.
                // without this the search field loses focus which is annoying
                if (document.activeElement === this.body.get(0)) {
                    window.setTimeout(this.bind(function() {
                        if (this.opened()) {
                            this.search.focus();
                        }
                    }), 0);
                }
            }));

            this.focusser.on("keydown", this.bind(function (e) {
                if (!this.isInterfaceEnabled()) return;

                if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
                    return;
                }

                if (this.opts.openOnEnter === false && e.which === KEY.ENTER) {
                    killEvent(e);
                    return;
                }

                if (e.which == KEY.DOWN || e.which == KEY.UP
                    || (e.which == KEY.ENTER && this.opts.openOnEnter)) {

                    if (e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) return;

                    this.open();
                    killEvent(e);
                    return;
                }

                if (e.which == KEY.DELETE || e.which == KEY.BACKSPACE) {
                    if (this.opts.allowClear) {
                        this.clear();
                    }
                    killEvent(e);
                    return;
                }
            }));


            installKeyUpChangeEvent(this.focusser);
            this.focusser.on("keyup-change input", this.bind(function(e) {
                if (this.opts.minimumResultsForSearch >= 0) {
                    e.stopPropagation();
                    if (this.opened()) return;
                    this.open();
                }
            }));

            selection.on("mousedown touchstart", "abbr", this.bind(function (e) {
                if (!this.isInterfaceEnabled()) {
                    return;
                }

                this.clear();
                killEventImmediately(e);
                this.close();

                if (this.selection) {
                    this.selection.focus();
                }
            }));

            selection.on("mousedown touchstart", this.bind(function (e) {
                // Prevent IE from generating a click event on the body
                reinsertElement(selection);

                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }

                if (this.opened()) {
                    this.close();
                } else if (this.isInterfaceEnabled()) {
                    this.open();
                }

                killEvent(e);
            }));

            dropdown.on("mousedown touchstart", this.bind(function() {
                if (this.opts.shouldFocusInput(this)) {
                    this.search.focus();
                }
            }));

            selection.on("focus", this.bind(function(e) {
                killEvent(e);
            }));

            this.focusser.on("focus", this.bind(function(){
                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }
                this.container.addClass("select2-container-active");
            })).on("blur", this.bind(function() {
                if (!this.opened()) {
                    this.container.removeClass("select2-container-active");
                    this.opts.element.trigger($.Event("select2-blur"));
                }
            }));
            this.search.on("focus", this.bind(function(){
                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }
                this.container.addClass("select2-container-active");
            }));

            this.initContainerWidth();
            this.opts.element.hide();
            this.setPlaceholder();

        },

        // single
        clear: function(triggerChange) {
            var data=this.selection.data("select2-data");
            if (data) { // guard against queued quick consecutive clicks
                var evt = $.Event("select2-clearing");
                this.opts.element.trigger(evt);
                if (evt.isDefaultPrevented()) {
                    return;
                }
                var placeholderOption = this.getPlaceholderOption();
                this.opts.element.val(placeholderOption ? placeholderOption.val() : "");
                this.selection.find(".select2-chosen").empty();
                this.selection.removeData("select2-data");
                this.setPlaceholder();

                if (triggerChange !== false){
                    this.opts.element.trigger({ type: "select2-removed", val: this.id(data), choice: data });
                    this.triggerChange({removed:data});
                }
            }
        },

        /**
         * Sets selection based on source element's value
         */
        // single
        initSelection: function () {
            var selected;
            if (this.isPlaceholderOptionSelected()) {
                this.updateSelection(null);
                this.close();
                this.setPlaceholder();
            } else {
                var self = this;
                this.opts.initSelection.call(null, this.opts.element, function(selected){
                    if (selected !== undefined && selected !== null) {
                        self.updateSelection(selected);
                        self.close();
                        self.setPlaceholder();
                        self.nextSearchTerm = self.opts.nextSearchTerm(selected, self.search.val());
                    }
                });
            }
        },

        isPlaceholderOptionSelected: function() {
            var placeholderOption;
            if (this.getPlaceholder() === undefined) return false; // no placeholder specified so no option should be considered
            return ((placeholderOption = this.getPlaceholderOption()) !== undefined && placeholderOption.prop("selected"))
                || (this.opts.element.val() === "")
                || (this.opts.element.val() === undefined)
                || (this.opts.element.val() === null);
        },

        // single
        prepareOpts: function () {
            var opts = this.parent.prepareOpts.apply(this, arguments),
                self=this;

            if (opts.element.get(0).tagName.toLowerCase() === "select") {
                // install the selection initializer
                opts.initSelection = function (element, callback) {
                    var selected = element.find("option").filter(function() { return this.selected && !this.disabled });
                    // a single select box always has a value, no need to null check 'selected'
                    callback(self.optionToData(selected));
                };
            } else if ("data" in opts) {
                // install default initSelection when applied to hidden input and data is local
                opts.initSelection = opts.initSelection || function (element, callback) {
                    var id = element.val();
                    //search in data by id, storing the actual matching item
                    var match = null;
                    opts.query({
                        matcher: function(term, text, el){
                            var is_match = equal(id, opts.id(el));
                            if (is_match) {
                                match = el;
                            }
                            return is_match;
                        },
                        callback: !$.isFunction(callback) ? $.noop : function() {
                            callback(match);
                        }
                    });
                };
            }

            return opts;
        },

        // single
        getPlaceholder: function() {
            // if a placeholder is specified on a single select without a valid placeholder option ignore it
            if (this.select) {
                if (this.getPlaceholderOption() === undefined) {
                    return undefined;
                }
            }

            return this.parent.getPlaceholder.apply(this, arguments);
        },

        // single
        setPlaceholder: function () {
            var placeholder = this.getPlaceholder();

            if (this.isPlaceholderOptionSelected() && placeholder !== undefined) {

                // check for a placeholder option if attached to a select
                if (this.select && this.getPlaceholderOption() === undefined) return;

                this.selection.find(".select2-chosen").html(this.opts.escapeMarkup(placeholder));

                this.selection.addClass("select2-default");

                this.container.removeClass("select2-allowclear");
            }
        },

        // single
        postprocessResults: function (data, initial, noHighlightUpdate) {
            var selected = 0, self = this, showSearchInput = true;

            // find the selected element in the result list

            this.findHighlightableChoices().each2(function (i, elm) {
                if (equal(self.id(elm.data("select2-data")), self.opts.element.val())) {
                    selected = i;
                    return false;
                }
            });

            // and highlight it
            if (noHighlightUpdate !== false) {
                if (initial === true && selected >= 0) {
                    this.highlight(selected);
                } else {
                    this.highlight(0);
                }
            }

            // hide the search box if this is the first we got the results and there are enough of them for search

            if (initial === true) {
                var min = this.opts.minimumResultsForSearch;
                if (min >= 0) {
                    this.showSearch(countResults(data.results) >= min);
                }
            }
        },

        // single
        showSearch: function(showSearchInput) {
            if (this.showSearchInput === showSearchInput) return;

            this.showSearchInput = showSearchInput;

            this.dropdown.find(".select2-search").toggleClass("select2-search-hidden", !showSearchInput);
            this.dropdown.find(".select2-search").toggleClass("select2-offscreen", !showSearchInput);
            //add "select2-with-searchbox" to the container if search box is shown
            $(this.dropdown, this.container).toggleClass("select2-with-searchbox", showSearchInput);
        },

        // single
        onSelect: function (data, options) {

            if (!this.triggerSelect(data)) { return; }

            var old = this.opts.element.val(),
                oldData = this.data();

            this.opts.element.val(this.id(data));
            this.updateSelection(data);

            this.opts.element.trigger({ type: "select2-selected", val: this.id(data), choice: data });

            this.nextSearchTerm = this.opts.nextSearchTerm(data, this.search.val());
            this.close();

            if ((!options || !options.noFocus) && this.opts.shouldFocusInput(this)) {
                this.focusser.focus();
            }

            if (!equal(old, this.id(data))) {
                this.triggerChange({ added: data, removed: oldData });
            }
        },

        // single
        updateSelection: function (data) {

            var container=this.selection.find(".select2-chosen"), formatted, cssClass;

            this.selection.data("select2-data", data);

            container.empty();
            if (data !== null) {
                formatted=this.opts.formatSelection(data, container, this.opts.escapeMarkup);
            }
            if (formatted !== undefined) {
                container.append(formatted);
            }
            cssClass=this.opts.formatSelectionCssClass(data, container);
            if (cssClass !== undefined) {
                container.addClass(cssClass);
            }

            this.selection.removeClass("select2-default");

            if (this.opts.allowClear && this.getPlaceholder() !== undefined) {
                this.container.addClass("select2-allowclear");
            }
        },

        // single
        val: function () {
            var val,
                triggerChange = false,
                data = null,
                self = this,
                oldData = this.data();

            if (arguments.length === 0) {
                return this.opts.element.val();
            }

            val = arguments[0];

            if (arguments.length > 1) {
                triggerChange = arguments[1];
            }

            if (this.select) {
                this.select
                    .val(val)
                    .find("option").filter(function() { return this.selected }).each2(function (i, elm) {
                        data = self.optionToData(elm);
                        return false;
                    });
                this.updateSelection(data);
                this.setPlaceholder();
                if (triggerChange) {
                    this.triggerChange({added: data, removed:oldData});
                }
            } else {
                // val is an id. !val is true for [undefined,null,'',0] - 0 is legal
                if (!val && val !== 0) {
                    this.clear(triggerChange);
                    return;
                }
                if (this.opts.initSelection === undefined) {
                    throw new Error("cannot call val() if initSelection() is not defined");
                }
                this.opts.element.val(val);
                this.opts.initSelection(this.opts.element, function(data){
                    self.opts.element.val(!data ? "" : self.id(data));
                    self.updateSelection(data);
                    self.setPlaceholder();
                    if (triggerChange) {
                        self.triggerChange({added: data, removed:oldData});
                    }
                });
            }
        },

        // single
        clearSearch: function () {
            this.search.val("");
            this.focusser.val("");
        },

        // single
        data: function(value) {
            var data,
                triggerChange = false;

            if (arguments.length === 0) {
                data = this.selection.data("select2-data");
                if (data == undefined) data = null;
                return data;
            } else {
                if (arguments.length > 1) {
                    triggerChange = arguments[1];
                }
                if (!value) {
                    this.clear(triggerChange);
                } else {
                    data = this.data();
                    this.opts.element.val(!value ? "" : this.id(value));
                    this.updateSelection(value);
                    if (triggerChange) {
                        this.triggerChange({added: value, removed:data});
                    }
                }
            }
        }
    });

    MultiSelect2 = clazz(AbstractSelect2, {

        // multi
        createContainer: function () {
            var container = $(document.createElement("div")).attr({
                "class": "select2-container select2-container-multi"
            }).html([
                "<ul class='select2-choices'>",
                "  <li class='select2-search-field'>",
                "    <label for='' class='select2-offscreen'></label>",
                "    <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input'>",
                "  </li>",
                "</ul>",
                "<div class='select2-drop select2-drop-multi select2-display-none'>",
                "   <ul class='select2-results'>",
                "   </ul>",
                "</div>"].join(""));
            return container;
        },

        // multi
        prepareOpts: function () {
            var opts = this.parent.prepareOpts.apply(this, arguments),
                self=this;

            // TODO validate placeholder is a string if specified
            if (opts.element.get(0).tagName.toLowerCase() === "select") {
                // install the selection initializer
                opts.initSelection = function (element, callback) {

                    var data = [];

                    element.find("option").filter(function() { return this.selected && !this.disabled }).each2(function (i, elm) {
                        data.push(self.optionToData(elm));
                    });
                    callback(data);
                };
            } else if ("data" in opts) {
                // install default initSelection when applied to hidden input and data is local
                opts.initSelection = opts.initSelection || function (element, callback) {
                    var ids = splitVal(element.val(), opts.separator, opts.transformVal);
                    //search in data by array of ids, storing matching items in a list
                    var matches = [];
                    opts.query({
                        matcher: function(term, text, el){
                            var is_match = $.grep(ids, function(id) {
                                return equal(id, opts.id(el));
                            }).length;
                            if (is_match) {
                                matches.push(el);
                            }
                            return is_match;
                        },
                        callback: !$.isFunction(callback) ? $.noop : function() {
                            // reorder matches based on the order they appear in the ids array because right now
                            // they are in the order in which they appear in data array
                            var ordered = [];
                            for (var i = 0; i < ids.length; i++) {
                                var id = ids[i];
                                for (var j = 0; j < matches.length; j++) {
                                    var match = matches[j];
                                    if (equal(id, opts.id(match))) {
                                        ordered.push(match);
                                        matches.splice(j, 1);
                                        break;
                                    }
                                }
                            }
                            callback(ordered);
                        }
                    });
                };
            }

            return opts;
        },

        // multi
        selectChoice: function (choice) {

            var selected = this.container.find(".select2-search-choice-focus");
            if (selected.length && choice && choice[0] == selected[0]) {

            } else {
                if (selected.length) {
                    this.opts.element.trigger("choice-deselected", selected);
                }
                selected.removeClass("select2-search-choice-focus");
                if (choice && choice.length) {
                    this.close();
                    choice.addClass("select2-search-choice-focus");
                    this.opts.element.trigger("choice-selected", choice);
                }
            }
        },

        // multi
        destroy: function() {
            $("label[for='" + this.search.attr('id') + "']")
                .attr('for', this.opts.element.attr("id"));
            this.parent.destroy.apply(this, arguments);

            cleanupJQueryElements.call(this,
                "searchContainer",
                "selection"
            );
        },

        // multi
        initContainer: function () {

            var selector = ".select2-choices", selection;

            this.searchContainer = this.container.find(".select2-search-field");
            this.selection = selection = this.container.find(selector);

            var _this = this;
            this.selection.on("click", ".select2-container:not(.select2-container-disabled) .select2-search-choice:not(.select2-locked)", function (e) {
                _this.search[0].focus();
                _this.selectChoice($(this));
            });

            // rewrite labels from original element to focusser
            this.search.attr("id", "s2id_autogen"+nextUid());

            this.search.prev()
                .text($("label[for='" + this.opts.element.attr("id") + "']").text())
                .attr('for', this.search.attr('id'));
            this.opts.element.focus(this.bind(function () { this.focus(); }));

            this.search.on("input paste", this.bind(function() {
                if (this.search.attr('placeholder') && this.search.val().length == 0) return;
                if (!this.isInterfaceEnabled()) return;
                if (!this.opened()) {
                    this.open();
                }
            }));

            this.search.attr("tabindex", this.elementTabIndex);

            this.keydowns = 0;
            this.search.on("keydown", this.bind(function (e) {
                if (!this.isInterfaceEnabled()) return;

                ++this.keydowns;
                var selected = selection.find(".select2-search-choice-focus");
                var prev = selected.prev(".select2-search-choice:not(.select2-locked)");
                var next = selected.next(".select2-search-choice:not(.select2-locked)");
                var pos = getCursorInfo(this.search);

                if (selected.length &&
                    (e.which == KEY.LEFT || e.which == KEY.RIGHT || e.which == KEY.BACKSPACE || e.which == KEY.DELETE || e.which == KEY.ENTER)) {
                    var selectedChoice = selected;
                    if (e.which == KEY.LEFT && prev.length) {
                        selectedChoice = prev;
                    }
                    else if (e.which == KEY.RIGHT) {
                        selectedChoice = next.length ? next : null;
                    }
                    else if (e.which === KEY.BACKSPACE) {
                        if (this.unselect(selected.first())) {
                            this.search.width(10);
                            selectedChoice = prev.length ? prev : next;
                        }
                    } else if (e.which == KEY.DELETE) {
                        if (this.unselect(selected.first())) {
                            this.search.width(10);
                            selectedChoice = next.length ? next : null;
                        }
                    } else if (e.which == KEY.ENTER) {
                        selectedChoice = null;
                    }

                    this.selectChoice(selectedChoice);
                    killEvent(e);
                    if (!selectedChoice || !selectedChoice.length) {
                        this.open();
                    }
                    return;
                } else if (((e.which === KEY.BACKSPACE && this.keydowns == 1)
                    || e.which == KEY.LEFT) && (pos.offset == 0 && !pos.length)) {

                    this.selectChoice(selection.find(".select2-search-choice:not(.select2-locked)").last());
                    killEvent(e);
                    return;
                } else {
                    this.selectChoice(null);
                }

                if (this.opened()) {
                    switch (e.which) {
                    case KEY.UP:
                    case KEY.DOWN:
                        this.moveHighlight((e.which === KEY.UP) ? -1 : 1);
                        killEvent(e);
                        return;
                    case KEY.ENTER:
                        this.selectHighlighted();
                        killEvent(e);
                        return;
                    case KEY.TAB:
                        this.selectHighlighted({noFocus:true});
                        this.close();
                        return;
                    case KEY.ESC:
                        this.cancel(e);
                        killEvent(e);
                        return;
                    }
                }

                if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e)
                 || e.which === KEY.BACKSPACE || e.which === KEY.ESC) {
                    return;
                }

                if (e.which === KEY.ENTER) {
                    if (this.opts.openOnEnter === false) {
                        return;
                    } else if (e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) {
                        return;
                    }
                }

                this.open();

                if (e.which === KEY.PAGE_UP || e.which === KEY.PAGE_DOWN) {
                    // prevent the page from scrolling
                    killEvent(e);
                }

                if (e.which === KEY.ENTER) {
                    // prevent form from being submitted
                    killEvent(e);
                }

            }));

            this.search.on("keyup", this.bind(function (e) {
                this.keydowns = 0;
                this.resizeSearch();
            })
            );

            this.search.on("blur", this.bind(function(e) {
                this.container.removeClass("select2-container-active");
                this.search.removeClass("select2-focused");
                this.selectChoice(null);
                if (!this.opened()) this.clearSearch();
                e.stopImmediatePropagation();
                this.opts.element.trigger($.Event("select2-blur"));
            }));

            this.container.on("click", selector, this.bind(function (e) {
                if (!this.isInterfaceEnabled()) return;
                if ($(e.target).closest(".select2-search-choice").length > 0) {
                    // clicked inside a select2 search choice, do not open
                    return;
                }
                this.selectChoice(null);
                this.clearPlaceholder();
                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }
                this.open();
                this.focusSearch();
                e.preventDefault();
            }));

            this.container.on("focus", selector, this.bind(function () {
                if (!this.isInterfaceEnabled()) return;
                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }
                this.container.addClass("select2-container-active");
                this.dropdown.addClass("select2-drop-active");
                this.clearPlaceholder();
            }));

            this.initContainerWidth();
            this.opts.element.hide();

            // set the placeholder if necessary
            this.clearSearch();
        },

        // multi
        enableInterface: function() {
            if (this.parent.enableInterface.apply(this, arguments)) {
                this.search.prop("disabled", !this.isInterfaceEnabled());
            }
        },

        // multi
        initSelection: function () {
            var data;
            if (this.opts.element.val() === "" && this.opts.element.text() === "") {
                this.updateSelection([]);
                this.close();
                // set the placeholder if necessary
                this.clearSearch();
            }
            if (this.select || this.opts.element.val() !== "") {
                var self = this;
                this.opts.initSelection.call(null, this.opts.element, function(data){
                    if (data !== undefined && data !== null) {
                        self.updateSelection(data);
                        self.close();
                        // set the placeholder if necessary
                        self.clearSearch();
                    }
                });
            }
        },

        // multi
        clearSearch: function () {
            var placeholder = this.getPlaceholder(),
                maxWidth = this.getMaxSearchWidth();

            if (placeholder !== undefined  && this.getVal().length === 0 && this.search.hasClass("select2-focused") === false) {
                this.search.val(placeholder).addClass("select2-default");
                // stretch the search box to full width of the container so as much of the placeholder is visible as possible
                // we could call this.resizeSearch(), but we do not because that requires a sizer and we do not want to create one so early because of a firefox bug, see #944
                this.search.width(maxWidth > 0 ? maxWidth : this.container.css("width"));
            } else {
                this.search.val("").width(10);
            }
        },

        // multi
        clearPlaceholder: function () {
            if (this.search.hasClass("select2-default")) {
                this.search.val("").removeClass("select2-default");
            }
        },

        // multi
        opening: function () {
            this.clearPlaceholder(); // should be done before super so placeholder is not used to search
            this.resizeSearch();

            this.parent.opening.apply(this, arguments);

            this.focusSearch();

            // initializes search's value with nextSearchTerm (if defined by user)
            // ignore nextSearchTerm if the dropdown is opened by the user pressing a letter
            if(this.search.val() === "") {
                if(this.nextSearchTerm != undefined){
                    this.search.val(this.nextSearchTerm);
                    this.search.select();
                }
            }

            this.updateResults(true);
            if (this.opts.shouldFocusInput(this)) {
                this.search.focus();
            }
            this.opts.element.trigger($.Event("select2-open"));
        },

        // multi
        close: function () {
            if (!this.opened()) return;
            this.parent.close.apply(this, arguments);
        },

        // multi
        focus: function () {
            this.close();
            this.search.focus();
        },

        // multi
        isFocused: function () {
            return this.search.hasClass("select2-focused");
        },

        // multi
        updateSelection: function (data) {
            var ids = [], filtered = [], self = this;

            // filter out duplicates
            $(data).each(function () {
                if (indexOf(self.id(this), ids) < 0) {
                    ids.push(self.id(this));
                    filtered.push(this);
                }
            });
            data = filtered;

            this.selection.find(".select2-search-choice").remove();
            $(data).each(function () {
                self.addSelectedChoice(this);
            });
            self.postprocessResults();
        },

        // multi
        tokenize: function() {
            var input = this.search.val();
            input = this.opts.tokenizer.call(this, input, this.data(), this.bind(this.onSelect), this.opts);
            if (input != null && input != undefined) {
                this.search.val(input);
                if (input.length > 0) {
                    this.open();
                }
            }

        },

        // multi
        onSelect: function (data, options) {

            if (!this.triggerSelect(data) || data.text === "") { return; }

            this.addSelectedChoice(data);

            this.opts.element.trigger({ type: "selected", val: this.id(data), choice: data });

            // keep track of the search's value before it gets cleared
            this.nextSearchTerm = this.opts.nextSearchTerm(data, this.search.val());

            this.clearSearch();
            this.updateResults();

            if (this.select || !this.opts.closeOnSelect) this.postprocessResults(data, false, this.opts.closeOnSelect===true);

            if (this.opts.closeOnSelect) {
                this.close();
                this.search.width(10);
            } else {
                if (this.countSelectableResults()>0) {
                    this.search.width(10);
                    this.resizeSearch();
                    if (this.getMaximumSelectionSize() > 0 && this.val().length >= this.getMaximumSelectionSize()) {
                        // if we reached max selection size repaint the results so choices
                        // are replaced with the max selection reached message
                        this.updateResults(true);
                    } else {
                        // initializes search's value with nextSearchTerm and update search result
                        if(this.nextSearchTerm != undefined){
                            this.search.val(this.nextSearchTerm);
                            this.updateResults();
                            this.search.select();
                        }
                    }
                    this.positionDropdown();
                } else {
                    // if nothing left to select close
                    this.close();
                    this.search.width(10);
                }
            }

            // since its not possible to select an element that has already been
            // added we do not need to check if this is a new element before firing change
            this.triggerChange({ added: data });

            if (!options || !options.noFocus)
                this.focusSearch();
        },

        // multi
        cancel: function () {
            this.close();
            this.focusSearch();
        },

        addSelectedChoice: function (data) {
            var enableChoice = !data.locked,
                enabledItem = $(
                    "<li class='select2-search-choice'>" +
                    "    <div></div>" +
                    "    <a href='#' class='select2-search-choice-close' tabindex='-1'></a>" +
                    "</li>"),
                disabledItem = $(
                    "<li class='select2-search-choice select2-locked'>" +
                    "<div></div>" +
                    "</li>");
            var choice = enableChoice ? enabledItem : disabledItem,
                id = this.id(data),
                val = this.getVal(),
                formatted,
                cssClass;

            formatted=this.opts.formatSelection(data, choice.find("div"), this.opts.escapeMarkup);
            if (formatted != undefined) {
                choice.find("div").replaceWith($("<div></div>").html(formatted));
            }
            cssClass=this.opts.formatSelectionCssClass(data, choice.find("div"));
            if (cssClass != undefined) {
                choice.addClass(cssClass);
            }

            if(enableChoice){
              choice.find(".select2-search-choice-close")
                  .on("mousedown", killEvent)
                  .on("click dblclick", this.bind(function (e) {
                  if (!this.isInterfaceEnabled()) return;

                  this.unselect($(e.target));
                  this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus");
                  killEvent(e);
                  this.close();
                  this.focusSearch();
              })).on("focus", this.bind(function () {
                  if (!this.isInterfaceEnabled()) return;
                  this.container.addClass("select2-container-active");
                  this.dropdown.addClass("select2-drop-active");
              }));
            }

            choice.data("select2-data", data);
            choice.insertBefore(this.searchContainer);

            val.push(id);
            this.setVal(val);
        },

        // multi
        unselect: function (selected) {
            var val = this.getVal(),
                data,
                index;
            selected = selected.closest(".select2-search-choice");

            if (selected.length === 0) {
                throw "Invalid argument: " + selected + ". Must be .select2-search-choice";
            }

            data = selected.data("select2-data");

            if (!data) {
                // prevent a race condition when the 'x' is clicked really fast repeatedly the event can be queued
                // and invoked on an element already removed
                return;
            }

            var evt = $.Event("select2-removing");
            evt.val = this.id(data);
            evt.choice = data;
            this.opts.element.trigger(evt);

            if (evt.isDefaultPrevented()) {
                return false;
            }

            while((index = indexOf(this.id(data), val)) >= 0) {
                val.splice(index, 1);
                this.setVal(val);
                if (this.select) this.postprocessResults();
            }

            selected.remove();

            this.opts.element.trigger({ type: "select2-removed", val: this.id(data), choice: data });
            this.triggerChange({ removed: data });

            return true;
        },

        // multi
        postprocessResults: function (data, initial, noHighlightUpdate) {
            var val = this.getVal(),
                choices = this.results.find(".select2-result"),
                compound = this.results.find(".select2-result-with-children"),
                self = this;

            choices.each2(function (i, choice) {
                var id = self.id(choice.data("select2-data"));
                if (indexOf(id, val) >= 0) {
                    choice.addClass("select2-selected");
                    // mark all children of the selected parent as selected
                    choice.find(".select2-result-selectable").addClass("select2-selected");
                }
            });

            compound.each2(function(i, choice) {
                // hide an optgroup if it doesn't have any selectable children
                if (!choice.is('.select2-result-selectable')
                    && choice.find(".select2-result-selectable:not(.select2-selected)").length === 0) {
                    choice.addClass("select2-selected");
                }
            });

            if (this.highlight() == -1 && noHighlightUpdate !== false && this.opts.closeOnSelect === true){
                self.highlight(0);
            }

            //If all results are chosen render formatNoMatches
            if(!this.opts.createSearchChoice && !choices.filter('.select2-result:not(.select2-selected)').length > 0){
                if(!data || data && !data.more && this.results.find(".select2-no-results").length === 0) {
                    if (checkFormatter(self.opts.formatNoMatches, "formatNoMatches")) {
                        this.results.append("<li class='select2-no-results'>" + evaluate(self.opts.formatNoMatches, self.opts.element, self.search.val()) + "</li>");
                    }
                }
            }

        },

        // multi
        getMaxSearchWidth: function() {
            return this.selection.width() - getSideBorderPadding(this.search);
        },

        // multi
        resizeSearch: function () {
            var minimumWidth, left, maxWidth, containerLeft, searchWidth,
                sideBorderPadding = getSideBorderPadding(this.search);

            minimumWidth = measureTextWidth(this.search) + 10;

            left = this.search.offset().left;

            maxWidth = this.selection.width();
            containerLeft = this.selection.offset().left;

            searchWidth = maxWidth - (left - containerLeft) - sideBorderPadding;

            if (searchWidth < minimumWidth) {
                searchWidth = maxWidth - sideBorderPadding;
            }

            if (searchWidth < 40) {
                searchWidth = maxWidth - sideBorderPadding;
            }

            if (searchWidth <= 0) {
              searchWidth = minimumWidth;
            }

            this.search.width(Math.floor(searchWidth));
        },

        // multi
        getVal: function () {
            var val;
            if (this.select) {
                val = this.select.val();
                return val === null ? [] : val;
            } else {
                val = this.opts.element.val();
                return splitVal(val, this.opts.separator, this.opts.transformVal);
            }
        },

        // multi
        setVal: function (val) {
            var unique;
            if (this.select) {
                this.select.val(val);
            } else {
                unique = [];
                // filter out duplicates
                $(val).each(function () {
                    if (indexOf(this, unique) < 0) unique.push(this);
                });
                this.opts.element.val(unique.length === 0 ? "" : unique.join(this.opts.separator));
            }
        },

        // multi
        buildChangeDetails: function (old, current) {
            var current = current.slice(0),
                old = old.slice(0);

            // remove intersection from each array
            for (var i = 0; i < current.length; i++) {
                for (var j = 0; j < old.length; j++) {
                    if (equal(this.opts.id(current[i]), this.opts.id(old[j]))) {
                        current.splice(i, 1);
                        if(i>0){
                            i--;
                        }
                        old.splice(j, 1);
                        j--;
                    }
                }
            }

            return {added: current, removed: old};
        },


        // multi
        val: function (val, triggerChange) {
            var oldData, self=this;

            if (arguments.length === 0) {
                return this.getVal();
            }

            oldData=this.data();
            if (!oldData.length) oldData=[];

            // val is an id. !val is true for [undefined,null,'',0] - 0 is legal
            if (!val && val !== 0) {
                this.opts.element.val("");
                this.updateSelection([]);
                this.clearSearch();
                if (triggerChange) {
                    this.triggerChange({added: this.data(), removed: oldData});
                }
                return;
            }

            // val is a list of ids
            this.setVal(val);

            if (this.select) {
                this.opts.initSelection(this.select, this.bind(this.updateSelection));
                if (triggerChange) {
                    this.triggerChange(this.buildChangeDetails(oldData, this.data()));
                }
            } else {
                if (this.opts.initSelection === undefined) {
                    throw new Error("val() cannot be called if initSelection() is not defined");
                }

                this.opts.initSelection(this.opts.element, function(data){
                    var ids=$.map(data, self.id);
                    self.setVal(ids);
                    self.updateSelection(data);
                    self.clearSearch();
                    if (triggerChange) {
                        self.triggerChange(self.buildChangeDetails(oldData, self.data()));
                    }
                });
            }
            this.clearSearch();
        },

        // multi
        onSortStart: function() {
            if (this.select) {
                throw new Error("Sorting of elements is not supported when attached to <select>. Attach to <input type='hidden'/> instead.");
            }

            // collapse search field into 0 width so its container can be collapsed as well
            this.search.width(0);
            // hide the container
            this.searchContainer.hide();
        },

        // multi
        onSortEnd:function() {

            var val=[], self=this;

            // show search and move it to the end of the list
            this.searchContainer.show();
            // make sure the search container is the last item in the list
            this.searchContainer.appendTo(this.searchContainer.parent());
            // since we collapsed the width in dragStarted, we resize it here
            this.resizeSearch();

            // update selection
            this.selection.find(".select2-search-choice").each(function() {
                val.push(self.opts.id($(this).data("select2-data")));
            });
            this.setVal(val);
            this.triggerChange();
        },

        // multi
        data: function(values, triggerChange) {
            var self=this, ids, old;
            if (arguments.length === 0) {
                 return this.selection
                     .children(".select2-search-choice")
                     .map(function() { return $(this).data("select2-data"); })
                     .get();
            } else {
                old = this.data();
                if (!values) { values = []; }
                ids = $.map(values, function(e) { return self.opts.id(e); });
                this.setVal(ids);
                this.updateSelection(values);
                this.clearSearch();
                if (triggerChange) {
                    this.triggerChange(this.buildChangeDetails(old, this.data()));
                }
            }
        }
    });

    $.fn.select2 = function () {

        var args = Array.prototype.slice.call(arguments, 0),
            opts,
            select2,
            method, value, multiple,
            allowedMethods = ["val", "destroy", "opened", "open", "close", "focus", "isFocused", "container", "dropdown", "onSortStart", "onSortEnd", "enable", "disable", "readonly", "positionDropdown", "data", "search"],
            valueMethods = ["opened", "isFocused", "container", "dropdown"],
            propertyMethods = ["val", "data"],
            methodsMap = { search: "externalSearch" };

        this.each(function () {
            if (args.length === 0 || typeof(args[0]) === "object") {
                opts = args.length === 0 ? {} : $.extend({}, args[0]);
                opts.element = $(this);

                if (opts.element.get(0).tagName.toLowerCase() === "select") {
                    multiple = opts.element.prop("multiple");
                } else {
                    multiple = opts.multiple || false;
                    if ("tags" in opts) {opts.multiple = multiple = true;}
                }

                select2 = multiple ? new window.Select2["class"].multi() : new window.Select2["class"].single();
                select2.init(opts);
            } else if (typeof(args[0]) === "string") {

                if (indexOf(args[0], allowedMethods) < 0) {
                    throw "Unknown method: " + args[0];
                }

                value = undefined;
                select2 = $(this).data("select2");
                if (select2 === undefined) return;

                method=args[0];

                if (method === "container") {
                    value = select2.container;
                } else if (method === "dropdown") {
                    value = select2.dropdown;
                } else {
                    if (methodsMap[method]) method = methodsMap[method];

                    value = select2[method].apply(select2, args.slice(1));
                }
                if (indexOf(args[0], valueMethods) >= 0
                    || (indexOf(args[0], propertyMethods) >= 0 && args.length == 1)) {
                    return false; // abort the iteration, ready to return first matched value
                }
            } else {
                throw "Invalid arguments to select2 plugin: " + args;
            }
        });
        return (value === undefined) ? this : value;
    };

    // plugin defaults, accessible to users
    $.fn.select2.defaults = {
        width: "copy",
        loadMorePadding: 0,
        closeOnSelect: true,
        openOnEnter: true,
        containerCss: {},
        dropdownCss: {},
        containerCssClass: "",
        dropdownCssClass: "",
        formatResult: function(result, container, query, escapeMarkup) {
            var markup=[];
            markMatch(this.text(result), query.term, markup, escapeMarkup);
            return markup.join("");
        },
        transformVal: function(val) {
            return $.trim(val);
        },
        formatSelection: function (data, container, escapeMarkup) {
            return data ? escapeMarkup(this.text(data)) : undefined;
        },
        sortResults: function (results, container, query) {
            return results;
        },
        formatResultCssClass: function(data) {return data.css;},
        formatSelectionCssClass: function(data, container) {return undefined;},
        minimumResultsForSearch: 0,
        minimumInputLength: 0,
        maximumInputLength: null,
        maximumSelectionSize: 0,
        id: function (e) { return e == undefined ? null : e.id; },
        text: function (e) {
          if (e && this.data && this.data.text) {
            if ($.isFunction(this.data.text)) {
              return this.data.text(e);
            } else {
              return e[this.data.text];
            }
          } else {
            return e.text;
          }
        },
        matcher: function(term, text) {
            return stripDiacritics(''+text).toUpperCase().indexOf(stripDiacritics(''+term).toUpperCase()) >= 0;
        },
        separator: ",",
        tokenSeparators: [],
        tokenizer: defaultTokenizer,
        escapeMarkup: defaultEscapeMarkup,
        blurOnChange: false,
        selectOnBlur: false,
        adaptContainerCssClass: function(c) { return c; },
        adaptDropdownCssClass: function(c) { return null; },
        nextSearchTerm: function(selectedObject, currentSearchTerm) { return undefined; },
        searchInputPlaceholder: '',
        createSearchChoicePosition: 'top',
        shouldFocusInput: function (instance) {
            // Attempt to detect touch devices
            var supportsTouchEvents = (('ontouchstart' in window) ||
                                       (navigator.msMaxTouchPoints > 0));

            // Only devices which support touch events should be special cased
            if (!supportsTouchEvents) {
                return true;
            }

            // Never focus the input if search is disabled
            if (instance.opts.minimumResultsForSearch < 0) {
                return false;
            }

            return true;
        }
    };

    $.fn.select2.locales = [];

    $.fn.select2.locales['en'] = {
         formatMatches: function (matches) { if (matches === 1) { return "One result is available, press enter to select it."; } return matches + " results are available, use up and down arrow keys to navigate."; },
         formatNoMatches: function () { return "No matches found"; },
         formatAjaxError: function (jqXHR, textStatus, errorThrown) { return "Loading failed"; },
         formatInputTooShort: function (input, min) { var n = min - input.length; return "Please enter " + n + " or more character" + (n == 1 ? "" : "s"); },
         formatInputTooLong: function (input, max) { var n = input.length - max; return "Please delete " + n + " character" + (n == 1 ? "" : "s"); },
         formatSelectionTooBig: function (limit) { return "You can only select " + limit + " item" + (limit == 1 ? "" : "s"); },
         formatLoadMore: function (pageNumber) { return "Loading more results…"; },
         formatSearching: function () { return "Searching…"; }
    };

    $.extend($.fn.select2.defaults, $.fn.select2.locales['en']);

    $.fn.select2.ajaxDefaults = {
        transport: $.ajax,
        params: {
            type: "GET",
            cache: false,
            dataType: "json"
        }
    };

    // exports
    window.Select2 = {
        query: {
            ajax: ajax,
            local: local,
            tags: tags
        }, util: {
            debounce: debounce,
            markMatch: markMatch,
            escapeMarkup: defaultEscapeMarkup,
            stripDiacritics: stripDiacritics
        }, "class": {
            "abstract": AbstractSelect2,
            "single": SingleSelect2,
            "multi": MultiSelect2
        }
    };

}(jQuery));

/**
 * Select2 Spanish translation
 */
(function ($) {
    "use strict";

    $.fn.select2.locales['es'] = {
    	formatMatches: function (matches) { if (matches === 1) { return "Un resultado disponible, presione enter para seleccionarlo."; } return matches + " resultados disponibles, use las teclas de dirección para navegar."; },
        formatNoMatches: function () { return "No se encontraron resultados"; },
        formatInputTooShort: function (input, min) { var n = min - input.length; return "Por favor, introduzca " + n + " car" + (n == 1? "ácter" : "acteres"); },
        formatInputTooLong: function (input, max) { var n = input.length - max; return "Por favor, elimine " + n + " car" + (n == 1? "ácter" : "acteres"); },
        formatSelectionTooBig: function (limit) { return "Sólo puede seleccionar " + limit + " elemento" + (limit == 1 ? "" : "s"); },
        formatLoadMore: function (pageNumber) { return "Cargando más resultados…"; },
        formatSearching: function () { return "Buscando…"; },
        formatAjaxError: function() { return "La carga falló"; }
    };

    $.extend($.fn.select2.defaults, $.fn.select2.locales['es']);
})(jQuery);

/*!
 * jQuery blockUI plugin
 * Version 2.66.0-2013.10.09
 * Requires jQuery v1.7 or later
 *
 * Examples at: http://malsup.com/jquery/block/
 * Copyright (c) 2007-2013 M. Alsup
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 * Thanks to Amir-Hossein Sobhi for some excellent contributions!
 */

;(function() {
/*jshint eqeqeq:false curly:false latedef:false */
"use strict";

	function setup($) {
		$.fn._fadeIn = $.fn.fadeIn;

		var noOp = $.noop || function() {};

		// this bit is to ensure we don't call setExpression when we shouldn't (with extra muscle to handle
		// confusing userAgent strings on Vista)
		var msie = /MSIE/.test(navigator.userAgent);
		var ie6  = /MSIE 6.0/.test(navigator.userAgent) && ! /MSIE 8.0/.test(navigator.userAgent);
		var mode = document.documentMode || 0;
		var setExpr = $.isFunction( document.createElement('div').style.setExpression );

		// global $ methods for blocking/unblocking the entire page
		$.blockUI   = function(opts) { install(window, opts); };
		$.unblockUI = function(opts) { remove(window, opts); };

		// convenience method for quick growl-like notifications  (http://www.google.com/search?q=growl)
		$.growlUI = function(title, message, timeout, onClose) {
			var $m = $('<div class="growlUI"></div>');
			if (title) $m.append('<h1>'+title+'</h1>');
			if (message) $m.append('<h2>'+message+'</h2>');
			if (timeout === undefined) timeout = 3000;

			// Added by konapun: Set timeout to 30 seconds if this growl is moused over, like normal toast notifications
			var callBlock = function(opts) {
				opts = opts || {};

				$.blockUI({
					message: $m,
					fadeIn : typeof opts.fadeIn  !== 'undefined' ? opts.fadeIn  : 700,
					fadeOut: typeof opts.fadeOut !== 'undefined' ? opts.fadeOut : 1000,
					timeout: typeof opts.timeout !== 'undefined' ? opts.timeout : timeout,
					centerY: false,
					showOverlay: false,
					onUnblock: onClose,
					css: $.blockUI.defaults.growlCSS
				});
			};

			callBlock();
			var nonmousedOpacity = $m.css('opacity');
			$m.mouseover(function() {
				callBlock({
					fadeIn: 0,
					timeout: 30000
				});

				var displayBlock = $('.blockMsg');
				displayBlock.stop(); // cancel fadeout if it has started
				displayBlock.fadeTo(300, 1); // make it easier to read the message by removing transparency
			}).mouseout(function() {
				$('.blockMsg').fadeOut(1000);
			});
			// End konapun additions
		};

		// plugin method for blocking element content
		$.fn.block = function(opts) {
			if ( this[0] === window ) {
				$.blockUI( opts );
				return this;
			}
			var fullOpts = $.extend({}, $.blockUI.defaults, opts || {});
			this.each(function() {
				var $el = $(this);
				if (fullOpts.ignoreIfBlocked && $el.data('blockUI.isBlocked'))
					return;
				$el.unblock({ fadeOut: 0 });
			});

			return this.each(function() {
				if ($.css(this,'position') == 'static') {
					this.style.position = 'relative';
					$(this).data('blockUI.static', true);
				}
				this.style.zoom = 1; // force 'hasLayout' in ie
				install(this, opts);
			});
		};

		// plugin method for unblocking element content
		$.fn.unblock = function(opts) {
			if ( this[0] === window ) {
				$.unblockUI( opts );
				return this;
			}
			return this.each(function() {
				remove(this, opts);
			});
		};

		$.blockUI.version = 2.66; // 2nd generation blocking at no extra cost!

		// override these in your code to change the default behavior and style
		$.blockUI.defaults = {
			// message displayed when blocking (use null for no message)
			message:  'Por favor espere...',

			title: null,		// title string; only used when theme == true
			draggable: true,	// only used when theme == true (requires jquery-ui.js to be loaded)

			theme: false, // set to true to use with jQuery UI themes

			// styles for the message when blocking; if you wish to disable
			// these and use an external stylesheet then do this in your code:
			// $.blockUI.defaults.css = {};
			css: {
				padding:	0,
				margin:		0,
				width:		'30%',
				top:		'40%',
				left:		'35%',
				textAlign:	'center',
				color:		'#000',
				border:		'3px solid #aaa',
				backgroundColor:'#fff',
				cursor:		'wait'
			},

			// minimal style set used when themes are used
			themedCSS: {
				width:	'30%',
				top:	'40%',
				left:	'35%'
			},

			// styles for the overlay
			overlayCSS:  {
				backgroundColor:	'#000',
				opacity:			0.6,
				cursor:				'wait'
			},

			// style to replace wait cursor before unblocking to correct issue
			// of lingering wait cursor
			cursorReset: 'default',

			// styles applied when using $.growlUI
			growlCSS: {
				width:		'350px',
				top:		'10px',
				left:		'',
				right:		'10px',
				border:		'none',
				padding:	'5px',
				opacity:	0.6,
				cursor:		'default',
				color:		'#fff',
				backgroundColor: '#000',
				'-webkit-border-radius':'10px',
				'-moz-border-radius':	'10px',
				'border-radius':		'10px'
			},

			// IE issues: 'about:blank' fails on HTTPS and javascript:false is s-l-o-w
			// (hat tip to Jorge H. N. de Vasconcelos)
			/*jshint scripturl:true */
			iframeSrc: /^https/i.test(window.location.href || '') ? 'javascript:false' : 'about:blank',

			// force usage of iframe in non-IE browsers (handy for blocking applets)
			forceIframe: false,

			// z-index for the blocking overlay
			baseZ: 1000,

			// set these to true to have the message automatically centered
			centerX: true, // <-- only effects element blocking (page block controlled via css above)
			centerY: true,

			// allow body element to be stetched in ie6; this makes blocking look better
			// on "short" pages.  disable if you wish to prevent changes to the body height
			allowBodyStretch: true,

			// enable if you want key and mouse events to be disabled for content that is blocked
			bindEvents: true,

			// be default blockUI will supress tab navigation from leaving blocking content
			// (if bindEvents is true)
			constrainTabKey: true,

			// fadeIn time in millis; set to 0 to disable fadeIn on block
			fadeIn:  200,

			// fadeOut time in millis; set to 0 to disable fadeOut on unblock
			fadeOut:  400,

			// time in millis to wait before auto-unblocking; set to 0 to disable auto-unblock
			timeout: 0,

			// disable if you don't want to show the overlay
			showOverlay: true,

			// if true, focus will be placed in the first available input field when
			// page blocking
			focusInput: true,

            // elements that can receive focus
            focusableElements: ':input:enabled:visible',

			// suppresses the use of overlay styles on FF/Linux (due to performance issues with opacity)
			// no longer needed in 2012
			// applyPlatformOpacityRules: true,

			// callback method invoked when fadeIn has completed and blocking message is visible
			onBlock: null,

			// callback method invoked when unblocking has completed; the callback is
			// passed the element that has been unblocked (which is the window object for page
			// blocks) and the options that were passed to the unblock call:
			//	onUnblock(element, options)
			onUnblock: null,

			// callback method invoked when the overlay area is clicked.
			// setting this will turn the cursor to a pointer, otherwise cursor defined in overlayCss will be used.
			onOverlayClick: null,

			// don't ask; if you really must know: http://groups.google.com/group/jquery-en/browse_thread/thread/36640a8730503595/2f6a79a77a78e493#2f6a79a77a78e493
			quirksmodeOffsetHack: 4,

			// class name of the message block
			blockMsgClass: 'blockMsg',

			// if it is already blocked, then ignore it (don't unblock and reblock)
			ignoreIfBlocked: false
		};

		// private data and functions follow...

		var pageBlock = null;
		var pageBlockEls = [];

		function install(el, opts) {
			var css, themedCSS;
			var full = (el == window);
			var msg = (opts && opts.message !== undefined ? opts.message : undefined);
			opts = $.extend({}, $.blockUI.defaults, opts || {});

			if (opts.ignoreIfBlocked && $(el).data('blockUI.isBlocked'))
				return;

			opts.overlayCSS = $.extend({}, $.blockUI.defaults.overlayCSS, opts.overlayCSS || {});
			css = $.extend({}, $.blockUI.defaults.css, opts.css || {});
			if (opts.onOverlayClick)
				opts.overlayCSS.cursor = 'pointer';

			themedCSS = $.extend({}, $.blockUI.defaults.themedCSS, opts.themedCSS || {});
			msg = msg === undefined ? opts.message : msg;

			// remove the current block (if there is one)
			if (full && pageBlock)
				remove(window, {fadeOut:0});

			// if an existing element is being used as the blocking content then we capture
			// its current place in the DOM (and current display style) so we can restore
			// it when we unblock
			if (msg && typeof msg != 'string' && (msg.parentNode || msg.jquery)) {
				var node = msg.jquery ? msg[0] : msg;
				var data = {};
				$(el).data('blockUI.history', data);
				data.el = node;
				data.parent = node.parentNode;
				data.display = node.style.display;
				data.position = node.style.position;
				if (data.parent)
					data.parent.removeChild(node);
			}

			$(el).data('blockUI.onUnblock', opts.onUnblock);
			var z = opts.baseZ;

			// blockUI uses 3 layers for blocking, for simplicity they are all used on every platform;
			// layer1 is the iframe layer which is used to supress bleed through of underlying content
			// layer2 is the overlay layer which has opacity and a wait cursor (by default)
			// layer3 is the message content that is displayed while blocking
			var lyr1, lyr2, lyr3, s;
			if (msie || opts.forceIframe)
				lyr1 = $('<iframe class="blockUI" style="z-index:'+ (z++) +';display:none;border:none;margin:0;padding:0;position:absolute;width:100%;height:100%;top:0;left:0" src="'+opts.iframeSrc+'"></iframe>');
			else
				lyr1 = $('<div class="blockUI" style="display:none"></div>');

			if (opts.theme)
				lyr2 = $('<div class="blockUI blockOverlay ui-widget-overlay" style="z-index:'+ (z++) +';display:none"></div>');
			else
				lyr2 = $('<div class="blockUI blockOverlay" style="z-index:'+ (z++) +';display:none;border:none;margin:0;padding:0;width:100%;height:100%;top:0;left:0"></div>');

			if (opts.theme && full) {
				s = '<div class="blockUI ' + opts.blockMsgClass + ' blockPage ui-dialog ui-widget ui-corner-all" style="z-index:'+(z+10)+';display:none;position:fixed">';
				if ( opts.title ) {
					s += '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">'+(opts.title || '&nbsp;')+'</div>';
				}
				s += '<div class="ui-widget-content ui-dialog-content"></div>';
				s += '</div>';
			}
			else if (opts.theme) {
				s = '<div class="blockUI ' + opts.blockMsgClass + ' blockElement ui-dialog ui-widget ui-corner-all" style="z-index:'+(z+10)+';display:none;position:absolute">';
				if ( opts.title ) {
					s += '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">'+(opts.title || '&nbsp;')+'</div>';
				}
				s += '<div class="ui-widget-content ui-dialog-content"></div>';
				s += '</div>';
			}
			else if (full) {
				s = '<div class="blockUI ' + opts.blockMsgClass + ' blockPage" style="z-index:'+(z+10)+';display:none;position:fixed"></div>';
			}
			else {
				s = '<div class="blockUI ' + opts.blockMsgClass + ' blockElement" style="z-index:'+(z+10)+';display:none;position:absolute"></div>';
			}
			lyr3 = $(s);

			// if we have a message, style it
			if (msg) {
				if (opts.theme) {
					lyr3.css(themedCSS);
					lyr3.addClass('ui-widget-content');
				}
				else
					lyr3.css(css);
			}

			// style the overlay
			if (!opts.theme /*&& (!opts.applyPlatformOpacityRules)*/)
				lyr2.css(opts.overlayCSS);
			lyr2.css('position', full ? 'fixed' : 'absolute');

			// make iframe layer transparent in IE
			if (msie || opts.forceIframe)
				lyr1.css('opacity',0.0);

			//$([lyr1[0],lyr2[0],lyr3[0]]).appendTo(full ? 'body' : el);
			var layers = [lyr1,lyr2,lyr3], $par = full ? $('body') : $(el);
			$.each(layers, function() {
				this.appendTo($par);
			});

			if (opts.theme && opts.draggable && $.fn.draggable) {
				lyr3.draggable({
					handle: '.ui-dialog-titlebar',
					cancel: 'li'
				});
			}

			// ie7 must use absolute positioning in quirks mode and to account for activex issues (when scrolling)
			var expr = setExpr && (!$.support.boxModel || $('object,embed', full ? null : el).length > 0);
			if (ie6 || expr) {
				// give body 100% height
				if (full && opts.allowBodyStretch && $.support.boxModel)
					$('html,body').css('height','100%');

				// fix ie6 issue when blocked element has a border width
				if ((ie6 || !$.support.boxModel) && !full) {
					var t = sz(el,'borderTopWidth'), l = sz(el,'borderLeftWidth');
					var fixT = t ? '(0 - '+t+')' : 0;
					var fixL = l ? '(0 - '+l+')' : 0;
				}

				// simulate fixed position
				$.each(layers, function(i,o) {
					var s = o[0].style;
					s.position = 'absolute';
					if (i < 2) {
						if (full)
							s.setExpression('height','Math.max(document.body.scrollHeight, document.body.offsetHeight) - (jQuery.support.boxModel?0:'+opts.quirksmodeOffsetHack+') + "px"');
						else
							s.setExpression('height','this.parentNode.offsetHeight + "px"');
						if (full)
							s.setExpression('width','jQuery.support.boxModel && document.documentElement.clientWidth || document.body.clientWidth + "px"');
						else
							s.setExpression('width','this.parentNode.offsetWidth + "px"');
						if (fixL) s.setExpression('left', fixL);
						if (fixT) s.setExpression('top', fixT);
					}
					else if (opts.centerY) {
						if (full) s.setExpression('top','(document.documentElement.clientHeight || document.body.clientHeight) / 2 - (this.offsetHeight / 2) + (blah = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + "px"');
						s.marginTop = 0;
					}
					else if (!opts.centerY && full) {
						var top = (opts.css && opts.css.top) ? parseInt(opts.css.top, 10) : 0;
						var expression = '((document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + '+top+') + "px"';
						s.setExpression('top',expression);
					}
				});
			}

			// show the message
			if (msg) {
				if (opts.theme)
					lyr3.find('.ui-widget-content').append(msg);
				else
					lyr3.append(msg);
				if (msg.jquery || msg.nodeType)
					$(msg).show();
			}

			if ((msie || opts.forceIframe) && opts.showOverlay)
				lyr1.show(); // opacity is zero
			if (opts.fadeIn) {
				var cb = opts.onBlock ? opts.onBlock : noOp;
				var cb1 = (opts.showOverlay && !msg) ? cb : noOp;
				var cb2 = msg ? cb : noOp;
				if (opts.showOverlay)
					lyr2._fadeIn(opts.fadeIn, cb1);
				if (msg)
					lyr3._fadeIn(opts.fadeIn, cb2);
			}
			else {
				if (opts.showOverlay)
					lyr2.show();
				if (msg)
					lyr3.show();
				if (opts.onBlock)
					opts.onBlock();
			}

			// bind key and mouse events
			bind(1, el, opts);

			if (full) {
				pageBlock = lyr3[0];
				pageBlockEls = $(opts.focusableElements,pageBlock);
				if (opts.focusInput)
					setTimeout(focus, 20);
			}
			else
				center(lyr3[0], opts.centerX, opts.centerY);

			if (opts.timeout) {
				// auto-unblock
				var to = setTimeout(function() {
					if (full)
						$.unblockUI(opts);
					else
						$(el).unblock(opts);
				}, opts.timeout);
				$(el).data('blockUI.timeout', to);
			}
		}

		// remove the block
		function remove(el, opts) {
			var count;
			var full = (el == window);
			var $el = $(el);
			var data = $el.data('blockUI.history');
			var to = $el.data('blockUI.timeout');
			if (to) {
				clearTimeout(to);
				$el.removeData('blockUI.timeout');
			}
			opts = $.extend({}, $.blockUI.defaults, opts || {});
			bind(0, el, opts); // unbind events

			if (opts.onUnblock === null) {
				opts.onUnblock = $el.data('blockUI.onUnblock');
				$el.removeData('blockUI.onUnblock');
			}

			var els;
			if (full) // crazy selector to handle odd field errors in ie6/7
				els = $('body').children().filter('.blockUI').add('body > .blockUI');
			else
				els = $el.find('>.blockUI');

			// fix cursor issue
			if ( opts.cursorReset ) {
				if ( els.length > 1 )
					els[1].style.cursor = opts.cursorReset;
				if ( els.length > 2 )
					els[2].style.cursor = opts.cursorReset;
			}

			if (full)
				pageBlock = pageBlockEls = null;

			if (opts.fadeOut) {
				count = els.length;
				els.stop().fadeOut(opts.fadeOut, function() {
					if ( --count === 0)
						reset(els,data,opts,el);
				});
			}
			else
				reset(els, data, opts, el);
		}

		// move blocking element back into the DOM where it started
		function reset(els,data,opts,el) {
			var $el = $(el);
			if ( $el.data('blockUI.isBlocked') )
				return;

			els.each(function(i,o) {
				// remove via DOM calls so we don't lose event handlers
				if (this.parentNode)
					this.parentNode.removeChild(this);
			});

			if (data && data.el) {
				data.el.style.display = data.display;
				data.el.style.position = data.position;
				if (data.parent)
					data.parent.appendChild(data.el);
				$el.removeData('blockUI.history');
			}

			if ($el.data('blockUI.static')) {
				$el.css('position', 'static'); // #22
			}

			if (typeof opts.onUnblock == 'function')
				opts.onUnblock(el,opts);

			// fix issue in Safari 6 where block artifacts remain until reflow
			var body = $(document.body), w = body.width(), cssW = body[0].style.width;
			body.width(w-1).width(w);
			body[0].style.width = cssW;
		}

		// bind/unbind the handler
		function bind(b, el, opts) {
			var full = el == window, $el = $(el);

			// don't bother unbinding if there is nothing to unbind
			if (!b && (full && !pageBlock || !full && !$el.data('blockUI.isBlocked')))
				return;

			$el.data('blockUI.isBlocked', b);

			// don't bind events when overlay is not in use or if bindEvents is false
			if (!full || !opts.bindEvents || (b && !opts.showOverlay))
				return;

			// bind anchors and inputs for mouse and key events
			var events = 'mousedown mouseup keydown keypress keyup touchstart touchend touchmove';
			if (b)
				$(document).bind(events, opts, handler);
			else
				$(document).unbind(events, handler);

		// former impl...
		//		var $e = $('a,:input');
		//		b ? $e.bind(events, opts, handler) : $e.unbind(events, handler);
		}

		// event handler to suppress keyboard/mouse events when blocking
		function handler(e) {
			// allow tab navigation (conditionally)
			if (e.type === 'keydown' && e.keyCode && e.keyCode == 9) {
				if (pageBlock && e.data.constrainTabKey) {
					var els = pageBlockEls;
					var fwd = !e.shiftKey && e.target === els[els.length-1];
					var back = e.shiftKey && e.target === els[0];
					if (fwd || back) {
						setTimeout(function(){focus(back);},10);
						return false;
					}
				}
			}
			var opts = e.data;
			var target = $(e.target);
			if (target.hasClass('blockOverlay') && opts.onOverlayClick)
				opts.onOverlayClick(e);

			// allow events within the message content
			if (target.parents('div.' + opts.blockMsgClass).length > 0)
				return true;

			// allow events for content that is not being blocked
			return target.parents().children().filter('div.blockUI').length === 0;
		}

		function focus(back) {
			if (!pageBlockEls)
				return;
			var e = pageBlockEls[back===true ? pageBlockEls.length-1 : 0];
			if (e)
				e.focus();
		}

		function center(el, x, y) {
			var p = el.parentNode, s = el.style;
			var l = ((p.offsetWidth - el.offsetWidth)/2) - sz(p,'borderLeftWidth');
			var t = ((p.offsetHeight - el.offsetHeight)/2) - sz(p,'borderTopWidth');
			if (x) s.left = l > 0 ? (l+'px') : '0';
			if (y) s.top  = t > 0 ? (t+'px') : '0';
		}

		function sz(el, p) {
			return parseInt($.css(el,p),10)||0;
		}

	}


	/*global define:true 
	if (typeof define === 'function' && define.amd && define.amd.jQuery) {
		setup();
	} else {
		
	} */
	setup(jQuery);

})();
'use strict';

/**
 * @ngdoc overview
 * @name qualita
 * @description
 * # qualita
 *
 * Main module of the application.
 */
angular
    .module('qualita', [
        'ngAnimate',
        'ngCookies',
        'ngMessages',
        'ngResource',
        'ngSanitize',
        'ui.bootstrap',
        'ngTouch',
        'angularSpinner',
        'ngTagsInput',
        'pascalprecht.translate',
        'angular-ladda',
        //'perfect_scrollbar',
        'qualitaCoreFrontend',
        'datatables.colreorder',
        'angular-intro',
        'qualita.components',
        'qualita.authorization',
        'qualita.parametros',
        'qualita.productos',
        'qualita.stock',
        'qualita.importacion',
        'qualita.notificaciones',
        'qualita.bobinas',
        'qualita.compra',
        'qualita.tesoreria',
        'qualita.inventario',
        'qualita.cuentasapagar',
        'qualita.venta',
        'qualita.diferenciacambio',
        'qualita.activofijo',
        'qualita.contabilidad',
        'qualita.analitica',
        'qualita.menujson'
    ]);

angular.module('qualita').constant('VERSION', {
    version:'4.0.0.0'
});

// Se agrega pop-up para evitar cerrar qualita sin querer
window.onbeforeunload = function(event) {
    var message = 'Seguro de que desea cerrar?';
    if (typeof event == 'undefined') {
        event = window.event;
    }
    if (event) {
        event.returnValue = message;
    }
    return message;
}

"use strict";
angular
    .module("qualita")
    .run([
        "$rootScope",
        "$state",
        "$stateParams",
        function($rootScope, $state, $stateParams) {
            $rootScope.$state = $state;
            $rootScope.$stateParams = $stateParams;

            //para generar el Header cuando se carga por primera vez la página.
            var toUnRegist;
            toUnRegist = $rootScope.$on("$stateChangeSuccess", function(
                event,
                toState
            ) {
                if (toState.ncyBreadcrumb) {
                    $rootScope.title = toState.ncyBreadcrumb.label;
                    $rootScope.description = toState.ncyBreadcrumb.description;
                    toUnRegist(); //se desregistra el evento stateChangeSuccess
                }
            });
        }
    ])
    .config([
        "$stateProvider",
        "$urlRouterProvider",
        "$httpProvider",
        "$translateProvider",
        "$urlMatcherFactoryProvider",
        function(
            $stateProvider,
            $urlRouterProvider,
            $httpProvider,
            $translateProvider,
            $urlMatcherFactoryProvider
        ) {
            $urlMatcherFactoryProvider.strictMode(false);
            $urlRouterProvider.otherwise("/404");
            $stateProvider
                .state("app", {
                    abstract: true,
                    url: "",
                    templateUrl: "views/layout.html",
                    ncyBreadcrumb: {
                        skip: true
                    }
                })
                .state("error404", {
                    url: "/404",
                    templateUrl: "../theme/views/error-404.html",
                    ncyBreadcrumb: {
                        label: "Error 404 - Página no encontrada"
                    }
                })
                .state("error500", {
                    url: "/500",
                    templateUrl: "../theme/views/error-500.html",
                    ncyBreadcrumb: {
                        label: "Error 500 - something went wrong"
                    }
                })
                .state("app.main", {
                    url: "",
                    templateUrl: "views/main.html",
                    controller: "MainCtrl",
                    ncyBreadcrumb: {
                        label: "Principal",
                        description: "Bienvenido"
                    }
                })
                .state("login", {
                    url: "/login",
                    templateUrl: "views/login.html",
                    controller: "LoginCtrl"
                })
                .state('lock', {
                     url: "/lock",
                     templateUrl: "views/lock.html",
                     controller: "LockController",
                     ncyBreadcrumb: {
                     label: 'Lock Screen'
                    }
                })
                .state("logout", {
                    url: "/logout",
                    controller: "LogoutController"
                })
                .state("app.menu", {
                    url: "/menu",
                    templateUrl: "views/menu.html",
                    controller: "MenuCtrl",
                    ncyBreadcrumb: {
                        skip: true
                    },
                    resolve: {
                        deps: [
                            "$ocLazyLoad",
                            function($ocLazyLoad) {
                                return $ocLazyLoad.load({
                                    serie: true,
                                    files: ["scripts/directives/custom-sidebar.js"]
                                });
                            }
                        ]
                    }
                });

            $httpProvider.interceptors.push("HttpInterceptor");
            $translateProvider.translations("es", {
                "placeholders.select": "$"
            });
            $translateProvider.preferredLanguage("es");
            $translateProvider.translationNotFoundIndicator("$");
        }
    ])
    .run([
        "$rootScope",
        "$modal",
        "$http",
        "$log",
        "AuthorizationService",
        "AuthenticationService",
        "$state",
        "$stateParams",
        "NotificacionesWSFactory",
        "baseurl",
        "statePermissionMapping",
        "notify",
        "dontRedirectArray",
        "NewRelicTracking",
        "CONFIGURATION",
        function(
            $rootScope,
            $modal,
            $http,
            $log,
            AuthorizationService,
            AuthenticationService,
            $state,
            $stateParams,
            NotificacionesWSFactory,
            baseurl,
            statePermissionMapping,
            notify,
            dontRedirectArray,
            NewRelicTracking,
            CONFIGURATION
        ) {
            $rootScope.wsinit = false;
            $rootScope.AuthParams = JSON.parse(
                localStorage.getItem("AUTH_PARAMS")
            ) || {};
            $rootScope.publicBaseURL = baseurl.getPublicBaseUrl();
            //$rootScope.userAvatar = "images/avatar.png";

            var Auth = $rootScope.AuthParams;
            
            // Configurar New Relic INMEDIATAMENTE si ya hay datos en localStorage
            // Esto asegura que el PRIMER PageView incluya los custom attributes básicos
            if (window.newrelic) {
                try {
                    // PASO 0: Leer cliente desde CONFIGURATION (dinámico por ambiente)
                    var clienteId = CONFIGURATION.clienteId || 'unknown';
                    var clienteNombre = CONFIGURATION.clienteNombre || clienteId;
                    var hostname = window.location.hostname;
                    
                    window.newrelic.setCustomAttribute('cliente_id', clienteId);
                    window.newrelic.setCustomAttribute('cliente_nombre', clienteNombre);
                    window.newrelic.setCustomAttribute('cliente_hostname', hostname);
                    console.log('[New Relic] Cliente configurado:', clienteId, '-', clienteNombre);
                    
                    // PASO 1: Configurar Device ID SIEMPRE (antes que nada)
                    // Esto permite identificar equipos únicos incluso con usuarios compartidos
                    var deviceId = localStorage.getItem('NR_DEVICE_ID');
                    if (!deviceId) {
                        // Generar fingerprint si no existe
                        var fingerprint = {
                            ua: navigator.userAgent,
                            screen: screen.width + 'x' + screen.height + 'x' + screen.colorDepth,
                            tz: new Date().getTimezoneOffset(),
                            lang: navigator.language || navigator.userLanguage,
                            cores: navigator.hardwareConcurrency || 0,
                            mem: navigator.deviceMemory || 0,
                            platform: navigator.platform,
                            vendor: navigator.vendor || ''
                        };
                        
                        var hash = 0;
                        var str = JSON.stringify(fingerprint);
                        for (var i = 0; i < str.length; i++) {
                            var char = str.charCodeAt(i);
                            hash = ((hash << 5) - hash) + char;
                            hash = hash & hash;
                        }
                        
                        deviceId = 'dev_' + Math.abs(hash).toString(36);
                        localStorage.setItem('NR_DEVICE_ID', deviceId);
                    }
                    
                    window.newrelic.setCustomAttribute('device_id', deviceId);
                    
                    // PASO 2: Características básicas del equipo
                    if (window.screen) {
                        window.newrelic.setCustomAttribute('screen_resolution', window.screen.width + 'x' + window.screen.height);
                    }
                    if (navigator.hardwareConcurrency) {
                        window.newrelic.setCustomAttribute('cpu_cores', navigator.hardwareConcurrency);
                    }
                    if (navigator.deviceMemory) {
                        window.newrelic.setCustomAttribute('device_memory_gb', navigator.deviceMemory);
                    }
                    
                    // PASO 3: Configurar usuario y sucursal si existe sesión
                    if (Auth && Auth.username) {
                        var locacionSeleccionada = JSON.parse(
                            localStorage.getItem("LOCACION_SELECCIONADA")
                        );
                        
                        window.newrelic.setUserId(String(Auth.username));
                        
                        if (locacionSeleccionada) {
                            if (locacionSeleccionada.sucursal) {
                                window.newrelic.setCustomAttribute('sucursal_id', String(locacionSeleccionada.sucursal.id));
                                window.newrelic.setCustomAttribute('sucursal_nombre', locacionSeleccionada.sucursal.nombre);
                            }
                            
                            if (locacionSeleccionada.unidadNegocio) {
                                window.newrelic.setCustomAttribute('unidad_negocio_id', String(locacionSeleccionada.unidadNegocio.id));
                                window.newrelic.setCustomAttribute('unidad_negocio_nombre', locacionSeleccionada.unidadNegocio.nombre);
                            }
                            
                            if (locacionSeleccionada.id) {
                                window.newrelic.setCustomAttribute('locacion_id', String(locacionSeleccionada.id));
                            }
                        }
                    }
                    
                    console.log('[New Relic] Device ID y atributos básicos configurados en run():', deviceId);
                } catch (e) {
                    console.error('[New Relic] Error al configurar atributos en run():', e);
                }
            }
            
            // PASO 2: Continuar con el flujo normal de autenticación
            if (Auth && Auth.accessToken && Auth.permissions) {
                AuthorizationService.setupCredentials(
                    Auth.username,
                    Auth.requestToken,
                    Auth.accessToken,
                    function() {
                        AuthenticationService.postLogin(
                            $rootScope.AuthParams
                        ).$promise.then(function(data) {
                            $rootScope.AuthParams.accesoSistema = data;
                            $rootScope.AuthParams.locacionSeleccionada = JSON.parse(
                                localStorage.getItem("LOCACION_SELECCIONADA")
                            );
                            $http.defaults.headers.common["X-Access"] =
                                $rootScope.AuthParams.accesoSistema.accesos[0].locacion.id;
                            $rootScope.$broadcast("locacionChanged", true);
                            
                            // PASO 3: Completar el tracking con información adicional (nombre, rol, IP)
                            NewRelicTracking.trackUser($rootScope.AuthParams);
                        });
                    }
                );
            }

            $rootScope.$on("$stateChangeStart", function(event, toState) {
                // console.log("stateChangeStart to: ", toState);
                if (toState.name !== "login"  && !$rootScope.AuthParams.accessToken) {
                    event.preventDefault();
                    if (toState.name !== "lock") {
                        $state.go("lock");
                    }else {
                        $state.go("login");
                    }
                    return;
                }

              /*  if (toState.name !== "lock"  && !$rootScope.AuthParams.accessToken) {
                    event.preventDefault();
                    $state.go("lock");
                    return;
                } */

                if (toState.name !== "login" && toState.name !== "logout") {
                    if ($rootScope.AuthParams.accessToken) {
                        if (!$rootScope.wsinit) {
                            //$log.debug("No se entró al login y se cuenta con accessToken");
                            //$log.debug("A punto de abrir socket");
                            NotificacionesWSFactory.init($rootScope.AuthParams.username);
                            $rootScope.auxiliarUsername = $rootScope.AuthParams.username;

                            //$rootScope.auxiliarNombreUsuario = data.nombres;
                            //$rootScope.auxiliarNombreUsuario = data.nombres;

                            //$log.debug("A punto de traer notificaciones");
                            //$log.debug("A punto de registrar observer de notificaciones");
                            NotificacionesWSFactory.registerMessageObserver(
                                onNotificationRecibida
                            );
                            $rootScope.cantNotificacionesNoLeidas = cantNotificacionesNoLeidas;
                            $rootScope.notificacionModal = notificacionModal;
                            $rootScope.wsinit = true;
                        }

                        if (toState.name == "app.main" ||  toState.name == "lock"  ) {
                            return;
                        }

                        var stopWatchingCollection = $rootScope.$watchCollection(
                            "AuthParams.permissions",
                            function(perm) {
                                // console.log(
                                //     "stateChange AuthParams.permissions watcher triggered: ",
                                //     toState
                                // );
                                if (!$rootScope.AuthParams.permissions) {
                                    return;
                                }

                                if ($stateParams && $stateParams.esAccesoInterno) {
                                    console.log("Acceso interno permitido a:", toState.name);
                                    stopWatchingCollection();
                                    return;
                                }

                                if (toState.name == "app.main") {
                                    stopWatchingCollection();
                                    return;
                                }
                                var splittedEstado = toState.name.split(".");
                                var entidad = splittedEstado[splittedEstado.length - 2];
                                var form = splittedEstado[splittedEstado.length - 1];
                                var mapa = {
                                    new: "create",
                                    edit: "update",
                                    list: "index",
                                    view: "index"
                                };
                                if (!entidad || !form) {
                                    rebotar(toState);
                                    stopWatchingCollection();
                                    return;
                                }
                                var permisoRegular = mapa[form] + "_" + entidad;
                                var permisoCustom =
                                    mapa[form] + "_" + statePermissionMapping[entidad];
                                // Caso especial: si es comprobanteventa.edit, permitir ambos permisos
                                var permisosAlternativos = [];
                                if ((entidad === "comprobanteventa" || entidad === "consultacomprobantesventa") && form === "edit") {
                                    permisosAlternativos = [
                                        "updatenotacreditoventa_comprobanteventa"
                                    ];
                                }

                                if (!_.find($rootScope.AuthParams.permissions, function(perm) {
                                        return (
                                            perm == permisoRegular ||
                                            perm == permisoCustom ||
                                            perm == statePermissionMapping[toState.name] ||
                                            permisosAlternativos.includes(perm)
                                        );
                                    })) {
                                    console.log("Se rebota intento a: ", toState);
                                    console.log("No cuenta con permiso " + permisoRegular + " ni " + permisoCustom);
                                    rebotar(toState);
                                    stopWatchingCollection();
                                    return;
                                }
                                stopWatchingCollection();
                            }
                        );

                    }
                }
            });

            $rootScope.$state = $state;
            $rootScope.$stateParams = $stateParams;

            function rebotar(toState) {
                notify.closeAll();
                notify({
                    message: "No posee los permisos necesarios para realizar la operación",
                    classes: "alert-danger",
                    position: "right"
                });
                if (!_.find(dontRedirectArray, function(ruta) {
                        return toState.name.includes(ruta.state);
                    })) {
                    $state.go("app.main");
                }
            }

            function onNotificationRecibida(mensaje) {
                // $log.debug("Se hizo trigger a onNotificacionRecibida de config.router");
                //parseamos mensaje
                if (!$rootScope.notificaciones) {
                    $rootScope.notificaciones = [];
                }
                // $log.info("Notificacion recibida en config.router: ");
                var msg = JSON.parse(mensaje.data);
                (msg.totalnotificaciones!=null) ? $rootScope.totalnotificaciones = msg.totalnotificaciones : $rootScope.totalnotificaciones = 0;

                if (msg.tipo && msg.tipo === "navbar") {
                    $rootScope.notificaciones = msg.notificaciones;
                    $rootScope.notificaciones.forEach(function(element, key) {
                        $rootScope.notificaciones[key].fecha = moment(element.fecha).format("D MMM YYYY");
                    });
                } else if (msg.tipo && msg.tipo === "list") {
                    return; //no corresponde parsear notificaciones para la lista de ver todas
                } else if (msg.constructor !== Array) {
                    //$log.info("Es un mensaje singular: ");
                    //$log.info(msg);
                    if ($rootScope.notificaciones.length >= 9) {
                        $rootScope.notificaciones.splice(7, 2);
                    }
                    $rootScope.notificaciones.unshift(msg);
                    //enviamos response de entregada al backend
                    NotificacionesWSFactory.sendAction("ack", msg);
                    //$log.info("ack enviado a backend");
                }
            }

            function notificacionModal(notificacion) {
                $rootScope.tituloModal = notificacion.titulo;
                $rootScope.mensajeModal = notificacion.descripcion;
                var modalInstance = $modal.open({
                    templateUrl: "views/directives/notification-modal.html",
                    scope: $rootScope
                });

                $rootScope.ok = function(itemId) {
                    $rootScope.mensajeModal = null;
                    modalInstance.close();
                };

                //marcamos notificacion como leida si no lo está

                if (notificacion.estado.codigo !== "notificacion_leida") {
                    NotificacionesWSFactory.sendAction("did_read", notificacion);
                    notificacion.estado.codigo = "notificacion_leida";
                }
                localStorage.setItem(
                    "NOTIFICACIONES",
                    JSON.stringify($rootScope.notificaciones)
                );
            }

            function cantNotificacionesNoLeidas() {
                var count = 0;
                if (!$rootScope.notificaciones) {
                    return count;
                }
                for (var i = 0; i < $rootScope.notificaciones.length; i++) {
                    if (
                        $rootScope.notificaciones[i].estado &&
                        $rootScope.notificaciones[i].estado.codigo !== "notificacion_leida"
                    ) {
                        count = count + 1;
                      }
                }
                return count;
            }
        }
    ]);
/* Multi-Tenant Fargate - ambiente TEST (QUAL-36828).
   Igual que parametros.multitenant.js salvo serverIp, que apunta a la API del
   ambiente test. Antes no existia este archivo y deploy-frontend.sh usaba el de
   produccion por defecto, asi que la SPA de test quedaba hablando con la API de
   produccion. */
angular.module('qualita').constant('CONFIGURATION', {
    serverName: "qualita-client",
    serverNameWS: "qualita-client",
    serverIp: "api-qualita-mt-test.sistematdn.com.py",
    serverPort: "443",
    serverAPI: "rest",
    serverFE: "https://test.kigafe.com:8443/dpy-testfe/rest/reportes/factura?cdc=",
    serverFERecibo: "https://test.kigafe.com:8443/dpy-testfe/rest/reportes/recibo?",
    clienteId: "multitenant",
    clienteNombre: "Qualita Multitenant (test)",
    // Version en prueba; produccion muestra la constante VERSION de app.js.
    version: "4.0.2.0"
  });

"use strict";

var app = angular
  .module("qualita")
  .constant("statePermissionMapping", {
    ordenescompra: "orden_compra",
    remision: "remisiones",
    pedidosventa: "pedidoventas",
    compraslocales: "compra",
    cierre: "compra",
    "app.importaciones.proceso.cierre": "index_importaciones",
    "app.importaciones.proceso.comprobante.apply": "update_comprobante",
    "app.compraslocales.proceso.comprobante.apply": "update_comprobante",
    "app.ventas.proceso.comprobanteventa.apply": "update_comprobanteventa",
    solicitud_compra_importacion: "solicitudescompra",
    "app.productos.edit2": "update_productos",
    consultacomprobantes: "comprobante",
    "app.consultacomprobantes.apply": "update_comprobante",
    consultacomprobantesventa: "comprobanteventa",
    comprobanteventaagil: "comprobanteventa",
    //"app.consultacomprobantes.apply": "update_comprobanteventa",
    "app.consultacomprobantesventa.applyadd": "update_comprobanteventa",
    "app.consultacomprobantesventa.applyedit": "update_comprobanteventa",
    consultacompras: "compra",
    consultarecepciones: "recepcion",
    procesoscobro: "procesocobro",
    "app.procesoscobro.proceso.cierre.list": "index_procesocobro",
    "app.procesoscobro.verproceso.cierre.list": "index_procesocobro",
    librocompra: "compra",
    embarques: "embarque",
    "app.importaciones.proceso.solicitudes.list": "index_solicitud_pago",
    "app.importaciones.proceso.solicitudes.new": "create_solicitud_pago",
    "app.importaciones.proceso.solicitudes.edit": "update_solicitud_pago",
    "app.importaciones.proceso.solicitudes.view": "index_solicitud_pago",
    proformas: "proforma",
    "app.consultaproforma.list": "index_proforma",
    "app.consultaproforma.view": "update_proforma",
    //"app.consultaproforma.list": "index_consultaproforma",
    recepcionimportacion: "recepcion",
    "app.planpagos.detalles.list": "index_planpagosdetalle",
    "app.planpagos.detalles.new": "create_planpagosdetalle",
    "app.planpagos.detalles.edit": "update_planpagosdetalle",
    "app.planpagos.detalles.view": "index_planpagosdetalle",
    "app.plancobros.detalles.list": "index_plancobrosdetalle",
    "app.plancobros.detalles.new": "create_plancobrosdetalle",
    "app.plancobros.detalles.edit": "update_plancobrosdetalle",
    "app.plancobros.detalles.view": "index_plancobrosdetalle",
    consultamovimiento: "movimientostock",
    reprocesomovimiento: "movimientostock",
    consultamovimiento2: "movimientostock",
    inventariovalorizado: "productoalmacen",
    clasificacionbobinas: "recepciondetalle",
    fraccionamientobobinas: "fraccionamiento",
    inventario: "inventarios",
    "app.inventario.proceso.apertura.list": "index_inventarios",
    "app.inventario.proceso.apertura.view": "index_inventarios",
    "app.inventario.proceso.cierre.list": "index_cierreinventarios",
    conteo: "conteos",
    "app.movimientobancario.consulta": "index_movimientobancario",
    "app.tesaka.list": "index_tesakaDetalle",
    "app.tesaka.carga": "upload_tesaka",
    "app.tesaka.upload": "upload_tesaka",
    "app.tesaka.erroresjson": "index_tesakaDetalle",
    "app.tesaka.errorescsv": "index_tesakaDetalle",
    salariosbasicos: "empleados",
    amonestacionempleado: "amonestaciones",
    resumenasistencia: "asistencia",
    "app.roles.clone": "create_roles",
    "app.importarcomprobante": "update_comprobanteretencion",
    "app.ordenpago.aplicaranticipo": "update_ordenpago",
    "app.configmarcaciones": "reprocesar_marcaciones",
    "app.reprocesarmarcaciones": "reprocesar_marcaciones",
    "app.importarmarcaciones": "importar_marcaciones",
    "app.usuarios.changepassword": "update_usuarios",
    "app.lineasproducto.details": "index_lineasproducto",
    ventas: "venta",
    "app.ventas.proceso.cierre.list": "index_venta",
    "app.clientes.carga": "create_clientes",
    "app.ordenpago.edit2": "update_ordenpago",
    "app.ordenpago.view2": "index_ordenpago",
    "app.listaprecioventa.carga": "create_listaprecioventa",
    cobro: "cobros",
    "app.cobro.aplicaranticipo":"create_cobros",
    depositocobranza: "movimientobancario",
    consultadespacho: "despacho",
    "app.consultadespacho.list": "index_despacho",
    consultacheque: "cheques",
    cambioprecio: "cambioprecio",
    consultacambioprecio: "cambiopreciohistorico",
    "app.consultacambioprecio.list": "index_cambiopreciohistorico",
    cambioprecioservicio: "cambioprecioservicio",
    "app.cambioprecioservicio.list": "index_cambioprecioservicio",
    "app.consultacambioprecioservicio.list": "index_cambiopreciohistorico",
    cambioprecio: "cambioprecio",
    entidades: "entidades",
    "app.entidades.list": "index_entidades",
    "app.cuentacontable.list" : "index_cuentacontable",
    "app.estadocuentaproveedor.list": "index_estadocuentaproveedores",
    "app.comprobantespendientesclientes.list":"consulta_comprobantes_pendientes_cliente",
    consultasaldoproveedor: "saldoproveedores",
    "app.comprobantespendientes.list": "consulta_comprobantes_pendientes",
    consultasaldoproveedor: "saldoproveedores",
    "app.consultacomprobantes.editAprobado": "update_comprobantes_aprobados",
    "app.referencias.list": "index_referencias",
    "app.comprobantesventaplanilla.list":"consulta_reporte_planilla",
    "app.contribuyentes.carga": "importar_contribuyentes",
    "app.importarprecio": "importar_importarprecio",
    "app.ordenproduccion.entregaadd": "entrega_materiaprima",
    "app.ordenproduccion.entregaedit": "entrega_materiaprima",
    "app.ordenproduccion.entregaview": "entrega_materiaprima",
    "app.ordenproduccion.procesaradd": "procesar_ordenproduccion",
    "app.ordenproduccion.procesaredit": "procesar_ordenproduccion",
    "app.ordenproduccion.procesarview": "procesar_ordenproduccion",
    "app.ordenproduccion.devolucionadd": "entrega_materiaprima",
    "app.ordenproduccion.devolucionedit": "entrega_materiaprima",
    "app.ordenproduccion.devolucionview": "entrega_materiaprima",
    "app.consultacobro.list": "index_cobrodetalle",
    "app.consultamovimientosimple.list": "index_consultamovimientosimple",
    "app.inventarioproductos.list": "index_inventarioproductos",
    "app.importaremision": "update_remisiones",
    "app.catalogos.carga": "create_catalogos",
    "app.arqueocajaventa.editInterno":"create_arqueocajaventa",
    "app.consultacobromovil.list": "index_consultacobromovil",
  })
  .constant("dontRedirectArray", [
    {
      path: "/compras/proceso",
      state: "app.compraslocales.proceso"
    },
    {
      path: "/importaciones/proceso",
      state: "app.importaciones.proceso"
    },
    {
      path: "/inventario/proceso",
      state: "app.inventario.proceso"
    }
  ])
  .config([
    "$controllerProvider",
    "$compileProvider",
    "$filterProvider",
    "$provide",
    "$translateProvider",
    "$translatePartialLoaderProvider",
    function(
      $controllerProvider,
      $compileProvider,
      $filterProvider,
      $provide,
      $translateProvider,
      $translatePartialLoaderProvider
    ) {
      app.controller = $controllerProvider.register;
      app.directive = $compileProvider.directive;
      app.filter = $filterProvider.register;
      app.factory = $provide.factory;
      app.service = $provide.service;
      app.constant = $provide.constant;
      app.value = $provide.value;

      $translatePartialLoaderProvider.addPart("home");

      $translateProvider.useLoader("$translatePartialLoader", {
        urlTemplate: "languages/{part}/{lang}.json"
      });
      $translateProvider.preferredLanguage("spanish");
    }
  ]);

app.config(["$breadcrumbProvider", function($breadcrumbProvider) {
  $breadcrumbProvider.setOptions({
    templateUrl: "views/partials/breadcrumb.template.html",
    includeAbstract: true
  });
}]);

app.config([
  "fcsaNumberConfigProvider",
  function(fcsaNumberConfigProvider) {
    fcsaNumberConfigProvider.setDefaultOptions({
      preventInvalidInput: true
    });
  }
]);

app.config(["flowFactoryProvider", "baseurlProvider", "CONFIGURATION", function(flowFactoryProvider, baseurlProvider, CONFIGURATION) {
  baseurlProvider.setConfig(CONFIGURATION);



  flowFactoryProvider.defaults = {
    method: "octet",
    target: baseurlProvider.$get().getBaseUrl() + "/adjuntos",
    //target: 'http://' + Config.serverIp +':8080/qualitaTest/rest/adjuntos'

    // QUAL-37399: pide a los servicios de subida de importacion (importacionUpload,
    // clienteUpload, contribuyenteUpload) que guarden el archivo como
    // '<identificador>-<nombre>' y devuelvan ese nombre. Un backend sin el cambio
    // ignora el parametro y guarda con el nombre original; el handler de
    // fileSuccess de mas abajo cubre los dos casos. /adjuntos lo ignora: ya
    // guardaba siempre con el identificador.
    query: { flowNaming: 'identificador' },

    // QUAL-37399: el identificador por defecto de flow.js es "tamano-nombre".
    // El backend guarda cada archivo como "<identificador>-<nombre>" en una
    // carpeta comun a todas las empresas (upload.dir, EFS en Multitenant) y lleva
    // el registro de partes subidas en un mapa por identificador, tambien comun.
    // Con el default, dos empresas que suben un archivo con el mismo nombre y el
    // mismo tamano escriben en el mismo archivo: una importacion de una empresa
    // puede terminar procesando los datos de la otra. Con un valor aleatorio
    // delante, cada subida es unica entre empresas y entre usuarios, y el nombre
    // deja de ser adivinable. El resto del nombre se mantiene para que siga
    // siendo legible.
    //
    // Los adjuntos (/adjuntos) arman el nombre como uniqueIdentifier + '-' + name.
    // Las importaciones no: guardaban con el nombre original sin importar el
    // identificador, y por eso seguian colisionando (CP01, QUAL-37544). Lo
    // resuelven query.flowNaming y el handler de fileSuccess. ng-flow aplica estos
    // defaults a cada flow-init.
    generateUniqueIdentifier: function(file) {
      var aleatorio;
      var cripto = window.crypto || window.msCrypto;
      if (cripto && cripto.getRandomValues) {
        var bytes = new Uint8Array(16);
        cripto.getRandomValues(bytes);
        aleatorio = Array.prototype.map.call(bytes, function(b) {
          return ('0' + b.toString(16)).slice(-2);
        }).join('');
      } else {
        aleatorio = (Date.now().toString(16) + Math.random().toString(16).slice(2)
            + Math.random().toString(16).slice(2)).slice(0, 32);
      }
      var nombre = file.relativePath || file.webkitRelativePath || file.fileName || file.name || '';
      return aleatorio + '-' + file.size + '-' + nombre.replace(/[^0-9a-zA-Z_-]/img, '');
    }
  };

  // QUAL-37399: con flowNaming=identificador los servicios de importacion
  // responden "Uploaded:<nombre guardado>". Se guarda en el FlowFile para que la
  // pantalla le pase a la carga el nombre real del archivo en el servidor. Un
  // backend sin el cambio responde "Uploaded" a secas: storedName queda sin
  // definir y la pantalla usa el nombre original, como antes.
  flowFactoryProvider.on('fileSuccess', function(file, message) {
    var prefijo = 'Uploaded:';
    if (typeof message === 'string' && message.indexOf(prefijo) === 0) {
      file.storedName = message.substring(prefijo.length);
    }
  });
}]);

app.config(["routesPermissionsMappingProvider", "statePermissionMapping", function(routesPermissionsMappingProvider, statePermissionMapping) {
  routesPermissionsMappingProvider.setMapping(statePermissionMapping);
}]);

app.config(["dontRedirectProvider", "dontRedirectArray", function(dontRedirectProvider, dontRedirectArray) {
  dontRedirectProvider.setArray(dontRedirectArray);
}]);

app.config([
  "$provide",
  function($provide) {
    $provide.decorator("yearpickerDirective", ["$delegate", function($delegate) {
      var directive = $delegate[0];

      directive.templateUrl = "views/widgets/datepicker/year.html";

      return $delegate;
    }]);

    $provide.decorator("monthpickerDirective", ["$delegate", function($delegate) {
      var directive = $delegate[0];

      directive.templateUrl = "views/widgets/datepicker/month.html";

      return $delegate;
    }]);

    $provide.decorator("daypickerDirective", ["$delegate", function($delegate) {
      var directive = $delegate[0];

      directive.templateUrl = "views/widgets/datepicker/day.html";

      return $delegate;
    }]);
  }
]);

app.factory("MyErrorHandler", ["$q", "$log", function($q, $log) {
  return function(part, lang) {
    console.log('The "' + part + "/" + lang + '" part was not loaded.');
    return $q.when({});
  };
}]);

app.config([
  "schemaFormProvider",
  "schemaFormDecoratorsProvider",
  "sfPathProvider",
  function(schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
    schemaFormDecoratorsProvider.addMapping(
      "bootstrapDecorator",
      "customcheckbox",
      "views/widgets/custom-checkbox.html"
    );
    schemaFormDecoratorsProvider.addMapping(
      "bootstrapDecorator",
      "switch",
      "views/widgets/custom-checkbox-switch.html"
    );

    var datepicker = function(name, schema, options) {
      if (
        schema.type === "string" &&
        (schema.format === "date" || schema.format === "date-time")
      ) {
        var f = schemaFormProvider.stdFormObj(name, schema, options);
        f.key = options.path;
        f.type = "datepicker";
        //f.ngModelOptions = {allowInvalid: true};
        options.lookup[sfPathProvider.stringify(options.path)] = f;
        return f;
      }
    };

    schemaFormProvider.defaults.string.unshift(datepicker);

    //Add to the bootstrap directive
    schemaFormDecoratorsProvider.addMapping(
      "bootstrapDecorator",
      "datepicker",
      "views/directives/datepicker.html"
    );
    schemaFormDecoratorsProvider.createDirective(
      "datepicker",
      "views/directives/datepicker.html"
    );
  }
]);

/**
 * AngularJS default filter with the following expression:
 * "person in people | filter: {name: $select.search, age: $select.search}"
 * performs a AND between 'name: $select.search' and 'age: $select.search'.
 * We want to perform a OR.
 */
angular.module('qualita').filter('propsFilter', function() {
  return function(items, props) {
    var out = [];
    console.log("PROPSFILTER!!");

    if (angular.isArray(items)) {
      var keys = Object.keys(props);

      items.forEach(function(item) {
        var itemMatches = false;

        for (var i = 0; i < keys.length; i++) {
          var prop = keys[i];
          var text = props[prop].toLowerCase();
          if (item[prop] && item[prop].toString().toLowerCase().indexOf(text) !== -1) {
            itemMatches = true;
            break;
          }
        }

        if (itemMatches) {
          out.push(item);
        }
      });
    } else {
      // Let the output be the input untouched
      out = items;
    }

    return out;
  };
});

'use strict';

angular.module('qualita')
    .controller('AppCtrl', [
        '$rootScope', '$localStorage', '$state', '$http', 'SucursalesFactory', 'UnidadesNegocioFactory', '$log',
        '$modal', 'AccesosSistemaFactory', '$translate', 'amMoment', '$scope', 'notify','MenuJsonFactory','baseurl','NewRelicTracking',
        function($rootScope, $localStorage, $state, $http, SucursalesFactory, UnidadesNegocioFactory, $log, $modal,
            AccesosSistemaFactory, $translate, amMoment, $scope, notify,MenuJsonFactory,baseurl,NewRelicTracking) {

            $rootScope.updateAccesoSistema = updateAccesoSistema;
            $rootScope.cargarEmpresaConectada = cargarEmpresaConectada;

            /**
             * QUAL-36855: deja en $rootScope el nombre de la empresa a la que
             * esta conectado el usuario, para mostrarlo fijo en la barra
             * superior junto a notificaciones y nombre de usuario.
             *
             * Vive en $rootScope y la barra esta fuera del ui-view, asi que el
             * dato se mantiene al navegar entre formularios sin volver a
             * pedirlo. Se llama desde activate(), que corre tanto despues del
             * login como al recargar la pagina.
             *
             * El nombre sale del parametro nombre_empresa de la base del tenant
             * en curso, que es lo que el usuario reconoce como "su empresa" y
             * lo mismo que sale en sus comprobantes. En multi-tenant, ademas,
             * identifica al tenant conectado.
             *
             * NO se usa la tabla empresa: existe en el esquema pero esta vacia
             * en los 9 tenants, asi que no sirve como fuente.
             */
            function cargarEmpresaConectada() {
                var filtro = {
                    type: 'and',
                    filters: [{ path: 'codigo', equals: 'nombre_empresa' }]
                };
                $http.get(baseurl.getBaseUrl() + '/parametros', {
                        params: { search: JSON.stringify(filtro) }
                    })
                    .then(function(response) {
                        var parametros = response.data;
                        if (angular.isArray(parametros) && parametros.length > 0) {
                            var valor = parametros[0].valor;
                            if (valor && valor.trim() !== '') {
                                $rootScope.empresaConectada = valor.trim();
                            }
                        }
                    }, function(error) {
                        // No romper la navegacion por no poder mostrar el nombre.
                        $log.warn('No se pudo obtener la empresa conectada', error);
                    });
            }

            function activate() {
                amMoment.changeLocale('es');
                setLandingData ();
                cargarEmpresaConectada();
                $rootScope.auxiliarNombreUsuario = $rootScope.AuthParams.accesoSistema.nombres;
                $rootScope.AuthParams.locaciones = _.map($rootScope.AuthParams.accesoSistema.accesos, function(acceso) {
                    return acceso.locacion;
                });

                if ($rootScope.AuthParams.accesoSistema.foto) {
                    $rootScope.userAvatar = $rootScope.publicBaseURL + $rootScope.AuthParams.accesoSistema.foto;
                } else {
                    $rootScope.userAvatar = "images/avatar.png";
                }

                var sucursales = _.map($rootScope.AuthParams.locaciones, function(locacion) {
                    return locacion.sucursal;
                });

                // Eliminar sucursales duplicadas,
                // el modelo de datos permite que un usuario este asociado varias veces a una misma sucursal.
                sucursales = _.unique(sucursales, function(value){
                    return value.nombre
                });


                $rootScope.sucursales = [];

                for (var i = 0; i < sucursales.length; i++) {
                    SucursalesFactory.get(sucursales[i].id, 'SucursalList').$promise.then(function(response) {
                        if (response.id === $rootScope.AuthParams.locacionSeleccionada.sucursal.id) {
                            $rootScope.AuthParams.suc = response;
                        }
                        $rootScope.sucursales.push(response);
                    });
                }

                var unidadesNegocio = _.map(_.filter($rootScope.AuthParams.locaciones, function(locacion) {
                    return locacion.sucursal.id == $rootScope.AuthParams.locacionSeleccionada.sucursal.id;
                }), function(locacion) {
                    return locacion.unidadNegocio;
                });
                $rootScope.unidadesNegocio = unidadesNegocio;

                for (var i = 0; i < unidadesNegocio.length; i++) {
                    if (unidadesNegocio[i].id === $rootScope.AuthParams.locacionSeleccionada.unidadNegocio.id) {
                        $rootScope.AuthParams.un = unidadesNegocio[i];
                    }
                }
            }

            function updateAccesoSistema() {
                AccesosSistemaFactory.get($rootScope.AuthParams.accesoSistema.id, "AccesoSistemaList").$promise.then(
                    function(response) {
                        $rootScope.AuthParams.accesoSistema = response;
                        var accesoDefault = _.find($rootScope.AuthParams.accesoSistema.accesos, function(acceso) {
                            return acceso.accesoPorDefecto = true;
                        });
                        $rootScope.AuthParams.locacionSeleccionada = accesoDefault.locacion;
                        localStorage.setItem('LOCACION_SELECCIONADA', JSON.stringify($rootScope.AuthParams.locacionSeleccionada));
                        $http.defaults.headers.common['X-Access'] = $rootScope.AuthParams.accesoSistema.accesos[0].locacion.id;
                    });
            }


            $rootScope.$watch('AuthParams.accesoSistema', function() {
                if (!$rootScope.AuthParams.accesoSistema) {
                    return;
                }
                activate();
            });

            $rootScope.sucursalSelected = function() {
                if (!$rootScope.AuthParams.suc) {
                    return;
                }
                var sucId = $rootScope.AuthParams.suc.id;
                var unidadesNegocio = _.map(_.filter($rootScope.AuthParams.locaciones, function(locacion) {
                    return locacion.sucursal.id == sucId;
                }), function(locacion) {
                    return locacion.unidadNegocio;
                });
                $rootScope.AuthParams.un = undefined;
                $rootScope.unidadesNegocio = unidadesNegocio;
                /*for(var i = 0; i < unidadesNegocio.length; i++) {
                  $rootScope.unidadesNegocio.push(UnidadesNegocioFactory.get(unidadesNegocio[i]));
                }*/
            };

            $rootScope.locacionAccepted = function() {
                console.log('locacionAccepted');
                if (!$rootScope.AuthParams.un) {
                    console.log('1');
                    var msg = "Debe elegir una Unidad de Negocio";
                    notify({ message: msg, classes: 'alert-danger', position: 'right' });
                
                    //$rootScope.AuthParams.suc = $rootScope.oldSuc;
                    //$rootScope.AuthParams.un = $rootScope.oldUn;
                   // return;
                }
                    var unId = $rootScope.AuthParams.un.id;
                    var sucId = $rootScope.AuthParams.suc.id;
                    if (unId && sucId) {
                        // $log.debug(unId);
                        // $log.debug(sucId);
                        $rootScope.AuthParams.locacionSeleccionada = _.find($rootScope.AuthParams.locaciones, function(locacion) {
                            return locacion.unidadNegocio.id === unId && locacion.sucursal.id === sucId;
                        });
                        if ($rootScope.AuthParams.locacionSeleccionada) {
                            //$rootScope.$broadcast("locacionChanged", true);
                            // $log.debug("se actualizó la locación seleccionada:");
                            // $log.debug($rootScope.AuthParams.locacionSeleccionada);
                            localStorage.setItem('LOCACION_SELECCIONADA', JSON.stringify($rootScope.AuthParams.locacionSeleccionada));
                            
                            // Actualizar tracking de New Relic cuando cambia la locación
                            NewRelicTracking.updateLocacion($rootScope.AuthParams.locacionSeleccionada);
                        }
                    }
                
            };

            $rootScope.selectedItem;
            $rootScope.selectedItem2;

            function changeLanguage(idioma) {
                $translate.use(idioma);
            }

            function setLandingData () {
                var fechainicio = moment($rootScope.AuthParams.accesoSistema.fechaCreacion);
                var fechahoy = moment(new Date());
                $scope.diastrabajados = fechahoy.diff(fechainicio, 'days');
                setDate();
            }

            function setDate(){
                $scope.date = moment().format("dddd D, MMMM YYYY").toLowerCase();
            }

            $rootScope.items = [
                { idioma: "Español", imagen: "/images/icono_espana.png" },
                { idioma: "Ingles", imagen: "/images/icono_eeuu.png" },
                { idioma: "Guarani", imagen: "/images/icono_paraguay.png" },
            ];

            $rootScope.change = function(idioma) {
                if (idioma !== undefined) {

                    if (idioma == "Español") {
                        amMoment.changeLocale('es');
                        changeLanguage("spanish");
                        setDate();
                    }

                    if (idioma == "Ingles") {
                        changeLanguage("english");
                        amMoment.changeLocale('en-au');
                        setDate();
                    }

                    if (idioma == "Guarani") {
                        changeLanguage("guarani");
                    }

                    return "" + $rootScope.selectedItem2;
                } else {
                    return "Elija un idioma";
                }
            };

            $rootScope.changeLocacion = function() {
                $rootScope.oldSuc = $rootScope.AuthParams.suc;
                $rootScope.oldUn = $rootScope.AuthParams.un;
                var modalInstance = $modal.open({
                    templateUrl: 'views/directives/locacion-modal.html',
                    scope: $rootScope
                });

                $rootScope.cancel = function() {
                    $rootScope.AuthParams.suc = $rootScope.oldSuc;
                    $rootScope.AuthParams.un = $rootScope.oldUn;
                    modalInstance.dismiss('cancel');
                };

                $rootScope.ok = function(itemId) {
                    $rootScope.locacionAccepted();
                    modalInstance.close();
                    //$state.go($state.current, {}, {reload: true});
                    $rootScope.$broadcast("locacionChanged", true);
                };
            };
            $rootScope.query = {};

            $rootScope.settings = {
                skin: '',
                color: {
                    themeprimary: '#2dc3e8',
                    themesecondary: '#fb6e52',
                    themethirdcolor: '#ffce55',
                    themefourthcolor: '#a0d468',
                    themefifthcolor: '#e75b8d'
                },
                rtl: false,
                fixed: {
                    navbar: false,
                    sidebar: false,
                    breadcrumbs: false
                }
            };
            if (angular.isDefined($localStorage.settings))
                $rootScope.settings = $localStorage.settings;
            else
                $localStorage.settings = $rootScope.settings;

            $rootScope.$watch('settings', function() {
                if ($rootScope.settings.fixed.breadcrumbs) {
                    $rootScope.settings.fixed.navbar = true;
                    //$rootScope.settings.fixed.sidebar = true;
                }
                // if ($rootScope.settings.fixed.sidebar)
                //     $rootScope.settings.fixed.navbar = true;

                $localStorage.settings = $rootScope.settings;
            }, true);

            $rootScope.$watch('settings.rtl', function() {
                if ($state.current.name != "persian.dashboard" && $state.current.name != "arabic.dashboard") {
                    switchClasses("pull-right", "pull-left");
                    switchClasses("databox-right", "databox-left");
                    switchClasses("item-right", "item-left");
                }

                $localStorage.settings = $rootScope.settings;
            }, true);

            $rootScope.$on('$viewContentLoaded',
                function(event, toState, toParams, fromState, fromParams) {
                    if ($rootScope.settings.rtl && $state.current.name != "persian.dashboard" && $state.current.name != "arabic.dashboard") {
                        switchClasses("pull-right", "pull-left");
                        switchClasses("databox-right", "databox-left");
                        switchClasses("item-right", "item-left");
                    }
                    if ($state.current.name == 'error404') {
                        $('body').addClass('body-404');
                    }
                    if ($state.current.name == 'error500') {
                        $('body').addClass('body-500');
                    }
                });
                if($rootScope.mainMenu == undefined){
                    AccesosSistemaFactory.downloadMenuJson();
                }
         }
    ]);

angular.module('qualita')
  .controller('ProfileCtrl', ProfileCtrl);

ProfileCtrl.$inject = ['$rootScope', 'AccesosSistemaFactory', '$scope', '$log', '$location', 'AuthorizationLangFactory',
  '$state', 'baseurl', 'ModelTrimmer', '$stateParams', 'UsuariosFactory', 'filterFactory', '$filter'];

function ProfileCtrl($rootScope, AccesosSistemaFactory, $scope, $log, $location, AuthorizationLangFactory, $state,
  baseurl, ModelTrimmer, $stateParams, UsuariosFactory, filterFactory, $filter, $injector, $q) {
  var vm = this;

  vm.idUsuario = $stateParams.idUsuario;

  vm.submit = submit;


  $rootScope.$watch('AuthParams.accesoSistema', function() {
                if (!$rootScope.AuthParams.accesoSistema) {
                    return;
                }
                activate();
            });

  function activate() {
    vm.isEdit = false;
    
    AuthorizationLangFactory.getTranslations().then(function (translations) {
        vm.translations = translations;
        vm.isAsync = true;
        vm.accesosLoaded = false;
        vm.title = $filter('translate')('EDITAR_ACCESO_SISTEMA');
        var staticFilter = {};
        staticFilter.search = filterFactory.and([{
            path: 'usuario.id',
            equals: vm.idUsuario
        }]).value();

        vm.isEdit = true;

        AccesosSistemaFactory.get($rootScope.AuthParams.accesoSistema.id, 'AccesoSistemaList').$promise.then(function (data) {
            vm.accesoSistema = data;
            vm.accesosLoaded = true;

            var imagePath = "images/placeholder.png";
            if (vm.accesoSistema.foto && vm.accesoSistema.foto !== false)
            imagePath = baseurl.getPublicBaseUrl() + vm.accesoSistema.foto
            vm.uploadOptions = { imageOnly: true, title: $filter('translate')('FOTO'), imagePath: imagePath };
            $scope.entidadId = vm.accesoSistema.id;
            $scope.entidad = "AccesoSistema";
        });

      $rootScope.isProcessing = false;
    });
  }

  function submit() {
    vm.submited = true;
    if ($scope.UserProfileForm && $scope.UserProfileForm.$valid) {
        actualizarPerfil();
    }
  }

  function actualizarPerfil () {
    $rootScope.isProcessing = true;
    submitAccesoSistema().then(function (accesoSistema) {
        $rootScope.updateAccesoSistema();
        vm.hasSaved = true;
        if($scope.$flow != undefined){
            $scope.$flow.files = [];
        }
    });
  }
  function submitAccesoSistema() {
      // Validar que existe sesión activa antes de intentar guardar
      if (!$rootScope.AuthParams || !$rootScope.AuthParams.accessToken) {
        var notify = $injector.get('notify');
        notify.closeAll();
        notify({
          message: "Su sesión ha expirado. Por favor, inicie sesión nuevamente.",
          classes: "alert-warning",
          position: "right",
          duration: 5000
        });
        window.location = '#/login';
        return $q.reject({ error: 'Sesión expirada' });
      }
      
      var trimmedModel = ModelTrimmer.trimDetails(vm.accesoSistema, ['accesos']);
      var accesoSistema = AccesosSistemaFactory.create(trimmedModel);
      return AccesosSistemaFactory.save(accesoSistema);
    }

    $rootScope.modificarFotoPerfil = function(file) {
        vm.accesoSistema.foto = file.uniqueIdentifier + '-' + file.name;
        actualizarPerfil();
    }

  $scope.resource = 'accesosSistema'; //MALA PRACTICA, necesario solo para que funciona offline-recovery
}

'use strict';

/**
 * @ngdoc function
 * @name qualita.controller:HelpCtrl
 * @description
 * # HelpCtrl
 * Controller of the qualita
 */
angular.module('qualita')
  .controller('HelpCtrl', ["$scope", "$state", function ($scope, $state) {
      
      $scope.getIntroOptions = getIntroOptions;

      function getIntroOptions() {
        if ($state.includes("app.importaciones.proceso")) {
          return ImportacionListHelp;
        }
      }

      var ImportacionListHelp = {
        steps:[
        {
            element: '#step1',
            intro: "Todo proceso de importación inicia con la carga de una OC (Orden de Compra). El proveedor y la " +
            "moneda de la OC se mantendrán a lo largo del proceso. <br/>Al cargar una OC, por defecto se mostrarán solo los productos " +
            "del proveedor seleccionado, si quiere ver todos los productos puede hacer click en 'Mostrar todos los productos'. " +
            "Las OC pueden modificarse y/o eliminarse mientras no estén emitidas. <br/>Para emitir una OC debe hacer debe hacer click " +
            " en el botón 'Emitir' de la fila correspondiente.",
            position: 'bottom'
        },
        {
            element: '#step2',
            intro: "Luego se cargan la/s Proforma/s, éstas deben estar asociadas a la OC previamente cargada. Los items pueden ser " +
            "modificados, eliminados y también se pueden agregar nuevos items. <br/>La finalidad de la Proforma es informativa, almacena " +
            "el presupuesto enviado por el proveedor.",
            position: 'bottom'
        },
        {
            element: '#step3',
            intro: "Cada SP (Solicitud de Pago) debe estar asociada a una OC, para que esto sea posible la OC debe estar emitida. <br/>La finalidad " +
            "de las solicitudes de pago también es informativa. <br/>Al cargar una SP se generará y enviará una notificación de sistema y un " +
            "correo al encargado de tesorería.",
            position: 'bottom'
        },
        {
            element: '#step4',
            intro: "El embarque determina las fechas de salida y llegada de los productos, así como los puertos de salida y llegada. " +
            "Además, sirve para indicar los containers con sus respectivos identificadores y pesos. Pueden cargarse uno o varios embarques. " +
            "La finalidad de la carga del embarque es informativa.",
            position: 'bottom'
        },
        {
            element: '#step5',
            intro: "<b>Comprobantes de Importación</b><br/> " +
            "Para cargar un comprobante de importación debe seleccionar una OC, la OC debe estar emitida. Al seleccionar la OC se cargarán " +
            "el proveedor y la moneda, estos datos no podrán ser modificados. Si la moneda no es local se debe especificar el tipo de cambio. " +
            "Se debe especificar además el valor FOB del comprobante. Por último se deben cargar los detalles, indicando el producto, el precio y la cantidad. " +
            "El resto de los campos son calculados automáticamente. Si el producto maneja grupos (serie/lote/bobina) se debe indicar el número de grupo. " +
            "Si el producto tiene vencimiento se debe indicar además la fecha de vencimiento. " +
            "<br/> Observación: en un comprobante de importación todos los productos son excentos. " +
            "<br/><b>Gastos de Importación</b><br/>" +
            "Los gastos no están relacionados a una OC, se debe seleccionar el proveedor y la moneda. Si la moneda no es local se debe especificar el tipo de cambio. " +
            "Se debe especificar los subtotales de cada tipo de impuesto. Por último se deben cargar los detalles, indicando el servicio, el precio y la cantidad. " +
            "El resto de los campos son calculados automáticamente. <br/> Observación: en un comprobante de gastos los servicios pueden ser excentos o no. ",
            position: 'bottom'
        },
        {
            element: '#step6',
            intro: "Las recepciones deben estar asociadas a un OC. Los detalles de la recepción se cargarán automáticamente a partir de los detalles de la OC seleccionada. " +
            "Los detalles pueden ser modificados, eliminados y también se pueden agregar nuevos detalles. En cada detalle debe especifcarse la cantidad recibida y la unidad de medida. " +
            "<br/>Si la unidad de medida de la recepción no es la unidad de medida base del producto puede hacer click en 'Mostrar en unidad de medida base' para ver la cantidad recibida en dicha medida. " +
            "Si el producto maneja grupos (serie/lote/bobina) se debe indicar además el número de grupo recibido.",
            position: 'bottom'
        },
        {
            element: '#step7',
            intro: "El despacho agrupa los gastos y comprobantes de importación. Debe estar asociado a un proveedor (tipo despachante), a una aduana y " +
            "a un regimen de aduana. Si la moneda no es local se debe especificar el tipo de cambio. También se debe indicar los valores de flete y seguro si existen. " +
            "<br/>El despacho es además la parte del proceso donde se realiza la liquidación de impuestos. El campo total liquidación se calcula automáticamente.",
            position: 'bottom'
        },
        {
            element: '#step8',
            intro: "El cierre de la importación es el último paso del proceso. Se muestran resumidamente las OC, Proformas y Embarques asociados a la importación. " +
            "Se muestran además los gastos y comprobantes de la importación, los saldos y costos resultantes y las diferencias en cantidades pedidas, facturadas y recibidas. " +
            "<br/>Para cerrar la importación debe cargar los totales de gastos, de comprobantes, fletes, seguros, la liquidación de impuestos y la suma total de todos éstos. " +
            "<br/>El cierre generará los movimientos de stock correspondientes, tanto de productos como de grupos de productos (lote/serie/bobina). " +
            "Por último se realizará la actualización de saldos de cada producto en sus almacenes correspondientes. ",
            position: 'bottom'
        }]
      };

  }]);

'use strict';

/**
 * @ngdoc function
 * @name qualita.controller:HelpCtrl
 * @description
 * # HelpCtrl
 * Controller of the qualita
 */
angular.module('qualita')
    .factory('UtilFactory', ["$state", "filterFactory", function($state, filterFactory) {

        return {
            // simple filters
            createFilters: function(filters, staticFilters) {

                var filtersDatatable = [];
                _.each(filters, function(search, data) {
                    if (search) {
                        filtersDatatable.push({ path: data, like: search })
                    }
                });
                if (staticFilters) {
                    _.each(staticFilters.search.filters, function(data) {
                        filtersDatatable.push(data);
                    });
                }

                var filters = filterFactory.and(filtersDatatable).value();
                return filters;
            },

            // nested filters
            createNestedFilters: function(filters, staticFilters, viewParam) {
                var filtersDatatable = [];
                var filtersC = _.cloneDeep(filters);
                var staticFiltersC = _.cloneDeep(staticFilters);
                _.each(filtersC, function(search, data) {
                    if (search.equals != undefined) {
                        filtersDatatable.push({ path: search.path, equals: search.equals });
                    } else if (search.like != undefined) {
                        filtersDatatable.push({ path: search.path, like: search.like });
                    } else if (search.equalOrBefore != undefined) {
                        filtersDatatable.push({ path: search.path, equalOrBefore: search.equalOrBefore });
                    } else if (search.equalOrAfter != undefined) {
                        filtersDatatable.push({ path: search.path, equalOrAfter: search.equalOrAfter });
                    } else if (search.greaterThan != undefined) {
                        filtersDatatable.push({ path: search.path, greaterThan: search.greaterThan });
                    } else if (search.lessThan != undefined) {
                        filtersDatatable.push({ path: search.path, lessThan: search.lessThan });
                    } else if (search.sortDesc != undefined) {
                        filtersDatatable.push({ path: search.path, sortDesc: search.sortDesc });
                    } else if (search.sortAsc != undefined) {
                        filtersDatatable.push({ path: search.path, sortAsc: search.sortAsc });
                    } else if (search.isNull != undefined) {
                        filtersDatatable.push({ path: search.path, isNull: search.isNull });
                    } else if (search.isNotNull != undefined) {
                        filtersDatatable.push({ path: search.path, isNotNull: search.isNotNull });
                    } else if (search.notEquals != undefined) {
                        filtersDatatable.push({ path: search.path, notEquals: search.notEquals });
                    } else if (search.greaterOrEqual != undefined) {
                        filtersDatatable.push({ path: search.path, greaterOrEqual: search.greaterOrEqual });
                    } else if (search.lessOrEqual != undefined) {
                        filtersDatatable.push({ path: search.path, lessOrEqual: search.lessOrEqual });
                    }
                });
                if (staticFiltersC) {
                    // entrar al OR y por cada AND agregar todos los filtros de datatable
                    var finalStaticFilter = [];
                    var entro = false;
                    var staticFiltersAnds = staticFiltersC.search.filters;
                    _.each(staticFiltersAnds, function(staticFilter) {
                        if (staticFilter.filters) {
                            _.each(filtersDatatable, function(dtFilter) {
                                staticFilter.filters.push(dtFilter);
                            });
                        } else {
                            if (staticFilter.equals != undefined) {
                                filtersDatatable.push({ path: staticFilter.path, equals: staticFilter.equals });
                            } else if (staticFilter.like != undefined) {
                                filtersDatatable.push({ path: staticFilter.path, like: staticFilter.like });
                            } else if (staticFilter.equalOrBefore != undefined) {
                                filtersDatatable.push({ path: staticFilter.path, equalOrBefore: staticFilter.equalOrBefore });
                            } else if (staticFilter.equalOrAfter != undefined) {
                                filtersDatatable.push({ path: staticFilter.path, equalOrAfter: staticFilter.equalOrAfter });
                            } else if (staticFilter.greaterThan != undefined) {
                                filtersDatatable.push({ path: staticFilter.path, greaterThan: staticFilter.greaterThan });
                            } else if (staticFilter.lessThan != undefined) {
                                filtersDatatable.push({ path: staticFilter.path, lessThan: staticFilter.lessThan });
                            } else if (staticFilter.sortDesc != undefined) {
                                filtersDatatable.push({ path: staticFilter.path, sortDesc: staticFilter.sortDesc });
                            } else if (staticFilter.sortAsc != undefined) {
                                filtersDatatable.push({ path: staticFilter.path, sortAsc: staticFilter.sortAsc });
                            } else if (staticFilter.isNull != undefined) {
                                filtersDatatable.push({ path: staticFilter.path, isNull: staticFilter.isNull });
                            } else if (staticFilter.isNotNull != undefined) {
                                filtersDatatable.push({ path: staticFilter.path, isNotNull: staticFilter.isNotNull });
                            } else if (staticFilter.notEquals != undefined) {
                                filtersDatatable.push({ path: staticFilter.path, notEquals: staticFilter.notEquals });
                            } else if (staticFilter.greaterOrEqual != undefined) {
                                filtersDatatable.push({ path: staticFilter.path, greaterOrEqual: staticFilter.greaterOrEqual });
                            } else if (staticFilter.lessOrEqual != undefined) {
                                filtersDatatable.push({ path: staticFilter.path, lessOrEqual: staticFilter.lessOrEqual });
                            }

                            entro = true;
                        }
                    });
                    if (entro == true) {
                        filtersC = filterFactory.and(filtersDatatable).value();
                    } else {
                        filtersC = filterFactory.or(staticFiltersAnds).value();
                    }
                } else {
                    filtersC = filterFactory.and(filtersDatatable).value();
                }

                if (!viewParam) {
                    viewParam = "BaseList"
                }

                var response = { search: filtersC, view: viewParam };
                return response;
            },

            getAccesosFromUsuarios: function(accesos, usuarios) {
                var accesosByUsuario = [];
                _.forEach(usuarios, function(usuario) {
                    _.forEach(accesos, function(acceso) {
                       if(acceso.usuario != null){
                            if (acceso.usuario.id == usuario.id) {
                                accesosByUsuario.push(acceso);
                            }
                        }
                    })
                });
                return accesosByUsuario;
            },

            roundForMoneda: function(monto, moneda) {
                var cantDecimales = 2;
                if (moneda.codigo === "guaranies") {
                    cantDecimales = 0;
                }

                return parseFloat(monto.toFixed(cantDecimales));
            },

            rucIsValid: function() {
                var p_numero = $scope.entidadBancaria.ruc.split('-')[0];
                var p_digit = $scope.entidadBancaria.ruc.split('-')[1];
                var p_basemax = 11;
                var v_total, v_resto, k, v_numero_aux, v_digit;
                var i;

                k = 2;
                v_total = 0;

                for (i = p_numero.length - 1; i >= 0; i--) {
                    k = k > p_basemax ? 2 : k;
                    v_numero_aux = p_numero.charAt(i);
                    v_total += v_numero_aux * k++;
                }

                v_resto = v_total % 11;
                v_digit = v_resto > 1 ? 11 - v_resto : 0;

                return v_digit == p_digit;
            }

        };

    }]);
'use strict';
/**
 * AngularJS default filter with the following expression:
 * "person in people | filter: {name: $select.search, age: $select.search}"
 * performs a AND between 'name: $select.search' and 'age: $select.search'.
 * We want to perform a OR.
 */
app.filter('customCurrencyFilter', function () {
    return function (number,symbol,place) {
        if(isNaN(number)) {
            return number;
        } else {
            //console.log("number",number);
            var str=number+"";
            //console.log("str",str);
            var spl=str.split(',');
            //console.log("spl",spl);
            if(spl.length===1){
                spl=str.split('.');
                //console.log("spl",spl);
            }
            var big=spl[0];
            big=big.split("").reverse().join("");
            //console.log("big",big);
            var acumulado="";
            while(big.length>3){
                var left=big.substring(0,3);
                var right=big.substring(3);
                acumulado=acumulado+left+'.';
                big=right;
            }
            acumulado=acumulado+big;
            acumulado=acumulado.split("").reverse().join("");
            if(spl.length>1){
                acumulado=acumulado+','+spl[1];
            }

            // Check if optional parameters are passed, if not, use the defaults
            var symbol = symbol || '$';
            var place = place === undefined ? 0 : place;

            // Perform the operation to set the symbol in the right location
            if( place ===0) {
            return symbol + acumulado;
            } else {
            return acumulado + symbol;
            }

        }


        //return acumulado;
    };
});
'use strict';

/**
 * @ngdoc function
 * @name qualita.controller:LoginCtrl
 * @description
 * # LoginCtrl
 * Controller of the qualita
 */
angular.module('qualita')
    .controller('LoginCtrl', ["$scope", "$state", "$http", "AuthenticationService", "AuthorizationService", "$log", "$rootScope", "NotificacionesWSFactory", "$modal", "AccesosSistemaFactory", "ModelTrimmer", "NewRelicTracking", function($scope, $state, $http, AuthenticationService, AuthorizationService, $log, $rootScope,
        NotificacionesWSFactory, $modal, AccesosSistemaFactory, ModelTrimmer, NewRelicTracking ) {

        $scope.usuario = {};

       function incrCantidadAccesos(accesoSistema) {
            accesoSistema.cantidadaccesos += 1;
    }

        $scope.interacted = function(field) {
            if ($scope.login) {
                return $scope.login.submitted || field.$dirty;
            }
        };

        $scope.iniciarSesion = function() {
            if (!$scope.login.$valid) {
                return;
            }
            $scope.login.submitted = true;
            var user = $scope.usuario;
            var auth = AuthenticationService.login(user.username, user.password);

            auth.then(function(response) {
                if (response.status === 401 && response.data.error) {
                    $scope.invalidUserPassword = true;
                    $scope.loginErrorMessage = response.data.error;
                    return;
                }

                AuthorizationService.setupCredentials(user.username,
                    response.requestToken,
                    response.accessToken,
                    function() {
                        AuthenticationService.postLogin($rootScope.AuthParams).$promise.then(function(data) {
                            $rootScope.AuthParams.accesoSistema = data;
                            incrCantidadAccesos($rootScope.AuthParams.accesoSistema);
                            $rootScope.AuthParams.accesoSistema.cantidadAccesos = AccesosSistemaFactory.cantidadAccesos($rootScope.AuthParams.accesoSistema.id);
                            var accesoDefault = _.find($rootScope.AuthParams.accesoSistema.accesos, function(acceso) {
                                return acceso.accesoPorDefecto == true;
                            });
                            $rootScope.AuthParams.locacionSeleccionada = accesoDefault.locacion;
                            localStorage.setItem('LOCACION_SELECCIONADA', JSON.stringify($rootScope.AuthParams.locacionSeleccionada));
                            $http.defaults.headers.common['X-Access'] = $rootScope.AuthParams.accesoSistema.accesos[0].locacion.id;
                            
                            // Configurar tracking de New Relic Browser
                            NewRelicTracking.trackUser($rootScope.AuthParams);
                        });
                        //$location.path('/main');
                        $state.go('app.main');
                    });

            }, function(response) {
                if (response.status === 401 && response.data && response.data.error) {
                    $scope.invalidUserPassword = true;
                    $scope.loginErrorMessage = response.data.error;
                } else {
                    $scope.invalidUserPassword = true;
                    $scope.loginErrorMessage = 'Usuario y/o password inválidos';
                }
            });
        };
    }]);
'use strict';

/**
 * @ngdoc function
 * @name qualita.controller:LogoutCtrl
 * @description
 * # LogoutCtrl
 * Controller of the qualita
 */
angular.module('qualita')
    .controller('LogoutController', ["$rootScope", "$state", "$location", "AuthenticationService", "AuthorizationService", "NotificacionesWSFactory", "NewRelicTracking", function($rootScope, $state, $location, AuthenticationService, AuthorizationService, NotificacionesWSFactory, NewRelicTracking) {

        /*AuthenticationService.logout($rootScope.AuthParams);
        AuthorizationService.cleanupCredentials();
        $state.go('login');*/

        // QUAL-36230: cerrar sesion local SIEMPRE, sin importar la respuesta del backend.
        // Antes solo se limpiaba el state si el server respondia 200 o 404; cualquier otro
        // status (401 token expirado, 500 error en logout) dejaba al usuario "logueado"
        // localmente, en una pantalla rota o en un loop de redirect.
        function cleanupLocalSession() {
            NewRelicTracking.clearTracking();
            NotificacionesWSFactory.close();
            $rootScope.wsinit = false;
            $rootScope.notificaciones = [];
            $state.go('login');
        }

        AuthenticationService.logout().then(cleanupLocalSession, cleanupLocalSession);
    }]);
'use strict';

/**
 * @ngdoc function
 * @name qualita.controller:LogoutCtrl
 * @description
 * # LogoutCtrl
 * Controller of the qualita
 */
angular.module('qualita').controller('LockController', ["$rootScope", "$state", "$location", "AuthenticationService", "AuthorizationService", "NotificacionesWSFactory", "$scope", "$http", "NewRelicTracking", function($rootScope, $state, $location, AuthenticationService,
        AuthorizationService, NotificacionesWSFactory, $scope, $http, NewRelicTracking) {

        // QUAL-36230: ir a 'lock' SIEMPRE, sin importar la respuesta del backend.
        function lockSession() {
            NotificacionesWSFactory.close();
            $rootScope.wsinit = false;
            $rootScope.notificaciones = [];
            $state.go('lock');
        }

        AuthenticationService.logout().then(lockSession, lockSession);

        $scope.desbloquear = function() {
            $scope.lock.submitted = true;
            var auth = AuthenticationService.login($rootScope.auxiliarUsername,  $scope.usuario.password);

            auth.then(function(response) {
                if (response.status === 401 && response.data.error) {
                    $scope.invalidUserPassword = true;
                    return;
                }

                AuthorizationService.setupCredentials($rootScope.auxiliarUsername,
                    response.requestToken,
                    response.accessToken,
                    function() {
                            AuthenticationService.postLogin($rootScope.AuthParams).$promise.then(function(data) {
                                $rootScope.AuthParams.accesoSistema = data;
                                var accesoDefault = _.find($rootScope.AuthParams.accesoSistema.accesos, function(acceso) {
                                    return acceso.accesoPorDefecto = true;
                                });
                            $rootScope.AuthParams.locacionSeleccionada = accesoDefault.locacion;
                            localStorage.setItem('LOCACION_SELECCIONADA', JSON.stringify($rootScope.AuthParams.locacionSeleccionada));
                            $http.defaults.headers.common['X-Access'] = $rootScope.AuthParams.accesoSistema.accesos[0].locacion.id;
                                
                                // Configurar tracking de New Relic Browser
                                NewRelicTracking.trackUser($rootScope.AuthParams);
                            });
                        $state.go('app.main');
                    });

            }, function(response) {
                console.log('response.status ' + response.status);
                if (response.status === 401 && response.data.error) {
                    $scope.invalidUserPassword = true;
                }
            });
        };
    }]);
'use strict';

/**
 * @ngdoc function
 * @name qualita.controller:MainCtrl
 * @description
 * # MainCtrl
 * Controller of the qualita
 */
angular.module('qualita')
	.controller('MainCtrl', ['$rootScope', '$log', '$modal', '$scope', '$translate', 'moment',  'amMoment', 
	   'ParametrosFactory','notify','MenuJsonFactory','$http','baseurl','$state','$stateParams','AccesosSistemaFactory', function($rootScope, $log, $modal,
       $scope, $translate, moment, amMoment, ParametrosFactory, notify, MenuJsonFactory,$http,baseurl,$state,$stateParams,AccesosSistemaFactory) {
		
		activate();

       function activate () {
			var horaActual;

			// En el servidor, la hora esta adelantada (3 horas)
			horaActual = new Date().getHours();			
			if(horaActual<12 && horaActual >=6){
				$scope.saludo = "¡Buenos dias";
			}else if(horaActual>=12 && horaActual<19 ){
				$scope.saludo = "¡Buenas tardes";				
			}else{
				$scope.saludo = "¡Buenas noches";
			}

			ParametrosFactory.getByCodigo('link_contabilidad').then(function (responseContabilidad) {
				$scope.contabilidad= function(){
					if(responseContabilidad.valor === ''){
						var msg = 'El módulo de Contabilidad no se encuentra configurado';
						notify({message: msg, classes: "alert-danger", position: "right"});
						$scope.targetContabilidad = "";
						$scope.enlaceContabilidad = "";
					}else{
						$scope.enlaceContabilidad = responseContabilidad.valor;
						$scope.targetContabilidad = "_blank";
					}
				};
			});

			ParametrosFactory.getByCodigo('link_rrhh').then(function (responseRrhh) {
				$scope.rrhh= function(){
					if(responseRrhh.valor === ''){
						var msg = 'El módulo de RRHH no se encuentra configurado';
						notify({message: msg, classes: "alert-danger", position: "right"});
						$scope.targetrrhh = "";
						$scope.enlaceRRHH = "";
					}else{
						$scope.enlaceRRHH = responseRrhh.valor;
						$scope.targetrrhh = "_blank";
					}
				};
			});

			ParametrosFactory.getByCodigo('link_serviceDesk').then(function (responseDesk) {
				$scope.desk= function(){
					if(responseDesk.valor === ''){
						var msg = 'El Service Desk no se encuentra configurado';
						notify({message: msg, classes: "alert-danger", position: "right"});
						$scope.target = "";
						$scope.enlaceServiceDesk =  "";
					}else{
						$scope.enlaceServiceDesk = responseDesk.valor;
						$scope.target = "_blank";
					}
				};
			});		
			if($rootScope.mainMenu == undefined){
				AccesosSistemaFactory.downloadMenuJson();
			}
	   }
    }]);
'use strict';

/**
 * @ngdoc function
 * @name qualita.controller:MenuCtrl
 * @description
 * # MenuCtrl
 * Controller of the qualita
 */
angular.module('qualita')
  .controller('MenuCtrl', ["$rootScope", "$localForage", "$scope", "usuariosFactory", function ($rootScope, $localForage, $scope, usuariosFactory) {


    var defaultMenu = [
          {
            'text': 'Personas',
            'children': [
              { 'text' : 'Clientes', 'estado': 'app.clientes.new' },
              { 'text' : 'Proveedores', 'estado': 'app.clientes.new' },
              { 'text' : 'Empleados', 'estado': 'app.clientes.new' }
            ]
          },
          {
            'text': 'Operaciones',
            'children' : [
              { 'text' : 'Compras', 'estado': 'app.clientes.new' },
              { 'text' : 'Ventas', 'estado': 'app.clientes.new' },
              { 'text' : 'Transferencias', 'estado': 'app.clientes.new' }
            ]
          },
          {
            'text': 'Otros',
            'children' : [
              { 'text' : 'Inventarios', 'estado': 'app.clientes.new' },
              { 'text' : 'Ajustes', 'estado': 'app.clientes.new' },
              { 'text' : 'Reportes', 'estado': 'app.clientes.new' }
            ]
          }
        ];

    var username =  $rootScope.AuthParams.username;

    usuariosFactory.getByUsername(username).$promise.then(function(response) {
      $scope.menu = (response && response[0].menu) ? JSON.parse(response[0].menu) : defaultMenu;
    });

    //$scope.menu = defaultMenu;

    $scope.save = function(menu) {
      usuariosFactory.getByUsername(username).$promise.then(function(response) {
        var user = usuariosFactory.create(response[0]);
        user.menu = JSON.stringify(menu);
        usuariosFactory.save(user);
        $scope.menu = menu;
      });
    };

    activate();



  }]);

'use strict';

/**
 * @ngdoc directive
 * @name qualita.directive:customMenu
 * @description
 * # customMenu
 */
angular.module('qualitaCoreFrontend')
    .directive('customMenu', ["$compile", "VERSION", "CONFIGURATION", function($compile, VERSION, CONFIGURATION) {
        return {
            templateUrl: './views/directives/custom-menu.html',
            restrict: 'EA',
            transclude: true,
            scope: { options: '=', menu: '=', query: '=' },
            link: function postLink(scope, element, attrs) {
                var buildMenuNode = function(node, query, level, parentVisible) {
                    var result, inner, nodeVisible;
                    var isVisible = function() { return !query || _.contains(node.text.toLowerCase(), query.toLowerCase()); };
                    var leafVisible = function() { return isVisible(node) || parentVisible; };
                    var nodeVisible = function() { return leafVisible(node) || inner; };
                    level = level || 0;
                    parentVisible = parentVisible || false;

                    if (node.children) {
                        inner = _.reduce(node.children, function(memo, n) {
                            return memo + buildMenuNode(n, query, level + 1, isVisible(node));
                        }, '');

                        if (level) {
                            result = (nodeVisible()) ? subMenu(node, inner) : '';
                        } else {
                            result = (nodeVisible()) ? topLevel(node, inner) : '';
                        }
                    } else {
                        result = (leafVisible()) ? leaf(node, level) : '';
                    }
                    return result;
                }

                var leaf = function(node, level) {

                    if (level === 0) node.data.icono = (node.data.icono) ? node.data.icono : 'glyphicon-home';
                    var icono = '<i class="menu-icon glyphicon <%= icon %>"></i>';
                    var template = _.template('<li><a ui-sref="<%= estado %>"><i class="menu-icon glyphicon <%= icon %>"></i><span class="menu-text"> &nbsp; <%= text %></span></a></li>');
                    var context = { text: node.text, estado: node.estado, icon: node.data.icono };
                    return template(context);
                }


                var topLevel = function(node, inner) {
                    node.data.icono = (node.data.icono) ? node.data.icono : 'glyphicon-home';
                    var icono = '<i class="menu-icon glyphicon <%= icon %>"></i>';
                    var template = _.template('<li><span class="menu-dropdown"><i class="menu-icon glyphicon <%= icon %>"></i><span class="menu-text"> &nbsp; <%= text %></span><i class="menu-expand"></i></span>' +
                        '<ul class="submenu"><%= inner %></ul></li>');
                    var context = { inner: inner, text: node.text, icon: node.data.icono };
                    return template(context);
                }

                var subMenu = function(node, inner) {
                    node.data.icono = (node.data.icono) ? node.data.icono : 'glyphicon-home';
                    var icono = '<i class="menu-icon glyphicon <%= icon %>"></i>';
                    var template = _.template('<li><span class="menu-dropdown"><i class="menu-icon glyphicon <%= icon %>"></i><span class="menu-text"> &nbsp; <%= text %></span><i class="menu-expand"></i></span>' +
                        '<ul class="submenu"><%= inner %></ul></li>');
                    var context = { inner: inner, text: node.text, icon: node.data.icono };
                    return template(context);
                }

                var buildMenu = function(nodes, query) {
                    return _.reduce(nodes, function(memo, n) { return memo + buildMenuNode(n, query); }, '');
                }

                scope.$watch('menu', function(newValue, oldValue) {
                    element.find('.custom-menu ul').html(buildMenu(newValue));
                    $compile(element.find('.custom-menu ul').contents())(scope);
                    // La version del ambiente (parametros.<ambiente>.js) manda sobre la constante:
                    // el test de Multitenant muestra la version en prueba antes que produccion.
                    var versionQualita = "<span>SISTEMA QUALITA - Versión " + (CONFIGURATION.version || VERSION.version) + "</span>";

                    $('body>nav').remove();
                    var API = element.find('#menus').mmenu({
                        "extensions": [
                            "pagedim-black",
                            "effect-listitems-slide",
                            "multiline"
                        ],
                        "counters": true,
                        "iconPanels": {
                            add: false,
                            hideNavbars: true
                        },
                        "navbar": {
                            "title": "Qualita"
                        },
                        "navbars": [{
                                "position": "top",
                                "content": [
                                    "searchfield"
                                ]
                            }, {
                                position: "bottom",
                                content: [versionQualita]
                            },

                            true
                        ],
                        searchfield: {
                            resultsPanel: {
                                title: "Resultados",
                                add: true
                            },
                            placeholder: "Buscar en menús",
                            noResults: "Sin coincidencias",
                            showTextItems: true
                        }
                    }, {
                        searchfield: {
                            clear: true
                        }
                    }).data('mmenu');

                    $('#hamburger').on('click',
                        function(e) {
                            e.preventDefault();
                            if ($('html').hasClass('mm-opened')) {
                                API.close();
                                // console.log(window.location);
                            } else {
                                API.open();
                            }
                        }
                    );
                });

                scope.initialModeCollapse = true;

            }
        };
    }]);
//Sidebar Menu Handle
angular.module('qualitaCoreFrontend')
    .directive('customSidebarMenu', function() {
        return {
            restrict: 'AC',
            link: function (scope, el, attr) {
                el.find('li.active').parents('li').addClass('active open');

                el.on('click', 'a', function (e) {
                    e.preventDefault();
                    var isCompact = false;
                    var menuLink = $(e.target);
                    if ($(e.target).is('span'))
                        menuLink = $(e.target).closest('a');
                    if (!menuLink || menuLink.length == 0)
                        return;
                    if (!menuLink.hasClass("menu-dropdown")) {
                        if (isCompact && menuLink.get(0).parentNode.parentNode == this) {
                            var menuText = menuLink.find(".menu-text").get(0);
                            if (e.target != menuText && !$.contains(menuText, e.target)) {
                                return false;
                            }
                        }
                        return;
                    }
                    var submenu = menuLink.next().get(0);
                    if (!$(submenu).is(":visible")) {
                        var c = $(submenu.parentNode).closest("ul");
                        if (isCompact && c.hasClass("custom-sidebar-menu"))
                            return;
                        c.find("* > .open > .submenu")
                            .each(function() {
                                if (this != submenu && !$(this.parentNode).hasClass("active"))
                                    $(this).slideUp(200).parent().removeClass("open");
                            });
                    }
                    if (isCompact && $(submenu.parentNode.parentNode).hasClass("custom-sidebar-menu"))
                        return false;
                    $(submenu).slideToggle(200).parent().toggleClass("open");
                    return false;
                });
            }
        };
    });


'use strict';

/**
 * @ngdoc directive
 * @name qualita.directive:menuBuilder
 * @description
 * # menuBuilder
 */
angular.module('qualitaCoreFrontend')
  .directive('menuBuilder', ["$timeout", function ($timeout) {
    return {
      templateUrl: 'views/directives/menu-builder.html',
      restrict: 'EA',
      replace: true,
      scope: { options: '=', menu: '=', save: '=' },
      link: function postLink(scope, element, attrs) {
        //scope.menu = {};
        var setLeafs = function(nodes) {
          _.each(nodes, function(n) {
            n.data = { estado: n.estado };
            if(n.children) setLeafs(n.children);
            else n.type = 'leaf';
          }); 
          return nodes;
        }

        function drawJSTree(treeData) {
          $('#menu-builder').jstree({
            'core' : {
              'animation' : 0,
              'check_callback': function(operation, node, parent, position)
              { 
                switch (operation) {
                    case 'move_node':
                      return !parent.parent || parent.original.type !== 'leaf';
                    case 'create_node':
                      return parent.original.type !== 'leaf';
                    case 'rename_node':
                      return node.original.type !== 'leaf';
                    case 'delete_node':
                      return _.isEmpty(node.children) && node.original.type !== 'leaf';
                }
                return false;
              },
              'themes' : { 'stripes' : true },
              'data' : setLeafs(treeData)
            },
            'types' : {
              'default' : {
                'icon' : 'glyphicon glyphicon-record'
              },
              'leaf' : {
                'icon' : 'glyphicon glyphicon-asterisk'
              }
            },
            'plugins' : [
              'dnd', 'search',
              'state', 'types', 'wholerow'
            ]
          });
        }

        function nodeRename() {
          var ref = $('#menu-builder').jstree(true),
            sel = ref.get_selected();
          if(!sel.length) { return false; }
          sel = sel[0];
          //console.log(ref.get_node(sel));
          if(ref.get_node(sel).original.type !== 'leaf') ref.edit(sel);
        };

        $('#menu-builder').delegate("li","dblclick", function(e) {
          nodeRename();
          return false;
        });

        scope.nodeCreate = function() {
          var ref = $('#menu-builder').jstree(true),
              sel = ref.get_selected();
          if(!sel.length) { return false; }
          sel = sel[0];
          sel = ref.create_node(sel);
          if(sel) {
              ref.edit(sel);
          }
        }

        scope.nodeDelete = function() {
          var ref = $('#menu-builder').jstree(true),
              sel = ref.get_selected();
          if(!sel.length) { return false; }
          ref.delete_node(sel);
        }

        scope.getMenu = function() {
          var getMenuNode = function(e) {
            var result = {
              text: e.text,
              estado: e.data.estado
            };

            if(!_.isEmpty(e.children)){
              result.children = _.map(e.children, function(c){
                return getMenuNode(c);
              });
            }

            return result;
          }

          var ref = $('#menu-builder').jstree(true);
          var menu = _.map(ref.get_json(), getMenuNode);
          
          scope.save(menu);
          //scope.menu = menu;
        }

        scope.$watch('menu', function(menu) {
          if(menu) drawJSTree(menu);
        });
      }
    };
  }]);

'use strict';

angular.module('qualitaCoreFrontend')
.directive('mmenu', function() {
    return {
        restrict : 'A',
        link : function(scope, element, attrs) {
            $(element).mmenu({
               "extensions": [
                  "pagedim-black",
                  "effect-listitems-slide",
                  "multiline",
                  "pageshadow"
               ],
               "counters": true,
               "iconPanels": {add:true,
                 hideNavbars: true
               },
               "navbar": {
                 "title": "Qualita"
               },
               "navbars": [
                  {
                     "position": "top",
                     "content": [
                        "searchfield"
                     ]
                  }, {
                      position: "bottom",
                      content: [ "<span>Version 1.14.0</span>" ]
                  },
                  true
               ],
               searchfield: {
                  resultsPanel: {
                    title: "Resultados",
                    add: true},
                  placeholder: "Buscar menú",
                  noResults: "Sin coincidencias",
                  
               }
            }, {
             searchfield: {
                clear: true  
             }
          });
        }
    };
});
angular
  .module('qualita')
  .directive('topFormButtons', topFormButtons);

function topFormButtons() {
  var directive = {
    restrict: 'E',
    scope: {
      save: '&',
      saveTitle: '&',
      cancel: '&',
      entidadId: '=',
      entidad:'=',
      saveEnabledCondition: '=?',
      extraMenuOptions: '=',
      refresh: '&'
    },
    controllerAs: 'vm',
    bindToController: true,
    templateUrl: 'views/directives/top-form-buttons.html',
    link: linkFunc,
    controller: TopFormButtonsController,
  };

  function linkFunc(scope, elem, attr) {
  }

  return directive;
}

TopFormButtonsController.$inject =  ['$scope','notify','$modal','baseurl','$http','BitacoraFactory'];
function TopFormButtonsController($scope,notify,$modal,baseurl,$http,BitacoraFactory) {
  var vm = this;

  if (angular.isUndefined(vm.saveEnabledCondition)) {
       vm.saveEnabledCondition = true;
  }

  vm.notificar = function () {
    notify({ message: 'Funcionalidad aún no implementada.', classes: 'alert-info', position: 'right' })
  };

  vm.bitacora = function () {
    if(vm.entidadId!==undefined){
      $http.get(baseurl.getBaseUrl() + '/bitacora/byid/'+vm.entidadId+"/"+vm.entidad).then(function (data) {
        $scope.tituloModal = "Bitacora "+vm.entidad;
        $scope.lista = data.data;
        var modalInstance = $modal.open({
                    templateUrl: 'views/directives/bitacora-modal.html',
                    scope: $scope
                  });

                  $scope.ok = function() {
                    modalInstance.close();
                  };
                  $scope.comentario = function() {
                    $scope.bitacora={};
                    $scope.bitacora.action="";
                    $scope.bitacora.identificador=""+vm.entidadId;
                    $scope.bitacora.entidad=vm.entidad;
                    $scope.bitacora.fecha=null;
                    $scope.tituloModalComentario = "Nuevo Comentario "+vm.entidad;
                    modalInstance.close();
                    var modalInstance2 = $modal.open({
                      templateUrl: 'views/directives/nuevo_comentario.html',
                      scope: $scope
                    });

                    $scope.submitComentario = function (form) {
                      //console.log("entro en el submit del comentario");
                      $scope.errorcomentario=false;
                      if($scope.bitacora.comentario==="" || $scope.bitacora.comentario===undefined){
                        $scope.errorcomentario=true;
                      }
                      //console.log($scope.bitacora);
                      submitBitacora().then(function (bitacora) {
                        vm.bitacora();
                        modalInstance2.close();
                      })

                    };

                    $scope.cancelComentario = function() {
                      vm.bitacora();
                      modalInstance2.close();
                    };

                  };
      });
  }else{
    notify({ message: 'Todavia no fue creado el ítem', classes: 'alert-info', position: 'right' })
  }



    };

    function submitBitacora() {
      var bitacora = BitacoraFactory.create($scope.bitacora);
      return BitacoraFactory.save(bitacora,
    function(resp, headers){
      //success callback
      console.log(resp);
    },
    function(err){
      // error callback
      console.log(err);
      notify({ message: 'Error.', classes: 'alert-info', position: 'right' })
    });
    }
  };


angular
    .module('qualita')
    .directive('bottomFormButtons', bottomFormButtons);

function bottomFormButtons() {
    var directive = {
        restrict: 'E',
        scope: {
            save: '&',
            saveTitle: '@',
            saveEnabledCondition: '=?',
            isLoading: '=',
            cancel: '&'
        },
        controllerAs: 'vm',
        bindToController: true,
        templateUrl: 'views/directives/bottom-form-buttons.html',
        link: linkFunc,
        controller: BottomFormButtonsController,
    };

    function linkFunc(scope, elem, attr) {

    }

    return directive;
}

BottomFormButtonsController.$inject = [];

function BottomFormButtonsController() {
    var vm = this;

    if (angular.isUndefined(vm.saveEnabledCondition)) {
        vm.saveEnabledCondition = true;
    }
}
'use strict';

/**
 * @ngdoc service
 * @name qualita.bitacora
 * @description
 * # bitacora
 * Factory in the qualita.
 */
angular.module('qualita')
  .factory('BitacoraFactory', ['$resource', 'baseurl', '$http', function($resource,  baseurl,$http) {

  	var Bitacora= $resource( baseurl.getBaseUrl() + '/bitacora/:id', {id: '@id'}, {
      update: {
        method: 'PUT'
      }
    });

    return {
      all: function(params) {
        return Bitacora.query(params);
      },

      get: function(id) {
        return Bitacora.get({id: id});
      },

      create: function(attrs) {
        return new Bitacora(attrs);
      },

      save: function(bitacora) {
        return (bitacora.id) ? bitacora.$update() : bitacora.$save();
      },

      remove: function(bitacora) {
        return bitacora.$remove();
      },

    };
  }]);
angular
  .module('qualita').directive('aDisabled', function() {
    return {
      compile: function(tElement, tAttrs, transclude) {
        //Disable ngClick
        tAttrs["ngClick"] = "!("+tAttrs["aDisabled"]+") && ("+tAttrs["ngClick"]+")";

        //return a link function
        return function (scope, iElement, iAttrs) {

          //Toggle "disabled" to class when aDisabled becomes true
          scope.$watch(iAttrs["aDisabled"], function(newValue) {
            if (newValue !== undefined) {
              iElement.toggleClass("disabled", newValue);
            }
          });

          //Disable href on click
          iElement.on("click", function(e) {
            if (scope.$eval(iAttrs["aDisabled"])) {
              e.preventDefault();
            }
          });
        };
      }
    };
  });

angular.module('qualita')
  .directive('uiRequired', function() {
    return {
      require: 'ngModel',
      link: function(scope, elm, attrs, ctrl) {
        ctrl.$validators.required = function(modelValue, viewValue) {
          console.log("link de uiRequired");
          console.log("viewValue: ");
          console.log(viewValue);
          return !((viewValue && viewValue.length === 0 || false) && attrs.uiRequired === 'true');
        };

        attrs.$observe('uiRequired', function() {
          console.log("observe de uiRequired");
          ctrl.$setValidity('required', !(attrs.uiRequired === 'true' && ctrl.$viewValue && ctrl.$viewValue.length === 0));
        });
      }
    };
  });

angular
  .module('qualita')
  .directive('validatedTextInput', validatedTextInput);

function validatedTextInput() {
  var directive = {
    restrict: 'E',
    scope: {
      model: '=',
      form: '=',
      name: '@',
      label: '@',
      isRequired: '=',
      submitedFlag: '=',
      placeholder: '@',
      clases: '@',
      inputType: '@',
      onChange: '&',
      onBlur: '&',
      maxLength: '@',
      minLength: '@',
      focusElement: '@',
      isDisabled: '=',
      textPattern: '@',
      textPatternMsg: '@',
      min: '=',
      max: '='
      //regex: '@'
    },
    controllerAs: 'vm',
    bindToController: true,
    templateUrl: 'views/directives/validated-text-input.html',
    link: linkFunc,
    controller: ValidatedTextInputController,
  };

  function linkFunc(scope, elem, attr) {
    scope.vm.textPattern = angular.isDefined(scope.vm.textPattern) ?
            new RegExp(scope.vm.textPattern) :
            // /^[^!@"#$%&\/()]*$/;   ejemplo original
            /^[^'"]*$/;
  }

  return directive;
}

ValidatedTextInputController.$inject =  ['$scope', '$timeout'];
function ValidatedTextInputController($scope, $timeout) {
  var vm = this;

  activate();
  vm.updateListener = updateListener;
  vm.updateListener2 = updateListener2;

  function activate() {
    if (!vm.textPatternMsg) {
      vm.textPatternMsg = "El dato es inválido";
    }
  }

  function updateListener() {
    $timeout(vm.onChange, 0);
  }

  function updateListener2() {
    $timeout(vm.onBlur, 0);
  }

};

angular
  .module('qualita')
  .directive('multipleEmails', function () {
  var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9-]+(\.[a-z0-9-]+)*$/i;

  function validateAll(ctrl, validatorName, value) {
    var validity = ctrl.$isEmpty(value) || value.split(',').every(
      function (email) {
        return EMAIL_REGEXP.test(email.trim());
      }
    );

    ctrl.$setValidity(validatorName, validity);
    return validity ? value : undefined;
  }

  return {
    restrict: 'A',
    require: 'ngModel',
    link: function postLink(scope, elem, attrs, modelCtrl) {
      function multipleEmailsValidator(value) {
        return validateAll(modelCtrl, 'multipleEmails', value);
      };

      modelCtrl.$formatters.push(multipleEmailsValidator);
      modelCtrl.$parsers.push(multipleEmailsValidator);
    }
  };
});

angular
  .module('qualita')
  .directive('validatedTextareaInput', validatedTextareaInput);

function validatedTextareaInput() {
  var directive = {
    restrict: 'E',
    scope: {
      model: '=',
      form: '=',
      name: '@',
      label: '@',
      isRequired: '=',
      submitedFlag: '=',
      clases: '@',
      inputType: '@',
      onChange: '&',
      maxLength: '@',
      minLength: '@',
      isDisabled: '='
    },
    controllerAs: 'vm',
    bindToController: true,
    templateUrl: 'views/directives/validated-textarea-input.html',
    link: linkFunc,
    controller: ValidatedTextareaInputController,
  };

  function linkFunc(scope, elem, attr) {
  }

  return directive;
}

ValidatedTextareaInputController.$inject =  ['$scope', '$timeout'];
function ValidatedTextareaInputController($scope, $timeout) {
  var vm = this;

  activate();
  vm.updateListener = updateListener;

  function activate() {
    vm.campo = vm.form[vm.name];
  }

  function updateListener() {
    $timeout(vm.onChange, 0);
  }

};


angular
  .module('qualita')
  .directive('validatedUiselectInput', validatedUiselectInput);

function validatedUiselectInput() {
  var directive = {
    restrict: 'E',
    scope: {
      model: '=',
      form: '=',
      name: '@',
      label: '@',
      isRequired: '=',
      position: '@',
      submitedFlag: '=',
      fieldToShow: '@',
      options: '=',
      clases: '@',
      onSelect: '&',
      onRemove: '&',
      onChange: '&',
      focusElement: '@',
      isDisabled: '=',
      delayRequestFactory: '=',
      filterArray: '=',
      delayRequestParamLengt : '@',
      searchValue: "@"
    },
    controllerAs: 'vm',
    bindToController: true,
    templateUrl: 'views/directives/validated-uiselect-input.html',
    link: linkFunc,
    controller: ValidatedUiselectInputController,
    compile: compileFunc
  };

  function linkFunc(scope, elem, attr) {
  }

  function compileFunc(element, attrs) {
    //if (!attrs.focusElement) { attrs.focusElement = false; }
  }

  return directive;
}

ValidatedUiselectInputController.$inject =  ['$scope', '$timeout', 'notify', '$translate', '$element', 'filterFactory'];
function ValidatedUiselectInputController($scope, $timeout, notify, $translate, $element, filterFactory) {
  var vm = this;

  vm.waitingFetch = false;

  vm.getChoice = getChoice;

  vm.selectListener = selectListener;

  vm.removeListener = removeListener;

  vm.changeListener = changeListener;

  vm.wrongItemListener = wrongItemListener;

  vm.getFilter = getFilter;

  vm.checkOption = checkOption;

  activate();

  function activate() {
  }

  function getChoice(obj) {
    return _.get(obj, vm.fieldToShow);
  }

  function selectListener() {
    $timeout(vm.onSelect, 0);
  }

  function removeListener() {
    $timeout(vm.onRemove, 0);
  }

  function changeListener() {
    $timeout(vm.onChange, 0);
  }

  function wrongItemListener() {
    $timeout(function() {
      vm.model = undefined;
      $translate('ELEMENTO_INEXISTENTE').then(function(mensaje) {
        notify({ message: mensaje, duration: 1200, classes: 'alert-danger', position: 'right'});
      });
    });
  }

  function checkOption (optionName) {
    if (vm.delayRequestFactory) {
      if (optionName.length >=
        (vm.delayRequestParamLengt ? vm.delayRequestParamLengt : 3)) {
          vm.filterArray.push({path: vm.searchValue,like: optionName})
          vm.staticFilterProv = {}
          vm.staticFilterProv.search = filterFactory.and(vm.filterArray).value();
          vm.delayRequestFactory.all(vm.staticFilterProv)
            .$promise.then(function(response) {
              vm.options = response
              /* Eliminamos el ultimo elemento del array para evitar filtros duplicados */
              vm.filterArray.pop()
            });

      } else {
        vm.options = undefined
      }
    }
  }


  function getFilter(param) {
    var obj = {};
    obj[vm.fieldToShow] = param;
      return obj;
  }

};

angular
  .module('qualita')
  .directive('validatedUiselectMultipleInput', validatedUiselectMultipleInput);

function validatedUiselectMultipleInput() {
  var directive = {
    restrict: 'E',
    scope: {
      model: '=',
      form: '=',
      name: '@',
      label: '@',
      isRequired: '=',
      submitedFlag: '=',
      fieldToShow: '@',
      fieldToShow2: '@',
      options: '=',
      clases: '@',
      onSelect: '&',
      onRemove: '&',
      onRefresh: '&',
      isDisabled: '=',
      refreshable: '=',
      delayRequestFactory: '=',
      filterArray: '=',
      delayRequestParamLengt : '@',
      searchValue: "@"
    },
    controllerAs: 'vm',
    bindToController: true,
    templateUrl: 'views/directives/validated-uiselect-multiple-input.html',
    link: linkFunc,
    controller: ValidatedUiselectMultipleInputController,
  };

  function linkFunc(scope, elem, attr) {
  }

  return directive;
}

ValidatedUiselectMultipleInputController.$inject =  ['$scope', '$timeout', '$translate', 'notify'];
function ValidatedUiselectMultipleInputController($scope, $timeout, $translate, notify) {
  var vm = this;

  vm.getChoice = getChoice;

  vm.selectListener = selectListener;

  vm.removeListener = removeListener;

  vm.refreshListener = refreshListener;

  vm.wrongItemListener = wrongItemListener;

  vm.printTest = printTest;

  vm.getFilter = getFilter;

  vm.checkOption = checkOption;

  activate();

  function activate() {
  }

  function getChoice(obj) {
    if (!obj) return '';
    if (vm.fieldToShow2) {
      // si fieldToShow2 está definido, devuelve dos líneas
      return obj[vm.fieldToShow] + '\n' + obj[vm.fieldToShow2];
    } 
    return obj[vm.fieldToShow];
  }
  

  function refreshListener() {
    vm.waitingFetch = true;
    $timeout(vm.onRefresh, 0).then(function(response) {
      vm.waitingFetch = false;
    });
  }

  function selectListener() {
    $timeout(vm.onSelect, 0);
  }

  function removeListener() {
    $timeout(vm.onRemove, 0);
  }

  function wrongItemListener() {
    $timeout(function() {
      if(vm.model.length == vm.options.length) {
        return;
      }
      $translate('ELEMENTO_INEXISTENTE').then(function(mensaje) {
        notify({ message: mensaje, duration: 1200, classes: 'alert-danger', position: 'right'});
      });
    });
  }

  function getFilter(param) {
    var obj = {};
    obj[vm.fieldToShow] = param;
      return obj;
  }

  function printTest() {
    console.log("este es un test");
  }

  function checkOption (optionName) {
    if (vm.delayRequestFactory) {
      if (optionName.length >=
        (vm.delayRequestParamLengt ? vm.delayRequestParamLengt : 3)) {
          vm.filterArray.push({path: vm.searchValue,like: optionName})
          vm.staticFilterProv = {}
          vm.staticFilterProv.search = filterFactory.and(vm.filterArray).value();
          vm.delayRequestFactory.all(vm.staticFilterProv)
            .$promise.then(function(response) {
              vm.options = response
              /* Eliminamos el ultimo elemento del array para evitar filtros duplicados */
              vm.filterArray.pop()
            });

      } else {
        vm.options = undefined
      }
    }
  }

  vm.getNestedProperty = function(obj, path) {
    if (!obj || !path) return '';
    return path.split('.').reduce(function(prev, curr) {
      return prev ? prev[curr] : null;
    }, obj) || '';
  };
  
};

angular
    .module('qualita')
    .directive('validatedDateInput', validatedDateInput);

function validatedDateInput() {
    var directive = {
        restrict: 'E',
        scope: {
            model: '=',
            form: '=',
            name: '@',
            label: '@',
            isRequired: '=',
            submitedFlag: '=',
            clases: '@',
            onChange: '&',
            isDisabled: '=',
            dateOptions: '@',
            format: '@',
            opened: '@'
        },
        controllerAs: 'vm',
        bindToController: true,
        templateUrl: 'views/directives/validated-date-input.html',
        link: linkFunc,
        controller: ValidatedDateInputController,
    };

    function linkFunc(scope, elem, attr, controller, dateFilter) {
        //controller.$formatters.shift();
        if (controller.model) {
            controller.model = new Date(controller.model);
        }
    }

    return directive;
}

ValidatedDateInputController.$inject = ['$scope', '$timeout'];

function ValidatedDateInputController($scope, $timeout) {
    var vm = this;

    if (!vm.format)
        vm.format = "dd/MM/yyyy";

    vm.showWeeks = false;

    vm.open = function() {
        vm.opened = true;
    };

    vm.focus = false;
    vm.focus = function() {
        vm.opened = true;
        vm.focus = true;
    };

    vm.today = function() {
        vm.model = new Date();
    };

    vm.clear = function() {
        vm.model = null;
    };

    vm.dateOptions = {
        formatYear: 'yy',
        startingDay: 1
    };

    activate();
    vm.updateListener = updateListener;

    function activate() {
        moment.locale('es');
    }

    function updateListener() {
        vm.focus = false;
        $timeout(vm.onChange, 0);
    }



};
angular
  .module('qualita')
  .directive('validatedTimeInput', validatedTimeInput);

function validatedTimeInput() {
  var directive = {
    restrict: 'E',
    scope: {
      model: '=',
      form: '=',
      name: '@',
      label: '@',
      isRequired: '=',
      submitedFlag: '=',
      clases: '@',
      onChange: '&',
      isDisabled: '=',
      dateOptions: '@',
      format:'@',
      opened:'@'
    },
    controllerAs: 'vm',
    bindToController: true,
    templateUrl: 'views/directives/validated-time-input.html',
    link: linkFunc,
    controller: validatedTimeInputController,
  };

  function linkFunc(scope, elem, attr, controller, dateFilter) {
    //controller.$formatters.shift();
    if (controller.model) {
      controller.model = new Date(controller.model);
    }
  }

  return directive;
}

validatedTimeInputController.$inject =  ['$scope', '$timeout', '$element', '$document'];
function validatedTimeInputController($scope, $timeout, element, $document) {
  var vm = this;
  vm.isValid = true;

  if (!vm.format)
    vm.format = "HH:mm";

  vm.date = new Date();
  vm.showWeeks = false;

  vm.open = function() {
    if(vm.opened === false) {
      vm.opened = true;
    } else {
      vm.opened = false;
    }
  };

  vm.focus = false;
  vm.focus = function() {
    vm.opened = true;
    vm.focus = true;
  };

  vm.blur = function() {
    vm.opened = false;
    vm.focus = false;
  };

  vm.today = function() {
    vm.date = new Date();
    vm.model = moment(vm.date).format(vm.format);
  };

  vm.clear = function() {
    vm.date = null;
    vm.model = null;
  };

  vm.close = function() {
    vm.opened = false;
    vm.focus = false;
  };

  activate();
  vm.updateListener = updateListener;
  vm.updateInputListener = updateInputListener;

  function activate() {
    moment.locale('es');
    vm.opened = false;
  }

  function updateListener() {
    //vm.focus = false;
    vm.model = moment(vm.date).format(vm.format);
    var pattern = new RegExp('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$');
    vm.isValid = pattern.test(vm.model);
    if (vm.isValid == false)
      vm.form[vm.name].$setValidity('invalido', !vm.isValid);
    else
      $timeout(vm.onChange, 0);
  }

  function updateInputListener() {
    var pattern = new RegExp('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$');
    vm.isValid = pattern.test(vm.model);
    if (vm.isValid == false)
      vm.form[vm.name].$setValidity('invalido', !vm.isValid);
    else (vm.isValid)
      $timeout(vm.onChange, 0);
  }

  vm.keydown = function(evt) {
    if (evt.which === 27 || evt.which === 9 || evt.which === 13) {
      console.log("keydown de close registrado.");
      //vm.opened = false;
      //element[0].focus();
      vm.close();
    }
  };

  element.bind('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
    });

  $document.bind('click', function(event) {
    $scope.$apply(function() {
      console.log("click bind triggered to set opened flag to false.");
      vm.opened = false;
    });
  });

};

angular
    .module("qualita")
    .directive("validatedCurrencyInput", validatedCurrencyInput);

function validatedCurrencyInput() {
    var directive = {
        restrict: "E",
        scope: {
            viewModel: "=",
            model: "=",
            form: "=",
            name: "@",
            label: "@",
            isRequired: "=",
            submitedFlag: "=",
            placeholder: "@",
            clases: "@",
            onChange: "&",
            maxLength: "@",
            minLength: "@",
            focusElement: "@",
            isDisabled: "=",
            digitsPattern: "@",
            digitsPatternMsg: "@",
            warningMsg: "@",
            min: "=",
            max: "=",
            defaultValue: "=?"
                //regex: '@'
        },
        controllerAs: "vm",
        bindToController: true,
        templateUrl: "views/directives/validated-currency-input.html",
        link: linkFunc,
        controller: ValidatedCurrencyInputController
    };

    function linkFunc(scope, elem, attr) {
        scope.vm.digitsPattern = angular.isDefined(scope.vm.digitsPattern) ?
            new RegExp(scope.vm.digitsPattern) :
            /^-*[0-9]+(,[0-9][0-9]?)?$/;
    }
    return directive;
}
ValidatedCurrencyInputController.$inject = ["$scope", "$timeout"];

function ValidatedCurrencyInputController($scope, $timeout) {
    var vm = this;
    vm.isValid = true;
    activate();
    vm.updateListener = updateListener;

    function activate() {
        if (vm.defaultValue != undefined) {
            if (!vm.model) {
                vm.model = vm.defaultValue;
                if (!vm.default) {
                    vm.viewModel = "0";
                }
            }
        }
    }

    function getRegexPattern() {
        if (typeof vm.digitsPattern == "string") {
            vm.digitsPattern = new RegExp(vm.digitsPattern);
        }
        return vm.digitsPattern;
    }

    function updateListener() {
        if (vm.viewModel) {
            vm.model = parseFloat(vm.viewModel.replace(/,/, "."));
            var pattern = getRegexPattern();

            vm.isValid = pattern.test(vm.viewModel);
            vm.form[vm.name].$setValidity("invalido", vm.isValid);
            if (
                ((vm.max == 0 || vm.max) && vm.model > vm.max) ||
                ((vm.min == 0 || vm.min) && vm.model < vm.min)
            ) {
                vm.isValid = false;
                vm.form[vm.name].$setValidity("invalido", vm.isValid);
            }
        } else {
            vm.model = 0.0;
            vm.viewModel = "0";
        }
        $timeout(vm.onChange, 0);
    }
    $scope.$watch("vm.model", function(newValue, oldValue) {
        if (!vm.model && vm.model != 0) {
            vm.isValid = true;
            vm.form[vm.name].$setValidity("invalido", vm.isValid);
            return;
        }

        if (vm.viewModel != vm.model.toString().replace(/\./, ",")) {
            vm.viewModel = vm.model.toString().replace(/\./, ",");
            var pattern = getRegexPattern();
            vm.isValid = pattern.test(vm.viewModel);

            vm.form[vm.name].$setValidity("invalido", vm.isValid);
            if (
                ((vm.max == 0 || vm.max) && vm.model > vm.max) ||
                ((vm.min == 0 || vm.min) && vm.model < vm.min)
            ) {
                vm.isValid = false;
                vm.form[vm.name].$setValidity("invalido", vm.isValid);
            }
        }
    });

}

"use strict";

/**
 * @ngdoc service
 * @name qualita.tipos
 * @description
 * # tipos
 * Factory in the qualita.
 */
angular.module("qualita").factory("TiposFactory", [
    "$resource",
    "baseurl",
    "filterFactory",
    "$http",
    function ($resource, baseurl, filterFactory, $http) {

        var tipos = $resource( baseurl.getBaseUrl() + "/tipos/:id", {id: '@id'}, {
            update: {
              method: 'PUT'
            }
          });

          return {

            administraciones: function (codigo) {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/" + codigo);
            },

            tipoproductos: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipoproductos");
            },

            estadosImportacion: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/importacion_estados"
                );
            },

            estadosCompra: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/estados_compra");
            },

            monedas: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/monedas?view=BaseForm");
            },

            tiposCobro: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipo_cobro?view=BaseForm");
            },

            administracionesProductos: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/administracion_productos"
                );
            },

            accionesTransaccion: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/imc_accion?view=BaseForm");
            },

            accionesTipoComprobante: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/fnd_accion_comprobante"
                );
            },

            clasesTipoComprobante: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/fnd_clase_comprobante"
                );
            },
            clasesUsuario: function (userId) {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/clase/"+ userId
                );
            },
            valoresParametros: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/valores_parametro"
                );
            },

            estilosGeneracion: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/estilos_generacion"
                );
            },

            modulos: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/modulos");
            },

            administracionCosto: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/tipo_administracion_costo"
                );
            },

            costoContable: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/tipo_costo_contable"
                );
            },

            recalculoCosto: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/tipo_recalculo_costo"
                );
            },

            estadosOrdenCompra: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/estados_orden_compra"
                );
            },

            estadosOrdenCompraLocal: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/estados_orden_compra_local"
                );
            },

            vias: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/via_embarque");
            },

            tiposRecepcion: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/tipo_recepcion_importacion"
                );
            },

            tiposDetalleComprobante: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/tipos_detalle_comprobante?view=BaseForm"
                );
            },

            estadosPeriodoAdministrativo: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/periodo_administrativo_estado"
                );
            },

            operacionesPeriodoAdministrativo: function () {
                return $http.get(
                    baseurl.getBaseUrl() +
                    "/tipos/tipo/periodo_administrativo_operaciones"
                );
            },

            estadosPeriodoComision: function () {
              return $http.get(
                baseurl.getBaseUrl() + "/tipos/tipo/periodo_comision_estado"
              );
            },

            operacionesPeriodoComision: function () {
              return $http.get(
                baseurl.getBaseUrl() +
                "/tipos/tipo/periodo_comision_operaciones"
              );
            },

            tipoCostoDespacho: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/costo_despacho");
            },

            gruposProveedor: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/proveedor_grupos");
            },

            estadosMovimientoStock: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/estados_movimiento_stock?view=BaseForm"
                );
            },

            claseFormasPago: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/clase_forma_pago");
            },

            tiposRetencion: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipo_retencion?view=BaseForm");
            },

            clasesRetencion: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/clase_retencion?view=BaseForm");
            },

            tiposChequera: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipo_chequera");
            },

            tiposCuenta: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipo_cuenta?view=BaseForm");
            },

            tiposMovimientoBancrio: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/tipo_movimiento_bancario"
                );
            },

            clasesOrdenPago: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/clase_orden_pago");
            },

            tiposMovimientoBancario: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/tipo_movimiento_bancario"
                );
            },

            estadosCuota: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/estados_plan_pagos"
                );
            },

            estadosCuotaCobro: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/estados_plan_cobros"
                );
            },

            conceptosIva: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/concepto_retenciones_iva?view=BaseForm"
                );
            },

            conceptosRenta: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/concepto_retenciones_renta?view=BaseForm"
                );
            },

            estadosPeriodoNomina: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/periodo_nomina_estado"
                );
            },

            estadosInventario: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/estados_inventario"
                );
            },

            estadosMovimientoFraccionarioDetalle: function () {
                return $http.get(
                    baseurl.getBaseUrl() +
                    "/tipos/tipo/estados_detalle_movimiento_fraccionado"
                );
            },

            componentesCompra: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/componente_tipo_compra"
                );
            },

            tipoPersonaCliente: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/tipo_persona_cliente"
                );
            },

            tipoDocumentoCliente: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/tipo_documento_cliente"
                );
            },

            componentesVenta: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/componente_tipo_venta?view=BaseForm"
                );
            },

            estadosVenta: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/estados_venta?view=BaseForm");
            },

            condicionCobroPedidoVenta: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/condicion_cobro_pedido_venta?view=BaseForm"
                );
            },

            condicionTipoComprobante: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/condicion_tipo_comprobante?view=BaseForm"
                );
            },

            estadosProcesoCobro: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/estado_procesocobro"
                );
            },

            estadosCobroMovil: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/estado_cobro_movil?view=BaseForm"
                );
            },

            estadosAdelantos: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/estado_adelanto");
            },

            estadosDetalleAsistencia: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/estado_detalle_asistencia"
                );
            },

            estadosSalarios: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/estados_salario");
            },

            clasesAlmacen: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/clase_almacen?view=BaseForm");
            },

            clasesTransaccion: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/clase_transaccion?view=BaseForm");
            },

            clasesGrupoCompra: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/clase_grupo_compra");
            },

            clasesInventario: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/clase_inventario");
            },

            rubroTipoOperacion: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/rubro_tipo_operacion");
            },

            ventaTipoOperacion: function(){
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/venta_tipo_operacion");
            },

            condicionTipoAplicacion: function(){
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/condicion_tipo_aplicacion");
            },

            tipoTransaccion: function(){
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipo_transaccion");
            },

            tipoAnticipo: function(){
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipo_transaccion_anticipo");
            },

            motivoEmision: function(){
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/motivo_emision");
            },

            motivoTraslado: function(){
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/motivo_traslado");
            },

            tipoTransporte: function(){
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipo_transporte");
            },

            tipoVehiculo: function(){
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipo_vehiculo");
            },

            naturalezaTransportista: function(){
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/naturaleza_transportista");
            },

            estadosPresupuestoVenta: function(){
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/estado_presupuesto_venta");
            },

            estadosListaPrecioVenta: function(){
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/estado_lista_precio_venta");
            },


            condicionTipoCobro: function(){
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipo_condicion");
            },
            
            periodoMontoMeta: function(){
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/periodo_monto_meta");
            },

            estadosPlanillasRepartos: function(){
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/estado_planilla_reparto");
            },

            all: function all(params, view) {
                if(params){
                  params.view = view != undefined ? view : 'BaseTipo';
                }
                return tipos.query(params);
              },
            
            estadosFraccionamientoBobinas: function(){
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/estado_fraccionamiento_bobinas");
            },

            origenesPV: function(){
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/origen_pv");
            },

            codigosContables: function(){
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/codigos_contables_grupos_compras");
            },
            clasesFormaDePago: function(){
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/clase_forma_pago");
            },
            estadosOrdenCarga: function(){
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/estado_orden_carga");
            },
            origenesCompronbantesRetencion: function(){
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/origen_comprobante_retencion");
            },
            tiposProcesamientosDetallesCobros: function(){
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipo_procesamiento");
            },
            tiposSuscripcionEstado: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipo_suscripcion_estado?view=BaseForm");
            },
            tiposSuscripcionOperacion: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipo_suscripcion_operacion?view=BaseForm");
            }, 
            tiposSuscripcionPeriodicidad: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipo_suscripcion_periodicidad?view=BaseForm");
            }
            ,
            tiposArqueoConcepto: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipo_arqueo_concepto?view=BaseForm");
            },
            tiposArqueoUtilizadoEn: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipo_arqueo_utilizado_en?view=BaseForm");
            },
            tiposArqueoSigno: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipo_arqueo_signo?view=BaseForm");
            },

            tiposAgendaSuscripcionEstado: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipo_agenda_suscripcion_estado?view=BaseForm");
            },
            tiposAgendaSuscripcionAccion: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipo_agenda_suscripcion_accion?view=BaseForm");
            },
            tiposAgendaSuscripcionIntervalo: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipo_agenda_suscripcion_intervalo?view=BaseForm");
            },
            tiposprecio: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipos_precio?view=BaseForm");
            },
            condicionNegociacion: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/condicion_negociacion?view=BaseForm");
            },
            paisDestino: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/pais_pais?view=BaseForm");
            },
            operacionComprobante: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipo_operacion_comprobante?view=BaseForm");
            },    
            utilizacionMateriales: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipos_utilizacion?view=BaseForm");
            },
            estadoMateriales: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipos_estado_materiales?view=BaseForm");
            },    
            tipoOrdenProduccion: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipos_orden_produccion?view=BaseForm");
            },
            estadoOrdenProduccion: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipos_estado_orden_produccion?view=BaseForm");
            },
            estadoListaMateriales: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipos_estado_lista_materiales?view=BaseForm");
            },

            estadosMovimientoStockManual: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/estados_movimiento_stock_manual?view=BaseForm"
                );
            },

            tiposEntregaPicking: function () {
                return $http.get(
                    baseurl.getBaseUrl() + "/tipos/tipo/tipos_entrega_picking?view=BaseForm"
                );
            },
            
            tiposRangosComisionPerfiles: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipo_perfiles_comision_ventas?view=BaseForm");
            },
            estadosDetallesPcking: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/estados_orden_picking_detalle?view=BaseForm");
            },
            tiposEstadosComisionesCalculadasComision: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/estados_comision?view=BaseForm");
            },
            estadosEntregaDocumentosRendicion: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/estados_entrega_planilla_rendicion_detalle?view=BaseForm");
            },
            tiposComisiones: function () {
              return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/tipo_comision?view=BaseForm");
            },
            formasPagoFactura: function () {
                return $http.get(baseurl.getBaseUrl() + "/tipos/tipo/formas_pago_factura?view=BaseForm");
              }
        };
    }
]);

angular.module('qualita')
  .factory('TiposTipoFactory', TiposTipoFactory);

TiposTipoFactory.$inject = ['$resource', 'baseurl'];

function TiposTipoFactory($resource, baseurl) {
  var service = {
    all: all,
    get: get,
    getById: getById,
    tiposValorDefault: ["String", "Long", "Integer", "Double", "Float"] //tipos por defecto admitidos en TipoTipo
  };

  var Tipos = $resource( baseurl.getBaseUrl() + "/tipos/tipo/:codigo");

  return service;

  function all(params) {
    return Tipos.query(params);
  }

  function get(codigo) {
    return Tipos.query({codigo: codigo});
  }

  function getById(id) {
    var tiposById = $resource( baseurl.getBaseUrl() + "/tipos/by-id/:id");
    return tiposById.get({id: id});
  }
}

angular.module('qualita')
    .factory('WatchLocacionChangeFactory', WatchLocacionChangeFactory);

WatchLocacionChangeFactory.$inject = ['$rootScope', 'UtilFactory', 'filterFactory', '$q'];

function WatchLocacionChangeFactory($rootScope, UtilFactory, filterFactory, $q) {

    var service = {
        watchWith: watchWith,
        executeWatching: executeWatching,
        killAllWatchers: killAllWatchers
    };

    var watchers = [];
    var self = this;
    return service;

    function executeWatching(accion, customPath) {
        return $q(function(resolve, reject) {
            var watcher = $rootScope.$watch("AuthParams.locacionSeleccionada", function() {
                if (!$rootScope.AuthParams) {
                    return;
                }

                if (!$rootScope.AuthParams.locacionSeleccionada) {
                    return;
                }

                var locacionesFilter = {};
                locacionesFilter.search = filterFactory.and([{
                    path: customPath,
                    equals: $rootScope.AuthParams.locacionSeleccionada.id
                }]).value();

                resolve(accion(locacionesFilter, watcher));
            });
            watchers.push(watcher);
        });
    }

    function killAllWatchers() {
        _.forEach(watchers, function(watcher) {
            watcher();
        });
        self.watchers = [];
    }

    function watchWith(staticFilter, options, customPath) {
        // console.log("Options: ");
        // console.log(options);
        $rootScope.$watch("AuthParams.locacionSeleccionada", function() {
            if (!$rootScope.AuthParams) {
                return;
            }

            if (!$rootScope.AuthParams.locacionSeleccionada) {
                return;
            }

            var locacionesFilter = {};
            locacionesFilter.search = filterFactory.and([{
                path: customPath,
                equals: $rootScope.AuthParams.locacionSeleccionada.id
            }]).value();

            if (staticFilter) {
                options.staticFilter = UtilFactory.createNestedFilters(locacionesFilter.search.filters, staticFilter);
            } else {
                options.staticFilter = locacionesFilter;
            }
            // console.log(options.staticFilter);
        });
    }

}
'use strict';

/**
 * @ngdoc service
 * @name qualita.service:NewRelicTracking
 * @description
 * # NewRelicTracking
 * Servicio para enviar información de usuarios y contexto a New Relic Browser
 */
angular.module('qualita')
    .factory('NewRelicTracking', ["$window", "$http", "$log", "CONFIGURATION", function($window, $http, $log, CONFIGURATION) {

        var service = {
            /**
             * Genera y retorna un Device ID único basado en características del equipo
             * Combina fingerprint del hardware con localStorage para persistencia
             * @returns {String} Device ID único
             */
            getDeviceId: function() {
                try {
                    // 1. Intentar leer del localStorage
                    var deviceId = localStorage.getItem('NR_DEVICE_ID');
                    
                    if (!deviceId) {
                        // 2. Si no existe, generar fingerprint basado en características del equipo
                        var fingerprint = {
                            ua: navigator.userAgent,
                            screen: screen.width + 'x' + screen.height + 'x' + screen.colorDepth,
                            tz: new Date().getTimezoneOffset(),
                            lang: navigator.language || navigator.userLanguage,
                            cores: navigator.hardwareConcurrency || 0,
                            mem: navigator.deviceMemory || 0,
                            platform: navigator.platform,
                            vendor: navigator.vendor || ''
                        };
                        
                        // 3. Generar hash del fingerprint (algoritmo simple de hash)
                        var hash = 0;
                        var str = JSON.stringify(fingerprint);
                        for (var i = 0; i < str.length; i++) {
                            var char = str.charCodeAt(i);
                            hash = ((hash << 5) - hash) + char;
                            hash = hash & hash; // Convertir a entero de 32 bits
                        }
                        
                        // 4. Convertir a formato legible (base36)
                        deviceId = 'dev_' + Math.abs(hash).toString(36);
                        
                        // 5. Guardar en localStorage para persistencia
                        localStorage.setItem('NR_DEVICE_ID', deviceId);
                        
                        $log.info('[New Relic] Device ID generado:', deviceId);
                    } else {
                        $log.debug('[New Relic] Device ID recuperado de localStorage:', deviceId);
                    }
                    
                    return deviceId;
                } catch (error) {
                    $log.error('[New Relic] Error al generar Device ID:', error);
                    // Fallback: generar ID aleatorio temporal
                    return 'dev_' + Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
                }
            },
            
            /**
             * Captura y envía características del equipo a New Relic
             */
            trackDeviceInfo: function() {
                if (!$window.newrelic) {
                    return;
                }
                
                try {
                    // 0. Cliente ID (desde CONFIGURATION, dinámico por ambiente)
                    var clienteId = CONFIGURATION.clienteId || 'unknown';
                    var clienteNombre = CONFIGURATION.clienteNombre || clienteId;
                    var hostname = $window.location.hostname;
                    
                    $window.newrelic.setCustomAttribute('cliente_id', clienteId);
                    $window.newrelic.setCustomAttribute('cliente_nombre', clienteNombre);
                    $window.newrelic.setCustomAttribute('cliente_hostname', hostname);
                    
                    // 1. Device ID único (para distinguir equipos con mismo usuario)
                    var deviceId = service.getDeviceId();
                    $window.newrelic.setCustomAttribute('device_id', deviceId);
                    
                    // 2. Resolución de pantalla
                    if ($window.screen) {
                        $window.newrelic.setCustomAttribute('screen_width', $window.screen.width);
                        $window.newrelic.setCustomAttribute('screen_height', $window.screen.height);
                        $window.newrelic.setCustomAttribute('screen_resolution', $window.screen.width + 'x' + $window.screen.height);
                        $window.newrelic.setCustomAttribute('screen_color_depth', $window.screen.colorDepth);
                    }
                    
                    // 3. Viewport (tamaño de ventana)
                    $window.newrelic.setCustomAttribute('viewport_width', $window.innerWidth);
                    $window.newrelic.setCustomAttribute('viewport_height', $window.innerHeight);
                    
                    // 4. Memoria del dispositivo (GB)
                    if (navigator.deviceMemory) {
                        $window.newrelic.setCustomAttribute('device_memory_gb', navigator.deviceMemory);
                    }
                    
                    // 5. Número de núcleos del procesador
                    if (navigator.hardwareConcurrency) {
                        $window.newrelic.setCustomAttribute('cpu_cores', navigator.hardwareConcurrency);
                    }
                    
                    // 6. Tipo de conexión (Wi-Fi, 4G, etc.)
                    if (navigator.connection || navigator.mozConnection || navigator.webkitConnection) {
                        var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
                        if (connection.effectiveType) {
                            $window.newrelic.setCustomAttribute('connection_type', connection.effectiveType);
                        }
                        if (connection.downlink) {
                            $window.newrelic.setCustomAttribute('connection_downlink_mbps', connection.downlink);
                        }
                        if (connection.rtt) {
                            $window.newrelic.setCustomAttribute('connection_rtt_ms', connection.rtt);
                        }
                    }
                    
                    // 7. Idioma del navegador
                    $window.newrelic.setCustomAttribute('browser_language', navigator.language || navigator.userLanguage);
                    
                    // 8. Zona horaria
                    try {
                        var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                        $window.newrelic.setCustomAttribute('timezone', timezone);
                    } catch (e) {
                        $window.newrelic.setCustomAttribute('timezone_offset', new Date().getTimezoneOffset());
                    }
                    
                    // 9. Platform (Windows, Mac, Linux, etc.)
                    $window.newrelic.setCustomAttribute('platform', navigator.platform);
                    
                    // 10. Vendor del navegador
                    if (navigator.vendor) {
                        $window.newrelic.setCustomAttribute('browser_vendor', navigator.vendor);
                    }
                    
                    // 11. Detectar si es tablet
                    var isTablet = /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(navigator.userAgent);
                    $window.newrelic.setCustomAttribute('is_tablet', isTablet);
                    
                    // 12. Número de plugins/extensiones (puede indicar conflictos)
                    if (navigator.plugins && navigator.plugins.length !== undefined) {
                        $window.newrelic.setCustomAttribute('plugins_count', navigator.plugins.length);
                    }
                    
                    // 13. ¿Está en modo oscuro?
                    if ($window.matchMedia) {
                        var darkMode = $window.matchMedia('(prefers-color-scheme: dark)').matches;
                        $window.newrelic.setCustomAttribute('dark_mode', darkMode);
                    }
                    
                    // 14. Nivel de batería (si está disponible, útil para laptops/móviles)
                    if (navigator.getBattery) {
                        navigator.getBattery().then(function(battery) {
                            $window.newrelic.setCustomAttribute('battery_level', Math.round(battery.level * 100));
                            $window.newrelic.setCustomAttribute('battery_charging', battery.charging);
                        }).catch(function() {
                            // Silenciar error si no está disponible
                        });
                    }
                    
                    $log.info('[New Relic] Información del dispositivo configurada:', {
                        deviceId: deviceId,
                        screen: $window.screen.width + 'x' + $window.screen.height,
                        cores: navigator.hardwareConcurrency,
                        memory: navigator.deviceMemory
                    });
                } catch (error) {
                    $log.error('[New Relic] Error al capturar información del dispositivo:', error);
                }
            },
            
            /**
             * Configura el tracking completo del usuario en New Relic
             * @param {Object} authParams - Objeto con la información del usuario autenticado
             */
            trackUser: function(authParams) {
                if (!$window.newrelic) {
                    $log.warn('[New Relic] New Relic no está disponible');
                    return;
                }

                if (!authParams) {
                    $log.warn('[New Relic] authParams no está definido');
                    return;
                }

                try {
                    var accesoSistema = authParams.accesoSistema;
                    var locacionSeleccionada = authParams.locacionSeleccionada;
                    var username = authParams.username;

                    $log.debug('[New Relic] Datos recibidos:', {
                        username: username,
                        tieneAccesoSistema: !!accesoSistema,
                        tieneLocacion: !!locacionSeleccionada
                    });

                    // 1. Setear User ID
                    if (username) {
                        $window.newrelic.setUserId(username);
                        $log.info('[New Relic] User ID configurado:', username);
                    }

                    // 2. Setear Atributos Personalizados del Usuario
                    if (accesoSistema) {
                        // Nombre completo
                        var nombreCompleto = '';
                        if (accesoSistema.nombres) {
                            nombreCompleto = accesoSistema.nombres;
                        }
                        if (accesoSistema.apellidos) {
                            nombreCompleto += (nombreCompleto ? ' ' : '') + accesoSistema.apellidos;
                        }
                        if (nombreCompleto) {
                            $window.newrelic.setCustomAttribute('usuario_nombre', nombreCompleto);
                            $log.debug('[New Relic] Nombre configurado:', nombreCompleto);
                        }

                        // ID del acceso al sistema
                        if (accesoSistema.id) {
                            $window.newrelic.setCustomAttribute('acceso_sistema_id', accesoSistema.id);
                        }

                        // Rol/Perfil (si está disponible en accesos)
                        if (accesoSistema.accesos && accesoSistema.accesos.length > 0) {
                            var primerAcceso = accesoSistema.accesos[0];
                            // Intentar obtener el rol de diferentes ubicaciones posibles
                            var rolNombre = 'Sin Rol';
                            if (primerAcceso.perfil && primerAcceso.perfil.nombre) {
                                rolNombre = primerAcceso.perfil.nombre;
                            } else if (primerAcceso.rol && primerAcceso.rol.nombre) {
                                rolNombre = primerAcceso.rol.nombre;
                            }
                            $window.newrelic.setCustomAttribute('usuario_rol', rolNombre);
                            $log.debug('[New Relic] Rol configurado:', rolNombre);
                        }
                    }

                    // 3. Setear Atributos de Locación/Sucursal
                    if (locacionSeleccionada) {
                        // Sucursal
                        if (locacionSeleccionada.sucursal) {
                            if (locacionSeleccionada.sucursal.id !== null && locacionSeleccionada.sucursal.id !== undefined) {
                                $window.newrelic.setCustomAttribute('sucursal_id', String(locacionSeleccionada.sucursal.id));
                            }
                            if (locacionSeleccionada.sucursal.nombre) {
                                $window.newrelic.setCustomAttribute('sucursal_nombre', locacionSeleccionada.sucursal.nombre);
                                $log.debug('[New Relic] Sucursal configurada:', locacionSeleccionada.sucursal.nombre);
                            }
                        }

                        // Unidad de Negocio
                        if (locacionSeleccionada.unidadNegocio) {
                            if (locacionSeleccionada.unidadNegocio.id !== null && locacionSeleccionada.unidadNegocio.id !== undefined) {
                                $window.newrelic.setCustomAttribute('unidad_negocio_id', String(locacionSeleccionada.unidadNegocio.id));
                            }
                            if (locacionSeleccionada.unidadNegocio.nombre) {
                                $window.newrelic.setCustomAttribute('unidad_negocio_nombre', locacionSeleccionada.unidadNegocio.nombre);
                                $log.debug('[New Relic] Unidad de Negocio configurada:', locacionSeleccionada.unidadNegocio.nombre);
                            }
                        }

                        // Locación ID
                        if (locacionSeleccionada.id !== null && locacionSeleccionada.id !== undefined) {
                            $window.newrelic.setCustomAttribute('locacion_id', String(locacionSeleccionada.id));
                        }
                    }

                    // 4. Capturar información del dispositivo (Device ID, pantalla, CPU, etc.)
                    service.trackDeviceInfo();
                    
                    // 5. Obtener IP del cliente (usando un servicio externo o del backend)
                    service.trackClientIP();

                    $log.info('[New Relic] Tracking de usuario y dispositivo configurado exitosamente');
                } catch (error) {
                    $log.error('[New Relic] Error al configurar tracking:', error);
                }
            },

            /**
             * Obtiene y registra la IP del cliente
             */
            trackClientIP: function() {
                if (!$window.newrelic) {
                    return;
                }

                try {
                    // Opción 1: Intentar obtener la IP del backend (si existe un endpoint)
                    // $http.get('/api/client-ip').then(function(response) {
                    //     if (response.data && response.data.ip) {
                    //         $window.newrelic.setCustomAttribute('client_ip', response.data.ip);
                    //     }
                    // }).catch(function(error) {
                    //     $log.warn('[New Relic] No se pudo obtener IP del backend:', error);
                    // });

                    // Opción 2: Usar un servicio externo (más simple pero requiere conexión externa)
                    // Solo en caso de que no tengas un endpoint backend
                    $http.jsonp('https://api.ipify.org?format=jsonp&callback=JSON_CALLBACK', {
                        timeout: 3000 // Timeout de 3 segundos
                    }).then(function(response) {
                        if (response.data && response.data.ip) {
                            $window.newrelic.setCustomAttribute('client_ip', response.data.ip);
                            $log.info('[New Relic] IP del cliente configurada:', response.data.ip);
                        }
                    }).catch(function(error) {
                        // Silenciar error, no es crítico
                        $log.debug('[New Relic] No se pudo obtener IP del cliente (no crítico):', error);
                    });
                } catch (error) {
                    $log.debug('[New Relic] Error al obtener IP (no crítico):', error);
                }
            },

            /**
             * Actualiza los atributos cuando cambia la locación/sucursal
             * @param {Object} nuevaLocacion - Nueva locación seleccionada
             */
            updateLocacion: function(nuevaLocacion) {
                if (!$window.newrelic || !nuevaLocacion) {
                    return;
                }

                try {
                    if (nuevaLocacion.sucursal) {
                        $window.newrelic.setCustomAttribute('sucursal_id', nuevaLocacion.sucursal.id);
                        $window.newrelic.setCustomAttribute('sucursal_nombre', nuevaLocacion.sucursal.nombre);
                    }

                    if (nuevaLocacion.unidadNegocio) {
                        $window.newrelic.setCustomAttribute('unidad_negocio_id', nuevaLocacion.unidadNegocio.id);
                        $window.newrelic.setCustomAttribute('unidad_negocio_nombre', nuevaLocacion.unidadNegocio.nombre);
                    }

                    if (nuevaLocacion.id) {
                        $window.newrelic.setCustomAttribute('locacion_id', nuevaLocacion.id);
                    }

                    $log.info('[New Relic] Locación actualizada');
                } catch (error) {
                    $log.error('[New Relic] Error al actualizar locación:', error);
                }
            },

            /**
             * Limpia todos los atributos personalizados (útil para logout)
             * NOTA: NO limpia el Device ID ya que es único por equipo, no por usuario
             */
            clearTracking: function() {
                if (!$window.newrelic) {
                    return;
                }

                try {
                    // Limpiar atributos de usuario (NO device_id ni características del equipo)
                    $window.newrelic.setUserId(null);
                    $window.newrelic.setCustomAttribute('usuario_nombre', null);
                    $window.newrelic.setCustomAttribute('usuario_rol', null);
                    $window.newrelic.setCustomAttribute('sucursal_id', null);
                    $window.newrelic.setCustomAttribute('sucursal_nombre', null);
                    $window.newrelic.setCustomAttribute('unidad_negocio_id', null);
                    $window.newrelic.setCustomAttribute('unidad_negocio_nombre', null);
                    $window.newrelic.setCustomAttribute('locacion_id', null);
                    $window.newrelic.setCustomAttribute('acceso_sistema_id', null);
                    $window.newrelic.setCustomAttribute('client_ip', null);

                    $log.info('[New Relic] Tracking de usuario limpiado (Device ID preservado)');
                } catch (error) {
                    $log.error('[New Relic] Error al limpiar tracking:', error);
                }
            }
        };

        return service;
    }]);


angular
  .module('qualita')
  .directive('locacionPicker', locacionPicker);

function locacionPicker() {
  var directive = {
    restrict: 'E',
    scope: {
      modelo: '=',
      isDefault: '=',
      defaultModelo: '=',
      notDefaultable: '=',
      isView: '='
    },
    controllerAs: 'vm',
    bindToController: true,
    templateUrl: 'views/directives/locacionpicker.html',
    link: linkFunc,
    controller: LocacionPickerController,
  };

  function linkFunc(scope, elem, attr) {
    scope.vm.loadAsync = angular.isDefined(scope.vm.loadAsync) ? scope.vm.loadAsync : false;
  }

  return directive;
}

LocacionPickerController.$inject =  ['SucursalesFactory', 'LocacionesFactory', 'UnidadesNegocioFactory', '$log','$scope', 'AuthorizationLangFactory'];
function LocacionPickerController(SucursalesFactory, LocacionesFactory, UnidadesNegocioFactory, $log, $scope, AuthorizationLangFactory) {
  var vm = this;

  vm.getLocaciones = getLocaciones;
  vm.sucursalForId = getSucursalForId;
  vm.allToggled = allToggled;

  activate();

  function activate() {
    AuthorizationLangFactory.getTranslations().then(function(translations){
      vm.translations=translations;
      $log.debug("LocacionPickerController $activate");
      init();
      $scope.$watchCollection('vm.modelo', function() {
        if(!vm.isDefault) return;
        if(!vm.modelo) return;

        vm.allChecked = vm.locaciones && vm.modelo.length == vm.locaciones.length && vm.modelo[0].unidadNegocio.id == vm.locaciones[0].unidadNegocio.id;
        if(vm.modelo.length !== 1) return;
        $log.info("$watch -> vm.modelo");
        vm.defaultModelo = vm.modelo[0];
      });

      $scope.$watch('vm.isDefault', function() {
        if(!vm.isDefault) return;
        if(vm.defaultModelo != undefined){
        if(_.find(vm.modelo, {"id": vm.defaultModelo.id})) return;
        }
        $log.debug("$watch -> vm.isDefault");
        vm.defaultModelo = vm.modelo[0];
      });

      return getUnidadesNegocio();

      function init() {
        if(!vm.modelo || vm.modelo.length === 0) return;
        vm.unidadNegocio = vm.modelo[0].unidadNegocio;
        var modelo = vm.modelo; //temporalmente guardamos el modelo
        getLocaciones(vm.unidadNegocio, vm.unidadNegocio);
        vm.modelo = modelo;
        }
    });
  }

  function getLocaciones($item, $model) {
    //vm.modelo = [];

    return LocacionesFactory.getByUnidadNegocio($model.id).$promise.then(function(response) {
      vm.locaciones = response;
      vm.allChecked = vm.locaciones && vm.modelo.length == vm.locaciones.length && vm.modelo[0].unidadNegocio.id == vm.locaciones[0].unidadNegocio.id;
      /* Transformación de datos necesaria para realizar validaciones en el HTM, bloque de codigo agregado a causa de la
      migración al core 4.0.0*/
      if (vm.modelo.length > 0){
        for(var i=0; i<vm.locaciones.length; i++){
          for (var j=0; j<vm.modelo.length; j++){
             if (vm.locaciones[i].unidadNegocio.id === vm.modelo[j].unidadNegocio.id && (vm.locaciones[i].sucursal.id === vm.modelo[j].sucursal || vm.locaciones[i].sucursal.id === vm.modelo[j].sucursal.id)){
                vm.locaciones[i].check = true;
                break;
             }else{
                vm.locaciones[i].check = false;
             }
          }
        }
      }
      

      vm.locaciones.map(function(value){
          UnidadesNegocioFactory.get(value.unidadNegocio.id).$promise.then(function(response) {
            value.sucursal = value.sucursal.id;
            value.unidadNegocio = response
            value.unidadNegocio.locacion = response.locaciones.map(function(value){return value.id});
        })
      })

      return vm.locaciones;
    }).then(function(locaciones) {
      if(!vm.sucursales) {
        return getSucursales();
      }
    })
  }

  function getUnidadesNegocio() {
    return UnidadesNegocioFactory.all(null,'BaseList').$promise.then(function(response) {
      vm.unidadesNegocio = response;
      return vm.unidadesNegocio;
    });
  }

  function getSucursales() {
    return SucursalesFactory.all(null,'BaseList').$promise.then(function(response) {
      vm.sucursales = response;
      return vm.sucursales;
    })
  }

  function getSucursalForId(unId) {
    return _.find(vm.sucursales, {'id': unId});
  }

  function allToggled() {
    for(var i=0; i<vm.locaciones.length; i++){
      vm.locaciones[i].check = vm.allChecked;
    }
    vm.modelo = vm.allChecked ? _.cloneDeep(vm.locaciones) : [];
    
  }

  $scope.$watch('vm.locaciones', function (newValue) {
    checklistModel(newValue)
  }, true)
  
  function checklistModel(locaciones) {
    if (locaciones) {
      vm.modelo = [];
      for (var i = 0; i < locaciones.length; i++) {
        if (locaciones[i].check) {
          vm.modelo.push(locaciones[i])
        }
      }
    }
  }
}

angular
  .module('qualita')
  .directive('locacionesPicker', locacionesPicker);

function locacionesPicker() {
  var directive = {
    restrict: 'E',
    scope: {
      modelo: '=',
      notDefaultable: '=',
      notAddSucursal: '=',
      isVendedor: '=',
      loadAsync: '=?',
      asyncFlag: '=',
      isView: '='
    },
    controllerAs: 'vm',
    bindToController: true,
    templateUrl: 'views/directives/locacionespicker.html',
    link: linkFunc,
    controller: LocacionesPickerController,
  };

  function linkFunc(scope, elem, attr) {
    scope.vm.loadAsync = angular.isDefined(scope.vm.loadAsync) ? scope.vm.loadAsync : false;
  }

  return directive;
}

LocacionesPickerController.$inject =  ['$log', '$scope', 'LocacionesFactory', 'AuthorizationLangFactory','UnidadesNegocioFactory'];
function LocacionesPickerController($log, $scope, LocacionesFactory, AuthorizationLangFactory, UnidadesNegocioFactory) {
  var vm = this;

  vm.addPicker = addPicker;

  vm.canAdd = false;

  vm.defaultPicker = 0; //indice del picker por defecto del arreglo vm.pickers

  vm.initialized = false;

  activate();

  function activate() {
    AuthorizationLangFactory.getTranslations().then(function(translations){
      vm.translations=translations;
      if(vm.loadAsync) {
        $scope.$watch('vm.asyncFlag', function(newValue, oldValue) {
          if(!vm.asyncFlag) {
            return;
          } else {
            console.log("groupPickers invocado desde watcher de asyncFlag");
            groupPickers();
          }
        });
      } else {
        console.log("sin asyncFlag");
        groupPickers();
      }

      $scope.$watch('vm.pickers', function() {
        if(!vm.pickers) return;
        var newModel = _.map(_.flatten(vm.pickers), function(loc) {
          if (vm.isVendedor){
            return {
              locacion: loc
            }
          }else{
            return {
              accesoPorDefecto: vm.defaultLocacion && loc.id === vm.defaultLocacion.id,
              locacion: loc
            }
          }
          
        });
        if(vm.modelo) {
          //$log.debug("newModel: ");
          //$log.debug(newModel);
          //$log.debug("modelo: ");
          //$log.debug(vm.modelo);
          _.forEach(newModel, function (acceso) {
            var accPresente = _.find(vm.modelo, function (acc) {
              return acc.locacion.id === acceso.locacion.id
            });
            if (!accPresente) {
              vm.modelo.push(acceso);
            }
          });

          //sacamos los elementos que quedaron fuera del arreglo original
          _.remove(vm.modelo, function(acceso) {
            var accPresente = _.find(newModel, function(acc) {
              return acc.locacion.id === acceso.locacion.id;
            });
            return !accPresente;
          })
        } else {
          vm.modelo = newModel;
        }

        checkUnassignedPickers();

        function checkUnassignedPickers() {
          var nullValueFlag = false;
          _.forEach(vm.pickers, function(picker) {
            if(picker.length < 1) {
              nullValueFlag = true;
            }
          });
          vm.canAdd = !nullValueFlag;
        }
      }, true);


      $scope.$watch('vm.defaultLocacion', function(newValue, oldValue) {
        if(vm.isVendedor || !vm.defaultLocacion || vm.defaultLocacion === {}) return;
        if(oldValue) {
          var viejoRegistro = _.find(vm.modelo, function (acceso) {
            return acceso.locacion.id === oldValue.id;
          });
          if(viejoRegistro) viejoRegistro.accesoPorDefecto = false;
        }
        _.find(vm.modelo, function(acceso) {
          return acceso.locacion.id === vm.defaultLocacion.id;
        }).accesoPorDefecto = true;
      });

      function groupPickers() {
        if(!vm.modelo || vm.modelo.length === 0) {
          console.log("No hay modelo. Se inicializa con un hijo.");
          vm.pickers = [[]]; //inicializamos con 1 hijo
          return;
        }

        vm.modelo.map(function(value){
          /* Transformación de datos necesaria para realizar validaciones en el HTM, bloque de codigo agregado a causa de la
             migración al core 4.0.0*/
          UnidadesNegocioFactory.get(value.locacion.unidadNegocio.id).$promise.then(function(response) {
            value.locacion.sucursal = value.locacion.sucursal.id;
            value.locacion.unidadNegocio = response
            value.locacion.unidadNegocio.locacion = response.locaciones.map(function(value){return value.id});
        })
      })

      var grupos = _.groupBy(vm.modelo, function(acceso) {
        if(acceso.locacion) {
          return acceso.locacion.unidadNegocio.id;
        }
        else {
          return acceso.unidadNegocio; //hack para el caso de que tratemos directamente con las locaciones
        }
     });

      var pickers = [];
      _.forOwn(grupos, function(value, key) {
        var picker = [];
        _.forEach(grupos[key], function(acceso) {
          if(acceso.accesoPorDefecto) {
            vm.defaultPicker = pickers.length;
            vm.defaultLocacion = acceso.locacion;
          }
            picker.push(acceso.locacion);

        });
        pickers.push(picker);
      });
      vm.pickers = pickers;
      console.log("Pickers finales: ");
      console.log(vm.pickers);

      }
    });
  }

  function addPicker() {
    if(vm.pickers) {
      vm.pickers.push([]);
      vm.canAdd = false;
    }
  }
}

angular
    .module('qualita')
    .directive('advancedDatatablesSearch', advancedDatatablesSearch);

function advancedDatatablesSearch() {
    var directive = {
        restrict: 'E',
        controllerAs: 'vm',
        scope: {
            model: '=',
            options: '=',
            factory: '=',
            disabledBtn: '=',
            multipleSelection: '=?',
            size: '@',
            serializationView: '@',
            style: '@',
            onSelect: '&',
            editFilters: '=?',
            icon: '@',
            title: '@'
        },
        bindToController: true,
        templateUrl: 'views/directives/advanced-datatables-search.html',
        link: linkFunc,
        controller: AdvancedDatatablesSearchController,
    };

    function linkFunc(scope, elem, attr) {
        scope.vm.multipleSelection = angular.isDefined(scope.vm.multipleSelection) ? scope.vm.multipleSelection : false;
        scope.vm.editFilters = angular.isDefined(scope.vm.editFilters) ? scope.vm.editFilters : false;
    }

    return directive;
}

AdvancedDatatablesSearchController.$inject = ['$log', '$scope', '$modal', '$state', '$timeout', '$rootScope', '$filter'];

function AdvancedDatatablesSearchController($log, $scope, $modal, $state, $timeout, $rootScope, $filter) {
    var childScope = $rootScope.$new();
    var eventoSearch = new Event('search');

    var vm = this;
    var isolatedVM = {};
    childScope.vm = isolatedVM;

    $scope.$watch("vm.options", function(newData) {
        if (!newData) {
            return;
        }
        isolatedVM.options = Object.assign({}, isolatedVM.options, _.cloneDeep(newData));
    }, true);
    isolatedVM.options = _.cloneDeep(vm.options);
    isolatedVM.multipleSelection = _.cloneDeep(vm.multipleSelection);
    isolatedVM.editFilters = _.cloneDeep(vm.editFilters);
    isolatedVM.factory = vm.factory;
    if (!vm.size) { vm.size = "btn-xs"; }
    vm.pick = pick;
    $rootScope.pick = pick;
    vm.showSearch = showSearch;
    vm.close = close;
    isolatedVM.close = close;
    isolatedVM.addAll = addAll;
    isolatedVM.searchAll = searchAll;
    if (!vm.multipleSelection) {

        isolatedVM.options.extraRowOptions = [{
            templateToRender: "<button class='btn btn-primary' title='" + $filter('translate')('PICK') + "' style='margin-right: 5px;' ng-click='pick(<%=dataId%>)'> <span class='glyphicon glyphicon-ok'></span> </button>",
            functionName: "pick",
            functionDef: function(itemId) {
                vm.pick(itemId);
            }
        }];
    } else {
        if (vm.multipleSelection) {
            isolatedVM.options.isSelectable = true;
            isolatedVM.options.selection = {};
            isolatedVM.options.extraMenuOptions = [{
                'title': "GSDG",
                'icon': 'glyphicon glyphicon-plus',
                'showCondition': function() {
                    return true;
                },
                'action': function() {
                    if (vm.isProcesoImportacion)
                        $state.go("app.importaciones.proceso.ordenescompra.new");
                    else
                        $state.go("app.orden_compra_importacion.new");
                }
            }];
        }
    }
    isolatedVM.options.hideAddMenu = true;
    isolatedVM.options.hideEditMenu = true;
    isolatedVM.options.hideRemoveMenu = true;
    isolatedVM.options.hideHeader = true;

    var createFilters = function(filters) {
        var filtersArr = [];
        _.each(filters, function(search, data) {
            filtersArr.push({ path: data, like: search })
        });
        var filters = filterFactory.and(filtersArr).value();
        return filters;
    }

    activate();

    function activate() {
        vm.modalInstance = undefined;
    }

    function pick(item) {
        $rootScope.isPopup = true;
        vm.model = vm.factory.get(item, vm.serializationView !== undefined ? vm.serializationView : "BaseList");
        if (vm.modalInstance) {
            vm.modalInstance.close();
        }
        vm.model.$promise.then(function(response) {
            $rootScope.isPopup = false;
            $timeout(vm.onSelect, 0);
        });

    }

    function showSearch() {
        vm.modalInstance = $modal.open({
            templateUrl: 'views/directives/datatables-modal.html',
            scope: childScope,
            size: 'lg'
        });
        if(vm.editFilters){
          editFilters();
        }
    }

    function editFilters() {
      vm.modalInstance.rendered.then(function () {
        setTimeout(function (){
          var searchFilter = document
            .querySelector('[id^="DataTables_Table_"][id$="filter"]').querySelector('input');
          $(searchFilter).off("keyup");
          $(searchFilter).off("keypress");
          $(searchFilter).off("input");
          $(searchFilter).off("cut");
          $(searchFilter).off("paste");
          $(searchFilter).off("mouseup");
          $(searchFilter).on('blur', function() {
            // Despacha el evento 'search' en el elemento de entrada
            $(searchFilter)[0].dispatchEvent(eventoSearch);
          });
          function handleColumnAdded() {
            _.forEach($("[id^='filtro']"), function(el) {
              $(el).off("keyup")
            });
          }
          var targetNode = document
            .querySelector('[id^="DataTables_Table_"]')
            .querySelector('table');
          // Configura el observador con una función de devolución de llamada
          var observer = new MutationObserver(function(mutationsList) {
            mutationsList.forEach(function(mutation) {
              if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                // Se agregó un nodo hijo (puede ser una columna)
                handleColumnAdded();
              }
            });
          });
          // Configura las opciones del observador
          var config = { childList: true, subtree: true };
          // Inicia la observación del nodo de destino con las opciones configuradas
          observer.observe(targetNode, config);
        })
      })
    }

    function addAll() {
        $("#addAll").off('click');
        //convertimos los datos a un array de indicesSelected
        var indicesSelected = _.filter(_.map(isolatedVM.options.selection, function(val, idx) {
                return val == true ? parseInt(idx) : false;
            }),
            function(val) { return val; });
        vm.model = _.map(indicesSelected, function(idx) { return isolatedVM.factory.get(idx, vm.serializationView); });
        if (vm.modalInstance) {
            vm.modalInstance.close();
        }
    }

    function searchAll() {
      var searchFilter = document
        .querySelector('[id^="DataTables_Table_"][id$="filter"]').querySelector('input');
      ;
      // Despacha el evento 'search' en el elemento de entrada
      $(searchFilter)[0].dispatchEvent(eventoSearch);
    }

    function close() {
        if (vm.modalInstance) {
            vm.modalInstance.close();
        }
    }
}

/*angular
  .module('qualita').directive('focusOn', function() {
   return function(scope, elem, attr) {
      scope.$on('focusOn', function(e, name) {
        if(name === attr.focusOn) {
          elem[0].focus();
        }
      });
   };
});*/

angular
  .module('qualita').directive('focusOn', ["$timeout", function($timeout) {
   return function(scope, elem, attrs) {
     scope.$on(attrs.focusOn, function(e) {
       $timeout((function() {
         elem[0].focus();
       }), 10);
     });

   };
}]);

'use strict';

angular.module('qualita')
.value('$datepickerSuppressError', true)
.directive('pickDate', ["$filter", function ($filter) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attrs, ngModel) {
      moment.locale('es');
      if (scope.model[scope.form.key[0]]) {
        scope.model[scope.form.key[0]] = new Date(scope.model[scope.form.key[0]]);
      }
      
      scope.status = {
        opened: false
      };
      
      scope.open = function () {
        scope.status.opened = true;
      };
      var defaultFormat = 'dd/MM/yyyy';

      ngModel.$parsers.push(function () {
        console.log(scope.schema.formatDate);
        return $filter('date')(element.val(), scope.form.schema.formatDate || defaultFormat);
      });
    }
  };
}]);

/**
 * Anularjs Module for pop up timepicker
 */
angular.module('qualita')
.factory('timepickerState', function() {
  var pickers = [];
  return {
		addPicker: function(picker) {
			pickers.push(picker);
		},
		closeAll: function() {
			for (var i=0; i<pickers.length; i++) {
				pickers[i].close();
			}
		}
	};
})
.directive("timeFormat", ["$filter", function($filter) {
  return {
    restrict : 'A',
    require : 'ngModel',
    scope : {
      showMeridian : '=',
    },
    link : function(scope, element, attrs, ngModel) {
        var parseTime = function(viewValue) {

        if (!viewValue) {
          ngModel.$setValidity('time', true);
          return null;
        } else if (angular.isDate(viewValue) && !isNaN(viewValue)) {
          ngModel.$setValidity('time', true);
          return viewValue;
        } else if (angular.isString(viewValue)) {
          var timeRegex = /^(0?[0-9]|1[0-2]):[0-5][0-9] ?[a|p]m$/i;
          if (!scope.showMeridian) {
            timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
          }
          if (!timeRegex.test(viewValue)) {
            ngModel.$setValidity('time', false);
            return undefined;
          } else {
            ngModel.$setValidity('time', true);
            var date = new Date();
            var sp = viewValue.split(":");
            var apm = sp[1].match(/[a|p]m/i);
            if (apm) {
              sp[1] = sp[1].replace(/[a|p]m/i, '');
              if (apm[0].toLowerCase() == 'pm') {
                sp[0] = sp[0] + 12;
              }
            }
            date.setHours(sp[0], sp[1]);
            return date;
          };
        } else {
          ngModel.$setValidity('time', false);
          return undefined;
        };
      };

      ngModel.$parsers.push(parseTime);

      var showTime = function(data) {
        parseTime(data);
        var timeFormat = (!scope.showMeridian) ? "HH:mm" : "hh:mm a";
        return $filter('date')(data, timeFormat);
      };
      ngModel.$formatters.push(showTime);
      scope.$watch('showMeridian', function(value) {
        var myTime = ngModel.$modelValue;
        if (myTime) {
          element.val(showTime(myTime));
        }

      });
    }
  };
}])

.directive('timepickerPop', ["$document", "timepickerState", function($document, timepickerState) {
      return {
        restrict : 'E',
        transclude : false,
        scope : {
          inputTime : "=",
          showMeridian : "=",
          disabled : "="
        },
        controller : ["$scope", "$element", function($scope, $element) {
          console.log('en la directiva timepicker');
          $scope.isOpen = false;
          
          $scope.disabledInt = angular.isUndefined($scope.disabled)? false : $scope.disabled;

          $scope.toggle = function() {
        	if ($scope.isOpen) {
        		$scope.close();
        	} else {
        		$scope.open();
        	}
          };
        }],
        link : function(scope, element, attrs) {
          console.log('link de la directiva timepicker');
          var picker = {
        		  open : function () {
        			  timepickerState.closeAll();
        			  scope.isOpen = true;
        		  },
        		  close: function () {
        			  scope.isOpen = false;
        		  }
          		  
          }
          timepickerState.addPicker(picker);
          
          scope.open = picker.open;
          scope.close = picker.close;
          
          scope.$watch("disabled", function(value) {
            scope.disabledInt = angular.isUndefined(scope.disabled)? false : scope.disabled;
          });
          
          scope.$watch("inputTime", function(value) {
            if (!scope.inputTime) {
              element.addClass('has-error');
            } else {
              element.removeClass('has-error');
            }

          });

          element.bind('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
          });

          $document.bind('click', function(event) {
            scope.$apply(function() {
           		scope.isOpen = false;
            });
          });

        },
        template : "<input type='text' class='form-control' ng-model='inputTime' ng-disabled='disabledInt' time-format show-meridian='showMeridian' ng-focus='open()' />"
            + "  <div class='input-group-btn' ng-class='{open:isOpen}'> "
            + "    <button type='button' ng-disabled='disabledInt' class='btn btn-default form-control' ng-class=\"{'btn-primary':isOpen}\" data-toggle='dropdown' ng-click='toggle()'> "
            + "        <i class='glyphicon glyphicon-time'></i></button> "
            + "          <div class='dropdown-menu pull-right'> "
            + "            <timepicker ng-model='inputTime' show-meridian='showMeridian' style='margin-left: 15%;'></timepicker> "
            + "           </div> " + "  </div>"
      };
}]);
'use strict';

angular
  .module('qualita').directive('resize', ["$window", function($window){
  return{
    link: function(scope, element, attrs){
        var w = angular.element($window);
        scope.getWindowDimensions = function () {
            return { 'h': w.height(), 'w': w.width() };
        };
        scope.$watch(scope.getWindowDimensions, function (newValue, oldValue) {
            scope.windowHeight = newValue.h;
            scope.windowWidth = newValue.w;

            scope.style = function () {
                return {
                    'height': (newValue.h) + 'px',
                    'width': (newValue.w) + 'px'
                };
            };
            scope.getHeight = function (padding) {
                return {
                    'height': (newValue.h + padding) + 'px'
                };
            };
            scope.getWidth= function (padding) {
                return {
                    'width': (newValue.w + padding) + 'px'
                };
            };
        }, true);

        w.bind('resize', function () {
            scope.$apply();
        });
    }
  }
}])

angular
  .module('qualita')
  .directive('tdnWizard', tdnWizard);

function tdnWizard() {
  var directive = {
    restrict: 'E',
    scope: {},
    controllerAs: 'vm',
    bindToController: true,
    templateUrl: 'views/directives/tdnwizard.html',
    controller: tdnWizardController,
    transclude: true
  };

  return directive;
}

tdnWizardController.$inject =  ['$scope', '$timeout'];
function tdnWizardController($scope, $timeout) {
  var vm = this;
  vm.tabs = [];

  activate();
  vm.addTab = addTab;

  function activate() {
  }

  function addTab() {
    // TODO Agregar TAB
  }

};

angular
  .module('qualita')
  .directive('tdnWizardPane', tdnWizardPane);

//tdnWizardPane.$inject = ["$state"];

function tdnWizardPane($state) {
  var directive = {
    required: '^^tdnWizard',
    restrict: 'E',
    scope: {
      title: '@',
      number: '@',
      disabledIf: '=',
      state: '@',
      parentState: '@' //Por un bug, parentState debe ser necesariamente el nombre completo
    },

    templateUrl: 'views/directives/tdnwizardpane.html',
    controller: controllerFunc,
    controllerAs: 'vm',
    bindToController: true
  };

  return directive;
}
tdnWizardPane.$inject = ["$state"];

controllerFunc.$inject =  ["$state"];

function controllerFunc($state) {
  var vm = this;
  vm.isActive = isActive;

  function isActive(estado) {
    return $state.includes(estado);
  }



};

angular
  .module('qualita')
  .directive('tdnWizardContent', tdnWizardContent);

function tdnWizardContent() {
  var directive = {
    restrict: 'E',
    transclude: true,
    scope: {},
    templateUrl: 'views/directives/tdnwizardcontent.html',
    link: linkFunc,
  };

  return directive;
}

function linkFunc(scope, element, attrs) {

  activate();

  function activate() {
  }
};

angular.module('qualita').directive('contenteditable', ['$sce', function($sce) {
  return {
  restrict: 'A', // only activate on element attribute
  require: '?ngModel', // get a hold of NgModelController
  link: function(scope, element, attrs, ngModel) {
      if (!ngModel) return; // do nothing if no ng-model

    // Specify how UI should be updated
      ngModel.$render = function() {
        element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
        read(); // initialize
      };

      // Listen for change events to enable binding
      element.on('blur keyup change', function() {
        scope.$evalAsync(read);
      });

      // Write data to the model
      function read() {
        var html = element.html();
        // When we clear the content editable the browser leaves a <br> behind
        // If strip-br attribute is provided then we strip this out
        if ( attrs.stripBr && html == '<br>' ) {
          html = '';
        }
        ngModel.$setViewValue(html);
      }
    }
  };
}]);

 angular.module('qualita')

 .directive('uiBlockui', ["$compile", function($compile) {
     return {

         restrict: 'AE',

         link: function($scope, el, attr, ctrl) {

             var renderManager = function(scope, iElement, iAttrs, controller) {

               console.log("Scope", scope);

              var mensaje = "Por favor espere..."
              if(iAttrs.vm.uiBlockuiConfig.message != undefined){
                mensaje = iAttrs.vm.uiBlockuiConfig.message;
              }
                 if (iAttrs.vm.uiBlockuiConfig && iAttrs.vm.uiBlockuiConfig.bloquear) {
                     $.blockUI({
                         css: {
                             border: 'none',
                             padding: '15px',
                             backgroundColor: '#000',
                             '-webkit-border-radius': '10px',
                             '-moz-border-radius': '10px',
                             opacity: .5,
                             color: '#fff',
                         },
                         baseZ: 10000,
                         message: mensaje,
                     });
                 } else {
                     $.unblockUI();
                 }

             }

             if (angular.isUndefined(attr.class)) {
                 $scope.$watch('vm.uiBlockuiConfig', renderManager, true);
             } else {
                 var mensaje = $scope.$eval(attr.vm.uiBlockuiConfig).message || "Por favor espere...";
                 $scope.$watch(attr.uiBlockuiConfig, function(valor) {
                     if (valor && valor.bloquear) {
                         el.block({
                             css: {
                                 border: 'none',
                                 padding: '15px',
                                 backgroundColor: '#000',
                                 '-webkit-border-radius': '10px',
                                 '-moz-border-radius': '10px',
                                 opacity: .5,
                                 color: '#fff',
                             },
                             baseZ: 999,
                             message: valor.message,
                         });
                     } else {
                         el.unblock();
                     }
                 }, true);
             }
         }
     };
 }]);
